// This file is auto-generated from public/filtered_cafes.json. Do not edit manually.
// Skips permanently-closed cafes and duplicate entries (same id).
const activeCafes = (cafes) => {
  const seen = new Set();
  return cafes.filter(cafe => {
    if (cafe.permanentlyClosed) return false;
    const key = cafe.id || cafe.placeId;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const cleanedCafesData = [
  {
    "id": "ChIJTTM6WIf91y0RotZGcWHII0k",
    "name": "Ropopang Citraland",
    "address": "Telaga Utama Road, Sambikerep, Surabaya, East Java 60213, Indonesia",
    "rating": "4.6",
    "reviewCount": 1214,
    "placeId": "ChIJTTM6WIf91y0RotZGcWHII0k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Ropopang%20Citraland&query_place_id=ChIJTTM6WIf91y0RotZGcWHII0k",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3339-8818",
    "website": "http://www.instagram.com/ropopang.sby",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "4 PM to 2 AM"
        }
      }
    ],
    "neighborhood": "Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipO8gbrDXMOn72WzBrjLUP6XNe30gkQtsbXWCKY1=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        },
        {
          "Wheelchair accessible seating": true
        },
        {
          "Wheelchair accessible restroom": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking garage": true
        },
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "On-site parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.642Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2905258,
      112.6484033
    ],
    "coordinatesSource": "known_accurate",
    "coordinatesAccuracy": "high",
    "coordinates_source": "google_maps_manual",
    "coordinates_updated": "2025-06-07T19:22:54.809756",
    "coordinates_corrected": true,
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJfVbuGoT91y0RNhWAjHd-e0o",
    "name": "Kopi teras",
    "address": "G-Walk, Citra Land, Jl. Niaga Gapura FG2 no. 1B-2, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "3.1",
    "reviewCount": 76,
    "placeId": "ChIJfVbuGoT91y0RNhWAjHd-e0o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20teras&query_place_id=ChIJfVbuGoT91y0RNhWAjHd-e0o",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 896-2003-5430",
    "website": "http://instagram.com/kopiterasid",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "2 to 10 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrzaMFcrJEwDRZwnBsvJ78H4PR3Zg3f7CK7BgNOnSNjLTKNmc_x82XuqJreFijgJIEnuRkt3hFztGpqfcAFG9mbIkZWoZJ2Mxpii0yDD-5bHTKqeMkZFfPnBh35y7NQm3ZaHW8=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.642Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2909843,
      112.6546651
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809767",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJVzXd5Mf91y0Rz7fXcuH6LkE",
    "name": "L Spot Cafe",
    "address": "G Walk, Food Garden 2 No.5, RW.6, Citraland, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.3",
    "reviewCount": 83,
    "placeId": "ChIJVzXd5Mf91y0Rz7fXcuH6LkE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=L%20Spot%20Cafe&query_place_id=ChIJVzXd5Mf91y0Rz7fXcuH6LkE",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "5 PM to 2 AM"
        }
      }
    ],
    "neighborhood": "Citraland, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMhSA9D5irGmS3e-MCyUSub_OOniBw4Ae8D5lpe=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great coffee": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.642Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2908849,
      112.6544651
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809772",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJoQ56zij91y0ROo8atGcCjGA",
    "name": "Rukun Kopi Peranakan",
    "address": "Sebelah Rumble Citraland, Bukit Telaga Golf Road No.10, Jeruk, Kec. Lakarsantri, Surabaya, Jawa Timur 60223, Indonesia",
    "rating": "4.6",
    "reviewCount": 84,
    "placeId": "ChIJoQ56zij91y0ROo8atGcCjGA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rukun%20Kopi%20Peranakan&query_place_id=ChIJoQ56zij91y0ROo8atGcCjGA",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 821-3695-8550",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Closed"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 3 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 3 PM"
        }
      }
    ],
    "neighborhood": "Jeruk, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPZrF6StV59eu-FrlWT6GshanUOmfy1bfU7Tvjv=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.642Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2917703,
      112.6477161
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809777",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJm92QN7j91y0RpkF8Qpbrt1g",
    "name": "Excelso - SUB G-Walk Citraland",
    "address": "Jl. Puri Widya Kencana No.26, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.4",
    "reviewCount": 705,
    "placeId": "ChIJm92QN7j91y0RpkF8Qpbrt1g",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Excelso%20-%20SUB%20G-Walk%20Citraland&query_place_id=ChIJm92QN7j91y0RpkF8Qpbrt1g",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 31 7451234",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npEmkx5F_ePotYjF-_z2WeWj6WOCv0We7TpeedoujKoOB-Ycqf9tklTgls4dpuPXObMq54ID2fHWE9-bzoIwTOUMN4NdSmnP8RRwrKTqGhKO4SE8j3xf9B5z2SZsWGL5j4S-5V2=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2931241,
      112.6541999
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809782",
    "coordinates_source": "google_maps_manual",
    "coordinates_verified": true,
    "coordinates_estimated": true
  },
  {
    "id": "ChIJB4ku0a391y0Ri9md3NHJqEg",
    "name": "M22 CAFE",
    "address": "Jl. Lontar Lidah Kulon No.6, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.5",
    "reviewCount": 347,
    "placeId": "ChIJB4ku0a391y0Ri9md3NHJqEg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=M22%20CAFE&query_place_id=ChIJB4ku0a391y0Ri9md3NHJqEg",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-8075-5389",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOgxSx8jJknbA-p9pn7Yj1IkdqUGEMgC7CL5F6q=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.3033653,
      112.6620914
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809788",
    "coordinates_source": "google_maps_manual",
    "coordinates_verified": true,
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ_aEX1jT91y0RPGn_abdWMGY",
    "name": "Fore Coffee - G Walk Citraland",
    "address": "Jl. Puri Widya Kencana No.22, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.6",
    "reviewCount": 369,
    "placeId": "ChIJ_aEX1jT91y0RPGn_abdWMGY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Fore%20Coffee%20-%20G%20Walk%20Citraland&query_place_id=ChIJ_aEX1jT91y0RPGn_abdWMGY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-1111-8456",
    "website": "http://fore.coffee/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nph_iZwnLH_n9k6b-T33gNAJVYvBvN0fUuAukZg_58LxS1pFc6_Yef12jtuWFWWm8PBZbjG93E7369w4ieOaNDRzRlMO7aOYmLvPTgLAStJlDH9fX7KkAPOWV2BTJh62KXW1jk=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.292444,
      112.6542076
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:17:09.386844",
    "coordinates_source": "google_maps_manual",
    "coordinates_verified": true
  },
  {
    "id": "ChIJGffl1av91y0Rgfa__fSW1Jw",
    "name": "Brew and Else",
    "address": "Jalan Emerald Mansion Citraland TN1 No 9, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.8",
    "reviewCount": 853,
    "placeId": "ChIJGffl1av91y0Rgfa__fSW1Jw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Brew%20and%20Else&query_place_id=ChIJGffl1av91y0Rgfa__fSW1Jw",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 851-8684-3889",
    "website": "http://www.linktr.ee/brewandelse.sby",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNFxKhhA9_0Vu_apdzO3MTTxs6qCDRlmXEyq55d=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2975613,
      112.6586854
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809794",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJqQJdbvX91y0RD1g_F8nPaL0",
    "name": "Kamikamu Eatery & Comfort Food",
    "address": "Telaga Utama Road No.D1/22, Lidah Kulon, Lakarsantri, Surabaya, East Java 60213, Indonesia",
    "rating": "4.4",
    "reviewCount": 907,
    "placeId": "ChIJqQJdbvX91y0RD1g_F8nPaL0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kamikamu%20Eatery%20%26%20Comfort%20Food&query_place_id=ChIJqQJdbvX91y0RD1g_F8nPaL0",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 817-0717-757",
    "website": "https://www.instagram.com/kamikamueatery/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7:30 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNq8PS-EkThK2aT_rAnrTOMX0ywBNGHd5Srx24O=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Halal food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.289432,
      112.647816
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809800",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJH4JYGyf91y0RfrdV0Jbmj2A",
    "name": "Afterwork Caffeine",
    "address": "Jl. Niaga Gapura No.FG-19, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.7",
    "reviewCount": 879,
    "placeId": "ChIJH4JYGyf91y0RfrdV0Jbmj2A",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Afterwork%20Caffeine&query_place_id=ChIJH4JYGyf91y0RfrdV0Jbmj2A",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 852-3604-7158",
    "website": "https://instagram.com/afterworkcaffeine?igshid=m5t1kwzwjwo1",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 2 AM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqy-Delq4WOh6OuoIXYFpSzCcqqMmhs-jdJN-QVDqye_D6KR7uqBqppk1q__YI3BMXwoUX9ICf-LAg6HNrjaTEfWq1V_VQrzIShh1fQt89ktICjxQcReAENnUsNNO9MWxZ8q5q7=w408-h302-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2915785,
      112.6545816
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809807",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJc6EsuY_91y0ROcp48ZmIgic",
    "name": "elka coffee & billiard",
    "address": "Jl. Wisma Lidah Kulon III No.A No.35, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.6",
    "reviewCount": 207,
    "placeId": "ChIJc6EsuY_91y0ROcp48ZmIgic",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=elka%20coffee%20%26%20billiard&query_place_id=ChIJc6EsuY_91y0ROcp48ZmIgic",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMJtJZMkfFpE4610rqKS57GvEDc0KuxC5NyMrg1=w408-h510-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Sport": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.3098201,
      112.6526144
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809814",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJObwsTTL91y0RUc1T8vBVzu0",
    "name": "Ratan Cafe & Gardenspace",
    "address": "Jl. Raya Randegansari, Lakarsantri, Kec. Lakarsantri, Surabaya, Jawa Timur 60211, Indonesia",
    "rating": "4.6",
    "reviewCount": 166,
    "placeId": "ChIJObwsTTL91y0RUc1T8vBVzu0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Ratan%20Cafe%20%26%20Gardenspace&query_place_id=ChIJObwsTTL91y0RUc1T8vBVzu0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 819-3156-7679",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npfY320aCpSOjUPYeBBZQt7OoFcqeivPXGv0tZEr4iJXDswL1MolaJeXUkZFCcbMXEzG7fEbDCCyZ-2A-pruo8oB3cPMEcXAFFyTkl2jIYZ26O-DTLke8WxvsgojmMcgQIqwbU=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.3099997,
      112.6353573
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809821",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ7dJbL9H91y0RsvI33Vo1M1k",
    "name": "KAPO Kafe Pojok",
    "address": "Jalan Niaga Gapura Gwalk Citraland FG-08, Lontar, Sambikerep, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60216, Indonesia",
    "rating": "4.3",
    "reviewCount": 366,
    "placeId": "ChIJ7dJbL9H91y0RsvI33Vo1M1k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KAPO%20Kafe%20Pojok&query_place_id=ChIJ7dJbL9H91y0RsvI33Vo1M1k",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": "http://www.instagram.com/kapokafepojok",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "2 to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "2 to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "2 to 10 PM"
        }
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMC2lKZhAtZl5zPgY-CrPmyJio6NUdrSE9p5pxT=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2898967,
      112.6549259
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809836",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ1_R-p5T91y0RXsEF0BFienk",
    "name": "Kokkili Cafe",
    "address": "Jl. Citralan No.13, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60216, Indonesia",
    "rating": "4.9",
    "reviewCount": 193,
    "placeId": "ChIJ1_R-p5T91y0RXsEF0BFienk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kokkili%20Cafe&query_place_id=ChIJ1_R-p5T91y0RXsEF0BFienk",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-1660-5706",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4no1kMFV0XSu0P_wbrir4P5JKpEjJFV-s3RvHbH2t-qsv1kkghallkPdsMSsTKfJcJ0WHEBr_mGlGAmstjDMFK4DJcKfCLZ7yEbSckJTylQdNGr7CrGB6X483Tcm2IY6EYlWDPRdRA=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Assistive hearing loop": false
        },
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        },
        {
          "Wheelchair-accessible toilet": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Gender-neutral toilets": true
        },
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free of charge street parking": true
        },
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2876699,
      112.6556897
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809828",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJSQafn6v91y0RmA64ayXcLQI",
    "name": "JJ LAKE CAFE & EATERY",
    "address": "Bukit Telaga Golf Blok FG no. 16, Jeruk, Lakarsantri, Surabaya, East Java 60212, Indonesia",
    "rating": "4.2",
    "reviewCount": 533,
    "placeId": "ChIJSQafn6v91y0RmA64ayXcLQI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=JJ%20LAKE%20CAFE%20%26%20EATERY&query_place_id=ChIJSQafn6v91y0RmA64ayXcLQI",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": "https://instagram.com/jjlakecafe?igshid=YmMyMTA2M2Y=",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Closed"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Jeruk, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noNAlLwmJQznX2vjBkaja3DhrQF9tlAtjHYOeFqoRyHK_8RprKdA0a46Uq0w2w7koJZqXaZ9AAClGxU58ObWrb-N52x88AefuQO6WbpCmLuy6c0kt6cMuTqRKjq0a6XIpHCI-BklA=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free of charge street parking": true
        },
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2977668,
      112.6492071
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809843",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJC2RM8Mv51y0RaYXcjIdPF2o",
    "name": "Kwasong Cafe",
    "address": "Ruko One Arcade ARA 11, 12, RW.Citraland, Lidah Kulon, Lakarsantri, Surabaya, East Java 60219, Indonesia",
    "rating": "4.6",
    "reviewCount": 176,
    "placeId": "ChIJC2RM8Mv51y0RaYXcjIdPF2o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kwasong%20Cafe&query_place_id=ChIJC2RM8Mv51y0RaYXcjIdPF2o",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3454-6220",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 7:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 7:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 7:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 7:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 7:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 7:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 8:30 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noarP1jC6S25gV7c1lF-T2jXwH7z60rTcfpAFcux871yahoYUf9gNPW1w__laXB1VHPhm4yLq35zqhA17USFsQQ4P6bbhHEv-aC2SC9zWI1gGthf2dG_zseImVsXzUGnQoI0kf5=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.283174,
      112.6581025
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809851",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ299-Xzz91y0R8ZwAyj6cpUo",
    "name": "KYND BAKER Cafe",
    "address": "Villa Taman Telaga TJ1/1, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.9",
    "reviewCount": 214,
    "placeId": "ChIJ299-Xzz91y0R8ZwAyj6cpUo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KYND%20BAKER%20Cafe&query_place_id=ChIJ299-Xzz91y0R8ZwAyj6cpUo",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 817-4727-000",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOJCeHHhR_q0-4Cq_yxUPv9t32rqf1cF1RTxrlc=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Organic dishes": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.294534,
      112.6520661
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809859",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ9VWYsOr91y0RFdlVC_V_MqA",
    "name": "Nyfodd kafe",
    "address": "Puri Widya Kencana K2 no, 1, RW.Citraland, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.9",
    "reviewCount": 138,
    "placeId": "ChIJ9VWYsOr91y0RFdlVC_V_MqA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Nyfodd%20kafe&query_place_id=ChIJ9VWYsOr91y0RFdlVC_V_MqA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 823-3330-2147",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 9:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 9:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 9:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 9:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 9:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqUZeanRZv2M5n1DMUxZl3CIM7uGcowPk-veKReMCNePkA_hz9WqO7K4mnjDqeO0TkNtyOhplVfDmODueoJb5oUkjK_0KTi_ySjYqzqUolpI4NLxJr45te4yA-cVKbMvxz93wJc=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "On-site services": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Assistive hearing loop": false
        },
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy-hour drinks": true
        },
        {
          "Late-night food": true
        },
        {
          "Organic dishes": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Gender-neutral toilets": true
        },
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free multi-storey car park": true
        },
        {
          "Free of charge street parking": true
        },
        {
          "Free parking lot": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        },
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2923637,
      112.6521793
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809867",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJdUQzzj391y0R66LaFbAqSQk",
    "name": "Dudu' Cafe",
    "address": "Jl. Sepat Lidah Kulon No.221, RT.01/RW.03, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.4",
    "reviewCount": 217,
    "placeId": "ChIJdUQzzj391y0R66LaFbAqSQk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Dudu%27%20Cafe&query_place_id=ChIJdUQzzj391y0R66LaFbAqSQk",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-2040-7878",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "12 to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "12 to 10 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNcJq7fKsLXEhl0ZhBuLBc4RcgmD7GmaQDs5E_f=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.3062976,
      112.6542102
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809876",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJs_sOljH91y0Rrp4GjwcOKBs",
    "name": "Bunbee Korean Bakery Gwalk",
    "address": "Jl. Sentra Taman Gapura No.H-5, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60217, Indonesia",
    "rating": "4.9",
    "reviewCount": 254,
    "placeId": "ChIJs_sOljH91y0Rrp4GjwcOKBs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Bunbee%20Korean%20Bakery%20Gwalk&query_place_id=ChIJs_sOljH91y0Rrp4GjwcOKBs",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3286-880",
    "website": "https://www.bunbeeid.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOErAdyHX5-o8DkG_-AN6n66gBwSSeGNSE4j3EA=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2854982,
      112.6548587
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809886",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJTby7aeP71y0R_cTbHgbK66o",
    "name": "Villos Coffee Surabaya",
    "address": "Jl. Pasar Kembang No.71, Wonorejo, Kec. Tegalsari, Surabaya, Jawa Timur 60263, Indonesia",
    "rating": "4.5",
    "reviewCount": 377,
    "placeId": "ChIJTby7aeP71y0R_cTbHgbK66o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Villos%20Coffee%20Surabaya&query_place_id=ChIJTby7aeP71y0R_cTbHgbK66o",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-5946-7480",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 3 am"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 3 am"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 3 am"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 3 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 3 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 3 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 3 am"
        }
      }
    ],
    "neighborhood": "Wonorejo, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4no155_z8_JUwsvjOmjPtez8inX48PEX1kHV5eWKvtJbzgf7NjTvH8VwefgGLkaXKrFbz5raSL-c0gGbMrxo3J5PXKFvtyxeEAahm0bIPugNotyZBNieFAtd1Z3iCO23vy5skI_d=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.2715475,
      112.7282571
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809895",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ3_IpVrNKeC4Rm2rsesn2E_k",
    "name": "\"ZorWid\" Shop & Cafe",
    "address": "Jalan Darmo Indah Barat II AA No.1, Jl. Tol Surabaya - Gempol, Karangpoh, Surabaya Barat, Surabaya, Jawa Timur 60186, Indonesia",
    "rating": "4.4",
    "reviewCount": 205,
    "placeId": "ChIJ3_IpVrNKeC4Rm2rsesn2E_k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=%22ZorWid%22%20Shop%20%26%20Cafe&query_place_id=ChIJ3_IpVrNKeC4Rm2rsesn2E_k",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3444-1627",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 AM to 12 am"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 AM to 12 am"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 AM to 12 am"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 AM to 12 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Karangpoh, Surabaya Barat",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOvUGWoPcdKRa0QGVDjppGU5HG4L_oXcnFWboDN=w408-h244-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        },
        {
          "Toilet": false
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.2631412,
      112.6806014
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809905",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ5UuYpN391y0RRy8bG0NkV3c",
    "name": "Calipto Eatery",
    "address": "Made, NorthWest Boulevard NV No.03 / 25 26, Babat Jerawat, Kec. Sambikerep, Surabaya, Jawa Timur 60217, Indonesia",
    "rating": "4.5",
    "reviewCount": 162,
    "placeId": "ChIJ5UuYpN391y0RRy8bG0NkV3c",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Calipto%20Eatery&query_place_id=ChIJ5UuYpN391y0RRy8bG0NkV3c",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 852-3413-2064",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 8 PM"
        }
      }
    ],
    "neighborhood": "Babat Jerawat, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNMuQ9mRNwW943o69E74ntXEcq9Zr4ZfK8h_btq=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2538753,
      112.62348
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809915",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJS-jcrIv71y0RH5D5i1szfrU",
    "name": "HAVANA COFFEE",
    "address": "Jl. Keputih Tegal Timur No.43, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.7",
    "reviewCount": 244,
    "placeId": "ChIJS-jcrIv71y0RH5D5i1szfrU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=HAVANA%20COFFEE&query_place_id=ChIJS-jcrIv71y0RH5D5i1szfrU",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNCDDCmCiRw1LNUYNUjsVrKCNv0tujX93AfJ6Ay=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.291701,
      112.8055943
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809927",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJa6o8XZ3w1y0R_yRLxtGaUSU",
    "name": "Bikop Roastery (supplier coffeeshop)",
    "address": "Jl. Keputih Tegal Timur No.21, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.6",
    "reviewCount": 329,
    "placeId": "ChIJa6o8XZ3w1y0R_yRLxtGaUSU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Bikop%20Roastery%20%28supplier%20coffeeshop%29&query_place_id=ChIJa6o8XZ3w1y0R_yRLxtGaUSU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 859-5169-9799",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "3 PM to 12 AM"
        }
      }
    ],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqgXwM9xB3l743O3VNKkJTehDu0QV3u_qK8CzGWnCnSU-ube8FLq5k8bY_eBla0xJz9m0pYcGv-dpQeCZujqYitiDsUWd3wmgLuUDb2OUYHY1Cuu8BMqR0hjgBT7QG4JHK0Cdn4=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.292357,
      112.8112362
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809939",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJNenWJU791y0RvVHh6az7XXs",
    "name": "Kedai Merakyat - Citraland",
    "address": "Jl. International Village I No.C-11, Sambikerep, Kec. Lakarsantri, Surabaya, Jawa Timur 60217, Indonesia",
    "rating": "4.5",
    "reviewCount": 73,
    "placeId": "ChIJNenWJU791y0RvVHh6az7XXs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Merakyat%20-%20Citraland&query_place_id=ChIJNenWJU791y0RvVHh6az7XXs",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-5710-1078",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "3 PM to 2 AM"
        }
      }
    ],
    "neighborhood": "Sambikerep, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqFFqZXyRu8Ca4mA9QhNjI8UknY7RvvRy3gPMhyNTeI3WZWaV-0my1ZEDA4DVTB3pa7-n1ye5z994ppfgOZqQ3Y3q53IZMqpuBabeWqhX_vyywf0vwu6DbrNxWgPFCn9-qcN_fe=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2852857,
      112.6529438
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809950",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ_1X118_91y0RXXqKrXv5zoA",
    "name": "Liek Cafe",
    "address": "Jl. Raya Sambikerep No.2, Sambikerep, Kec. Sambikerep, Surabaya, Jawa Timur 60217, Indonesia",
    "rating": "4.3",
    "reviewCount": 187,
    "placeId": "ChIJ_1X118_91y0RXXqKrXv5zoA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Liek%20Cafe&query_place_id=ChIJ_1X118_91y0RXXqKrXv5zoA",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 857-4857-8201",
    "website": null,
    "openingHours": [],
    "neighborhood": "Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noCzGr2PxPQvY8VpgJKCutYGZcx8hgGDiFqHqNUWKYv0wCZdZGyoTE4YqfvKd2jwoSRMsT9KFksdaRl-AelKbU5MfgPZZ3KFNxT1lR_jYaoAkEbLm6YIzh52ViSDtko0z1YJAgc=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        },
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2814902,
      112.6578369
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809961",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJf3Z7ZJr_1y0RDhXfg-U_D94",
    "name": "Kedai Cemara Condong",
    "address": "Jl. Tengger Rejo Mulyo V/F, Kandangan, Kec. Benowo, Surabaya, Jawa Timur 60199, Indonesia",
    "rating": "4.9",
    "reviewCount": 102,
    "placeId": "ChIJf3Z7ZJr_1y0RDhXfg-U_D94",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Cemara%20Condong&query_place_id=ChIJf3Z7ZJr_1y0RDhXfg-U_D94",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": "http://wa.me/6289525355302",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Kandangan, Benowo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMq_l3Pq5AlgOXfqzD6SD7v7c083qFVfGmiS7fI=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2560371,
      112.6546427
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809973",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJtdLZcmz-1y0RPt6eEvdtBu0",
    "name": "Cafe Kanon (now available on gojek/grab)",
    "address": "Jl. Raya Klakah Rejo No.63, RT.04/RW.08, Klakahrejo, Kec. Benowo, Surabaya, Jawa Timur 60198, Indonesia",
    "rating": "3.4",
    "reviewCount": 185,
    "placeId": "ChIJtdLZcmz-1y0RPt6eEvdtBu0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20Kanon%20%28now%20available%20on%20gojek/grab%29&query_place_id=ChIJtdLZcmz-1y0RPt6eEvdtBu0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 895-0345-5789",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 9:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 9:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 9:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 9:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 9:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 9:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 9:30 PM"
        }
      }
    ],
    "neighborhood": "Klakahrejo, Benowo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNWmb3xE0kj64y-CO0wswrNGkuwWLA39ZqTlfyS=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2574528,
      112.6481004
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809986",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ-8yHEtD91y0RCUX8O9BIPSI",
    "name": "Moonk Cartil and Cafe",
    "address": "Jl. Raya Sambikerep No.102A, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60217, Indonesia",
    "rating": "4.3",
    "reviewCount": 257,
    "placeId": "ChIJ-8yHEtD91y0RCUX8O9BIPSI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Moonk%20Cartil%20and%20Cafe&query_place_id=ChIJ-8yHEtD91y0RCUX8O9BIPSI",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 817-9955-558",
    "website": "http://www.instagram.com/moonk.sub",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 11:45 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 11:45 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 11:45 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 11:45 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 11:45 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 11:45 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 11:45 PM"
        }
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMRTn4--yhiBC-wuF3E2v_nKKN_Hc47pGwzLZf6=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2789361,
      112.6589445
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.809998",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJr73AbpH91y0RUD2xEhylNUY",
    "name": "GOODMAN Coffee",
    "address": "GWalk Shophouse W1/17-18, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60216, Indonesia",
    "rating": "4.8",
    "reviewCount": 133,
    "placeId": "ChIJr73AbpH91y0RUD2xEhylNUY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=GOODMAN%20Coffee&query_place_id=ChIJr73AbpH91y0RUD2xEhylNUY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-1325-2521",
    "website": "https://www.instagram.com/goodman.coffeebar/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npUHfNEpf70LXz41I4RfPXQ_mKrtEA5udA-MgfvGjA8j_cc74vzK3Gr_Ji1vKj4i3flwpraoADgYUconWwqfcELHGNjtYgu9zV1Q3a-2OzxpTGoEd8x1zZ2HM_jqScXv_yBGYfz=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2849731,
      112.6564051
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810010",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJc1zrm4v91y0RGJ-QT6A0oYo",
    "name": "Titik Koma Citraland G-Walk",
    "address": "Jl. Sentra Taman Gapura Jl. Citraland Surabaya No.H-17, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60216, Indonesia",
    "rating": "4.7",
    "reviewCount": 222,
    "placeId": "ChIJc1zrm4v91y0RGJ-QT6A0oYo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Titik%20Koma%20Citraland%20G-Walk&query_place_id=ChIJc1zrm4v91y0RGJ-QT6A0oYo",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 877-0013-5888",
    "website": "https://titikkoma.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 8:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 8:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 8:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 8:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 8:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 8:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 8:30 PM"
        }
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOOt8ULomMTBnyIk958efnT_jx0kCslRIt4XvYQ=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2855595,
      112.6553498
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810024",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJY7IdOnL_1y0RRb0u3Cih6KE",
    "name": "Nomcherry Cafe",
    "address": "Jl. Bumi Indah No.3, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60217, Indonesia",
    "rating": "4.4",
    "reviewCount": 202,
    "placeId": "ChIJY7IdOnL_1y0RRb0u3Cih6KE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Nomcherry%20Cafe&query_place_id=ChIJY7IdOnL_1y0RRb0u3Cih6KE",
    "categories": [
      "Restaurant",
      "Cafe"
    ],
    "phone": "+62 878-5521-0770",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "12 to 9 PM"
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNeZO-W5aN6Reb_F_PcbBQrltTloX2Qvk61tL3P=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.595670",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ05JxiLT91y0RctdrPnAYXaA",
    "name": "Suroboyo Kulon Coffee",
    "address": "Jl. Made Barat No.70, Made, Kec. Sambikerep, Surabaya, Jawa Timur 60219, Indonesia",
    "rating": "4.8",
    "reviewCount": 73,
    "placeId": "ChIJ05JxiLT91y0RctdrPnAYXaA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Suroboyo%20Kulon%20Coffee&query_place_id=ChIJ05JxiLT91y0RctdrPnAYXaA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3529-9979",
    "website": "http://www.instagram.com/subkulon.skc",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Made, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4no-P7nfx4SfQv2lcyFJy_3Xc0RH6kFTKd5azwmzz8aUX0ptnPKjVW4nfQICr3axy6_aMcn_1y0sqCmWm9NT6BJE91QYOX7NRiB6n3aVjul2S3-HRV-7MCxjVevMlZTO-t7Mlu2U=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2769423,
      112.6324751
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810037",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJG8TdfvH61y0RN_4ypzDaKKI",
    "name": "Excelso MERR",
    "address": "Jl. Dr. Ir. H. Soekarno Pondok Nirwana No.292, Kedung Baruk, Kec. Rungkut, Surabaya, Jawa Timur 60298, Indonesia",
    "rating": "4.6",
    "reviewCount": 2271,
    "placeId": "ChIJG8TdfvH61y0RN_4ypzDaKKI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Excelso%20MERR&query_place_id=ChIJG8TdfvH61y0RN_4ypzDaKKI",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3113-319",
    "website": "https://www.instagram.com/excelso_merr/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Kedung Baruk, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOd1uB6TD1av9aL4Kvkpw-oBxM6BnI9LslCGLSI=w451-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        },
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.3125194,
      112.7804585
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810049",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJqRKRU7P91y0RzIemqZUyeII",
    "name": "DELIFORE COFFEE & EATERY BUKIT PALMA",
    "address": "Ruko Galeria Palma RB 2/1 Citraland, Sememi, Kec. Benowo, Surabaya, Jawa Timur 60218, Indonesia",
    "rating": "4.6",
    "reviewCount": 86,
    "placeId": "ChIJqRKRU7P91y0RzIemqZUyeII",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=DELIFORE%20COFFEE%20%26%20EATERY%20BUKIT%20PALMA&query_place_id=ChIJqRKRU7P91y0RzIemqZUyeII",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-4200-6799",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "12 to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "12 to 10 PM"
        }
      }
    ],
    "neighborhood": "Sememi, Benowo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipONeCnc6PLDDCMl743GRn044ss1o7opw21AhLby=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2621673,
      112.6366158
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810065",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJKRPcS-D71y0RVYN2hEO7M6A",
    "name": "Ijjo cafe",
    "address": "MQ8V+HRH, Jl. Raya Gn. Anyar Sawah, Gn. Anyar, Kec. Gn. Anyar, Surabaya, Jawa Timur 60294, Indonesia",
    "rating": "4.5",
    "reviewCount": 483,
    "placeId": "ChIJKRPcS-D71y0RVYN2hEO7M6A",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Ijjo%20cafe&query_place_id=ChIJKRPcS-D71y0RVYN2hEO7M6A",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqi66Mzv0ls6S55HgsjyzCgVAu5ps9gfc7e5su02qXUgSgUbH6mJXVVzwBs-Bkrlnu4lEstmNdy4YV_AvT9JWSxVE36VH4YwU7kR_0onBKCGj0Mb3uWxwJ5cezKJA1JZp9U-S2ToQ=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.3335643,
      112.7945987
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810078",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ1_GUIt791y0RJkvnMnXS0f8",
    "name": "Gatherinc Bistro and Bakery",
    "address": "Taman Puspa Raya A2 no 11, Made, Kec. Sambikerep, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.5",
    "reviewCount": 634,
    "placeId": "ChIJ1_GUIt791y0RJkvnMnXS0f8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Gatherinc%20Bistro%20and%20Bakery&query_place_id=ChIJ1_GUIt791y0RJkvnMnXS0f8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 99019881",
    "website": "https://www.instagram.com/gatherinc",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Made, Sambikerep",
    "city": "Surabaya",
    "description": "Contemporary Asian fare whipped up in lofty, industrial-chic digs with floor-to-ceiling windows.",
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNLYTxSmxJKwit1Npiw-17uWJytMfUny4EbV3j0=w428-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2781645,
      112.6454158
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810093",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ318h82T51y0RJ5dvMW9lTG4",
    "name": "DEJAVU",
    "address": "Ngagel Jaya Selatan St No.33, RT.001/RW.05, Pucang Sewu, Gubeng, Surabaya, East Java 60283, Indonesia",
    "rating": "4.4",
    "reviewCount": 3181,
    "placeId": "ChIJ318h82T51y0RJ5dvMW9lTG4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=DEJAVU&query_place_id=ChIJ318h82T51y0RJ5dvMW9lTG4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5021028",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 3 AM"
        }
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOE-GwDZdgDLs4DvdSaHvm6mP3v5mE2obqpTC-j=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible restroom": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Hard liquor": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.2925846,
      112.7512433
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810106",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ0TyXN2_71y0RqrT7jgNetzY",
    "name": "Demandailing Cafe & Eatery - MERR",
    "address": "Jl. Dr. Ir. H. Soekarno MERR No.414, Kedung Baruk, Kec. Rungkut, Surabaya, Jawa Timur 60298, Indonesia",
    "rating": "4.6",
    "reviewCount": 1393,
    "placeId": "ChIJ0TyXN2_71y0RqrT7jgNetzY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Demandailing%20Cafe%20%26%20Eatery%20-%20MERR&query_place_id=ChIJ0TyXN2_71y0RqrT7jgNetzY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 87860281",
    "website": "http://instagram.com/demandailingcafe",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Kedung Baruk, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOREspZs08F_y9D0kOHV_QdlWPpR1ZvP-U6ftlJ=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Checks": true
        },
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.3225321,
      112.7423232
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:52:39.811428",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJZyiPPTj61y0Rii9RULnl8wU",
    "name": "Konoae Warung A La Cafe, Klampis Ngasem",
    "address": "Jl. Klampis Ngasem IV No.39, Klampis Ngasem, Kec. Sukolilo, Surabaya, Jawa Timur 60117, Indonesia",
    "rating": "4.5",
    "reviewCount": 401,
    "placeId": "ChIJZyiPPTj61y0Rii9RULnl8wU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Konoae%20Warung%20A%20La%20Cafe%2C%20Klampis%20Ngasem&query_place_id=ChIJZyiPPTj61y0Rii9RULnl8wU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3404-6606",
    "website": "https://linktr.ee/konoae.sby",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Klampis Ngasem, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npjweFHi-y4cTjPTtbZNGD7Kxg41a7mYSivvpaCosYbwojGn2oPnHyKbwuBqYxFAGfMspUazVJq1iAeEKl3QLQXofFOq8O7Buz4Yk2xFGQaKMUBeCvOxyGfMqNuCf7UOJpEOPf2=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.2840839,
      112.7757231
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810140",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJETSpNBv61y0R6zHDlL1jtT4",
    "name": "SAS Cafe N Resto",
    "address": "Jl. Bhaskara Sawah No.30, Kalisari, Kec. Mulyorejo, Surabaya, Jawa Timur 60112, Indonesia",
    "rating": "4.2",
    "reviewCount": 3239,
    "placeId": "ChIJETSpNBv61y0R6zHDlL1jtT4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=SAS%20Cafe%20N%20Resto&query_place_id=ChIJETSpNBv61y0R6zHDlL1jtT4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3555-460",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Kalisari, Mulyorejo",
    "city": "Surabaya",
    "description": "Tempat makan yg casual dan terbuka, dengan fasilitas taman bermain anak, dengan aneka variasi menu.",
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npXiR90Jc5gtVQHtUPh80c4vvdHezIlVBD-2DJRTyuU_-OwAf5EgzIuFPWEk-gRvwZUn9_Z7sX7Ap6CJpthsXFuaagA-L7Hl8o2CeY1qRL1W1wK2KHyKRkxbrrg3Slf07i1PyEsZw=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.2703801,
      112.7986469
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810155",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ08PjtvX51y0RBqpIaXpMsTc",
    "name": "Cocoro Surabaya",
    "address": "Jl. Mulyosari Utara No.06, Kalisari, Kec. Mulyorejo, Surabaya, Jawa Timur 60112, Indonesia",
    "rating": "4.8",
    "reviewCount": 106,
    "placeId": "ChIJ08PjtvX51y0RBqpIaXpMsTc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cocoro%20Surabaya&query_place_id=ChIJ08PjtvX51y0RBqpIaXpMsTc",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-2022-8228",
    "website": "http://instagram.com/cocoro.sub",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8:30 AM to 5 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8:30 AM to 5 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8:30 AM to 5 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8:30 AM to 5 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8:30 AM to 5 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8:30 AM to 5 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "Kalisari, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nooUAvpJNcN-EEVXhGTGYrwPUoJQ77IqO5uh6vBUiWWcLCbJMtH1r4CVgfOWa9upvPSua5w3qNEGPbhNHwFu1aAcwOlWVFl8jLxwG6tE1gtJZsUbpcK0SuBsAmQOeYlgoqWJGNy=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.2620049,
      112.7960531
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810171",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJ_XYT8jn81y0R4kzGNijkOcg",
    "name": "JCO COFFEE & DONUTS LENMARC MALL",
    "address": "Lenmarc Mall, Level G, Jl. Mayjend. Jonosewojo No.9, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60226, Indonesia",
    "rating": "4.4",
    "reviewCount": 126,
    "placeId": "ChIJ_XYT8jn81y0R4kzGNijkOcg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=JCO%20COFFEE%20%26%20DONUTS%20LENMARC%20MALL&query_place_id=ChIJ_XYT8jn81y0R4kzGNijkOcg",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": "https://jcodonuts.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npP3IFHHU4QApULRs3HJNXA3FXorrph1tbYn9Ez6Oybj7ETHFswcec5yf80CNKrhJGTM7WzQebIwZNbiv0S6YPl5fJKgb0skv1GdXC8GjlJxKVdTQe6TC-snHnVZ8Lks-z2Nhq8qA=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.2859339,
      112.6806065
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810188",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJF1Jn4z_71y0R1VSUJ72iFRo",
    "name": "Republika Cafe & Resto",
    "address": "Jl. Dr. Ir. H. Soekarno No.338, Kedung Baruk, Kec. Rungkut, Surabaya, Jawa Timur 60298, Indonesia",
    "rating": "4.3",
    "reviewCount": 1888,
    "placeId": "ChIJF1Jn4z_71y0R1VSUJ72iFRo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Republika%20Cafe%20%26%20Resto&query_place_id=ChIJF1Jn4z_71y0R1VSUJ72iFRo",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-3377-9542",
    "website": "https://ibisnis.com/republikacaferesto",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Kedung Baruk, Rungkut",
    "city": "Surabaya",
    "description": "Warmly decorated, rustic-chic restaurant featuring redbrick walls & a rooftop terrace.",
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPGyetnLfJPakPTGxJ6I32x9Fw8Lxe7YErNtF7M=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.315972,
      112.780663
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810205",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJQ6uIkf771y0RXdIgzZWRziM",
    "name": "Eicy Cafe",
    "address": "Jl. Manyar Jaya No.2e, Menur Pumpungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.6",
    "reviewCount": 590,
    "placeId": "ChIJQ6uIkf771y0RXdIgzZWRziM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Eicy%20Cafe&query_place_id=ChIJQ6uIkf771y0RXdIgzZWRziM",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-6001-0910",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Menur Pumpungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npsvAzVxvK_mETnhbsn4LgtxpbzNbQ81baat_yq67HyMpf5zvhz1uNoFNC3BclLbrJWfneWw-gFiCEuxX6BHAOzzYWudv-nCFIlxxY0S4OlXpqwbcUcUfOHJQn2WZfkFcMr2eLDTw=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.2945429,
      112.768385
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810221",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJq6rq1kn81y0RfzYZGIl4yTc",
    "name": "Kudos Cafe - Pakuwon Square",
    "address": "Pakuwon Square AK 2, Jl. Mayjend. Jonosewojo No.100, Lidah Wetan, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.6",
    "reviewCount": 2318,
    "placeId": "ChIJq6rq1kn81y0RfzYZGIl4yTc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kudos%20Cafe%20-%20Pakuwon%20Square&query_place_id=ChIJq6rq1kn81y0RfzYZGIl4yTc",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 99016791",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Lidah Wetan, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqws5vyIIdYrgCqD3DltvvM01z4QOkVYXlMFj-yQKUv94fligFOUTWs2C9P7R8p_hkobQkecl8s-p4M88DyQ-IQ5BIqtPr7buwN4iTWX6yKyPcgqItqoAUKLkl4fbRJe8VMkWHh=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "On-site services": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        },
        {
          "Dogs allowed inside": true
        },
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2948389,
      112.6752565
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:22:54.810238",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJF2rBfhT71y0RZcjbW3Ajc2I",
    "name": "Demandailing Cafe",
    "address": "Jl. Raya Jemursari No.71, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.5",
    "reviewCount": 4214,
    "placeId": "ChIJF2rBfhT71y0RZcjbW3Ajc2I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Demandailing%20Cafe&query_place_id=ChIJF2rBfhT71y0RZcjbW3Ajc2I",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 31 8480367",
    "website": "http://instagram.com/demandailingcafe",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOV_29TY9qH6T9xnYFtC-wIVbVA-5yYj5zDY9Kl=w408-h509-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Lunch reservations recommended": true
        },
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.294,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.595940",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ39rV7LT51y0R5IAiDaoF32k",
    "name": "Coffee TGC basra",
    "address": "Jl. Basuki Rahmat No.23, belakang McD, Kec. Genteng, Surabaya, Jawa Timur 60261, Indonesia",
    "rating": "4.5",
    "reviewCount": 2209,
    "placeId": "ChIJ39rV7LT51y0R5IAiDaoF32k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Coffee%20TGC%20basra&query_place_id=ChIJ39rV7LT51y0R5IAiDaoF32k",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-3778-7875",
    "website": "http://coffeetgc.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 AM to 11:55 PM"
        }
      }
    ],
    "neighborhood": "belakang McD, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOXKFBCnRAzzq5VNCvnilHdVgDK0LDuCjM4t8wa=w408-h306-k-no",
    "additionalInfo": {
      "From the business": [
        {
          "Identifies as women-owned": true
        }
      ],
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.595954",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJE4MuDXn71y0RND_g72UkISI",
    "name": "Patdua Coffee & Eatery",
    "address": "Jl. Rungkut Madya No.203, Rungkut Kidul, Kec. Rungkut, Surabaya, Jawa Timur 60294, Indonesia",
    "rating": "4.6",
    "reviewCount": 476,
    "placeId": "ChIJE4MuDXn71y0RND_g72UkISI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Patdua%20Coffee%20%26%20Eatery&query_place_id=ChIJE4MuDXn71y0RND_g72UkISI",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 851-7345-0042",
    "website": "http://www.instagram.com/patdua_eatery/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Rungkut Kidul, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqXAsCzKrnZ5qaKSHud3IZrQ7ONx0e5zfxmhj4744wDOyw7CJNZiWUsA9hLowCPsDBn9_kAS6IWe9YNP4HoJFB0tknNLvdDKoNjYFIQ2CuXfAKve9ax2ESSuxDNJ_C9ypAMo-2zdg=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.595969",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJwVCGeP_61y0R8LDb1OUTeuM",
    "name": "Upper Room Cafe & Resto",
    "address": "Nginden Intan Selatan Blok:C7, Jl. Raya Nginden Jangkungan No.7, Ngenden Jangkungan, Sukolilo, Surabaya, East Java 60118, Indonesia",
    "rating": "4.5",
    "reviewCount": 226,
    "placeId": "ChIJwVCGeP_61y0R8LDb1OUTeuM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Upper%20Room%20Cafe%20%26%20Resto&query_place_id=ChIJwVCGeP_61y0R8LDb1OUTeuM",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5953237",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 5 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 5 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 5 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Closed"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 5 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 5 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 5 PM"
        }
      }
    ],
    "neighborhood": "Ngenden Jangkungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNp8kR-j9oSOgwwrGETnR8ja4elubBBnv1I7q3r=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "known_accurate",
    "coordinatesAccuracy": "high",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.595999",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJFSrpelX71y0RnuFg_CAHJPY",
    "name": "Petrichor",
    "address": "Jl. Manyar Kerta Adi No.93, Manyar Sabrangan, Kec. Mulyorejo, Surabaya, Jawa Timur 60117, Indonesia",
    "rating": "4.4",
    "reviewCount": 824,
    "placeId": "ChIJFSrpelX71y0RnuFg_CAHJPY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Petrichor&query_place_id=ChIJFSrpelX71y0RnuFg_CAHJPY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 877-6473-0892",
    "website": "https://msha.ke/petrichorcafe/",
    "openingHours": [],
    "neighborhood": "Manyar Sabrangan, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPWokWTRUeNOzm0JNNDFOlplo8nElvIVDApRi2R=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        },
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596013",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ_bZtg5X51y0R2Sj9OLC1bCI",
    "name": "Mawu Cafe",
    "address": "Jl. Pandan No.5, Ketabang, Kec. Genteng, Surabaya, Jawa Timur 60272, Indonesia",
    "rating": "4.4",
    "reviewCount": 595,
    "placeId": "ChIJ_bZtg5X51y0R2Sj9OLC1bCI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Mawu%20Cafe&query_place_id=ChIJ_bZtg5X51y0R2Sj9OLC1bCI",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Ketabang, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipODcUKVQ6Oz3DvOWehNL4lyVSWOwzoDozu7GXL2=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596026",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ1aicVMX71y0RbWVfgRWu2yU",
    "name": "Djoedjoegan coffeeshop",
    "address": "Jl. Kalasan No.15, Pacar Keling, Kec. Tambaksari, Surabaya, Jawa Timur 60271, Indonesia",
    "rating": "4.4",
    "reviewCount": 264,
    "placeId": "ChIJ1aicVMX71y0RbWVfgRWu2yU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Djoedjoegan%20coffeeshop&query_place_id=ChIJ1aicVMX71y0RbWVfgRWu2yU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 856-3320-722",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Pacar Keling, Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPf7ujbGM3hLcdD4BdtPlaHXq_E4AXvZ3pjmOaq=w408-h291-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.252,
      112.765
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596057",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJQXiuyU771y0Ru6TlzyXauvQ",
    "name": "Sand Box Cafe - Pakuwon City Mall",
    "address": "Pakuwon Town Square AA1-25, Kejawaan Putih Tamba, Mulyorejo, Surabaya, East Java 60112, Indonesia",
    "rating": "4.9",
    "reviewCount": 170,
    "placeId": "ChIJQXiuyU771y0Ru6TlzyXauvQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Sand%20Box%20Cafe%20-%20Pakuwon%20City%20Mall&query_place_id=ChIJQXiuyU771y0Ru6TlzyXauvQ",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 816-517-508",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 8 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7:30 AM to 8 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7:30 AM to 8 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7:30 AM to 8 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7:30 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7:30 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7:30 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Kejawaan Putih Tamba, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPVrjzzWCKUN7rlHcTEE9B8m3v2eKmgm9THkN33=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596073",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJBeogymP71y0RKdX783oL6vk",
    "name": "Aucafe Specialty Coffee",
    "address": "Jl. Manyar Kertoarjo III No.9, Manyar Sabrangan, Kec. Mulyorejo, Surabaya, Jawa Timur 60116, Indonesia",
    "rating": "4.7",
    "reviewCount": 473,
    "placeId": "ChIJBeogymP71y0RKdX783oL6vk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Aucafe%20Specialty%20Coffee&query_place_id=ChIJBeogymP71y0RKdX783oL6vk",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-1688-1683",
    "website": "http://instagram.com/aucafe.id",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 7:45 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 7:45 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 7:45 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 7:45 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 7:45 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 7:45 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 7:45 PM"
        }
      }
    ],
    "neighborhood": "Manyar Sabrangan, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqVMk-rHNGv52ZjsbPzXg1DlsrTiW3EAZajUt2euDqcnNxY92QOorARZdwjUf-iJq37uI1QIbP2TRi7vUD6k2z4z5S5qefTx-ToK2kubdAU52mvKYdZvA_vybQsb1JJkEt5zro=w425-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596087",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ4V2fcEb61y0R7gOkG6JrR4E",
    "name": "The Localist Coffee and Bistro Surabaya",
    "address": "Jl. Arief Rahman Hakim No.40, Klampis Ngasem, Kec. Sukolilo, Surabaya, Jawa Timur 60117, Indonesia",
    "rating": "4.3",
    "reviewCount": 653,
    "placeId": "ChIJ4V2fcEb61y0R7gOkG6JrR4E",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=The%20Localist%20Coffee%20and%20Bistro%20Surabaya&query_place_id=ChIJ4V2fcEb61y0R7gOkG6JrR4E",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5937373",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Klampis Ngasem, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPMfPJNsI-7rkNHRPURqOqR8ZQcnnD1bw4Vupn6=w533-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596102",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJKe5jttn71y0RHyF2VuhqHpA",
    "name": "Historica",
    "address": "Jl. Sumatera No.40, Gubeng, Kec. Gubeng, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.4",
    "reviewCount": 1939,
    "placeId": "ChIJKe5jttn71y0RHyF2VuhqHpA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Historica&query_place_id=ChIJKe5jttn71y0RHyF2VuhqHpA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5033003",
    "website": "http://www.society.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNqPrhxkrt-AapeeOqJHE7YARmiXVac1b3zQ1kV=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596115",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJhS6qhGT51y0RUCoksi_dipo",
    "name": "Calibre Coffee Roasters",
    "address": "Jl. Walikota Mustajab No.67 - 69, Ketabang, Kec. Genteng, Surabaya, Jawa Timur 60272, Indonesia",
    "rating": "4.5",
    "reviewCount": 2103,
    "placeId": "ChIJhS6qhGT51y0RUCoksi_dipo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Calibre%20Coffee%20Roasters&query_place_id=ChIJhS6qhGT51y0RUCoksi_dipo",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-2941-8452",
    "website": "https://instagram.com/calibrecoffeeroasters",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Ketabang, Genteng",
    "city": "Surabaya",
    "description": "High-end coffee spot & cafe in fashionable digs offering gourmet blends & elevated light eats.",
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNq_HYVFfabwIYc6WGmQNG1Db5GZcnf3QCMjliz=w408-h509-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596128",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ2YANmonx1y0R5DFUHpWgVg4",
    "name": "Nusa Coffee",
    "address": "Jl. Keputih Timur Jaya No.17 Blok D, RT.04/RW.02, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.6",
    "reviewCount": 253,
    "placeId": "ChIJ2YANmonx1y0R5DFUHpWgVg4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Nusa%20Coffee&query_place_id=ChIJ2YANmonx1y0R5DFUHpWgVg4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3639-0519",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNBajoroeT1iHR-14z6pyyA_8HO8beGFggckOpO=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596142",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJYRAvJ5P71y0R5FuXV544Hv4",
    "name": "O'bubble Warkop semi Kafe",
    "address": "Jl. Petemon Bar. No.26, RT.01/RW.12, Petemon, Kec. Sawahan, Surabaya, Jawa Timur 60252, Indonesia",
    "rating": "4.4",
    "reviewCount": 73,
    "placeId": "ChIJYRAvJ5P71y0R5FuXV544Hv4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=O%27bubble%20Warkop%20semi%20Kafe&query_place_id=ChIJYRAvJ5P71y0R5FuXV544Hv4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-1699-5956",
    "website": "https://obubblepetemon.weebly.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Petemon, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipORy4FXUArqqdLtn5pHFXnNTIpo92NbD-oTCA_-=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596156",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJbWrtmN_91y0RETmliS0jjRE",
    "name": "Wizz Gelato",
    "address": "Jl. Mayjend. Jonosewojo No.1, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60226, Indonesia",
    "rating": "4.7",
    "reviewCount": 400,
    "placeId": "ChIJbWrtmN_91y0RETmliS0jjRE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Wizz%20Gelato&query_place_id=ChIJbWrtmN_91y0RETmliS0jjRE",
    "categories": [
      "Ice cream shop",
      "Cafe"
    ],
    "phone": "+62 851-0052-0788",
    "website": "https://biolinky.co/wizzgelato",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 9:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 9:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 9:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 9:30 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 9:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 9:30 PM"
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOW8xJ8EbwCOM6nvVElQkwP3TxoDky96oYY33EX=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "In-store pickup": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Quick visit": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "Unknown",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596174",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ_XINBy771y0Rs1CLdYDfJ9g",
    "name": "CAFFE DIAZ 63",
    "address": "Jl. Tempel Sukorejo I No.63, RT.003/RW.07, Wonorejo, Kec. Tegalsari, Surabaya, Jawa Timur 60263, Indonesia",
    "rating": "4.8",
    "reviewCount": 77,
    "placeId": "ChIJ_XINBy771y0Rs1CLdYDfJ9g",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=CAFFE%20DIAZ%2063&query_place_id=ChIJ_XINBy771y0Rs1CLdYDfJ9g",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3337-2961",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Closed"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10:30 AM to 3 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10:30 AM to 3 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10:30 AM to 3 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "12 PM to 3 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10:30 AM to 3 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10:30 AM to 3 AM"
        }
      }
    ],
    "neighborhood": "Wonorejo, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMAQYjGWQE5ZkcCZSmRdqQvdtD5Bc8Fl1RcGwrh=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596187",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJJTxT4B381y0R42CCRDRd2zU",
    "name": "Warkop Gazza Surabaya",
    "address": "Jl. Sukomanunggal No.39, Sukomanunggal, Kec. Sukomanunggal, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.5",
    "reviewCount": 227,
    "placeId": "ChIJJTxT4B381y0R42CCRDRd2zU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Gazza%20Surabaya&query_place_id=ChIJJTxT4B381y0R42CCRDRd2zU",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 822-3104-1444",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Sukomanunggal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOvFX3yodFTKYpS0h-9Q7p2AywLB6-vFWqhPk9r=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.27,
      112.685
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596200",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJs9FiTbL91y0RSsXVhwbcGAg",
    "name": "Jiakopi HR",
    "address": "Jl. Mayjen HR. Muhammad No.86 G, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60187, Indonesia",
    "rating": "4.5",
    "reviewCount": 181,
    "placeId": "ChIJs9FiTbL91y0RSsXVhwbcGAg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Jiakopi%20HR&query_place_id=ChIJs9FiTbL91y0RSsXVhwbcGAg",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-2932-7415",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrFFpVO_SXOImq2msUwEO54W1XIkoV6K41gLNwcnkJhW_kO1kWDRnIh29GUxzaes-2WFb3jEd2p97OUA361kccsbZrJ5SzZpefKJCTxiA17NMxcMoXii424LgmK7sKSlQGYuqr7Ig=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "Unknown",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596221",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJcdYUMPz71y0R6hoZPzGNkQg",
    "name": "Kedai Sorwit",
    "address": "Jl. Banyu Urip No.111, RT.004/RW.03, Banyu Urip, Kec. Sawahan, Surabaya, Jawa Timur 60254, Indonesia",
    "rating": "4.8",
    "reviewCount": 212,
    "placeId": "ChIJcdYUMPz71y0R6hoZPzGNkQg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Sorwit&query_place_id=ChIJcdYUMPz71y0R6hoZPzGNkQg",
    "categories": [
      "Art cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "5 to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "5 to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "5 to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "5 to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "5 to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "5 to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "5 to 11 PM"
        }
      }
    ],
    "neighborhood": "Banyu Urip, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNX4QofxsOO8k8Nu4Guafbjx--owdQ_yaWXI1o=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596236",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJzbEW6qb-1y0RNsB8EA8cA80",
    "name": "Sahabat Java 9",
    "address": "Jalan Raya No.41, Sukomanunggal, Kec. Sukomanunggal, Surabaya, Jawa Timur 60188, Indonesia",
    "rating": "4.5",
    "reviewCount": 565,
    "placeId": "ChIJzbEW6qb-1y0RNsB8EA8cA80",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Sahabat%20Java%209&query_place_id=ChIJzbEW6qb-1y0RNsB8EA8cA80",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 855-4664-5671",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Sukomanunggal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMjqfCFid9EKo5OgLLeqO8hjxusHRystyFgyPti=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.27,
      112.685
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596249",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJewQDvU751y0ROSm0mfppC8s",
    "name": "The Atjeh Connection SURABAYA",
    "address": "Jl. Arjuno No.15, RT.004/RW.07, Sawahan, Kec. Sawahan, Surabaya, Jawa Timur 60251, Indonesia",
    "rating": "4.6",
    "reviewCount": 116,
    "placeId": "ChIJewQDvU751y0ROSm0mfppC8s",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=The%20Atjeh%20Connection%20SURABAYA&query_place_id=ChIJewQDvU751y0ROSm0mfppC8s",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 99253544",
    "website": "https://www.instagram.com/the_atjehconnection/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqFemuHsiY91zVfAz6qvhf39iZmvpgtomPy2x9M_4b1kxKTnuYdj-r3bEAiG0u580xLny6qDOF4HbZPP-hmmEUaQmMCLNF74sAumZOlgtL2fDxLNzJhfkyctza8alAbtus2o6Zq=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596262",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJZ3X3yPD71y0RovP2uHEMuY0",
    "name": "D 'CAFE coffee and shisha",
    "address": "Jl. Jarak No.23, Putat Jaya, Kec. Sawahan, Surabaya, Jawa Timur 60255, Indonesia",
    "rating": "4.5",
    "reviewCount": 88,
    "placeId": "ChIJZ3X3yPD71y0RovP2uHEMuY0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=D%20%27CAFE%20coffee%20and%20shisha&query_place_id=ChIJZ3X3yPD71y0RovP2uHEMuY0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-4305-3098",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 PM to 2 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 PM to 2 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 PM to 2 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 PM to 2 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 PM to 2 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 PM to 2 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 PM to 2 AM"
        }
      }
    ],
    "neighborhood": "Putat Jaya, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMwrB5-z-4Lh3P4v7akGaq4OxhT3BQePhdnXrIX=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596276",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJGeSmp1v51y0RFyutEwermkE",
    "name": "Coffee Breng And Lounge",
    "address": "No., Jl. Widodaren No.18, RW.07, Sawahan, Kec. Sawahan, Surabaya, Jawa Timur 60251, Indonesia",
    "rating": "4.5",
    "reviewCount": 203,
    "placeId": "ChIJGeSmp1v51y0RFyutEwermkE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Coffee%20Breng%20And%20Lounge&query_place_id=ChIJGeSmp1v51y0RFyutEwermkE",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noZVN4CtgaTuTUqhFsxsIBP9y70YwyqN2SzVP0S-3OxT2WtzWi2SKQnuXoFFP5beie7enuO1bi-DTi9yd1k4a4v2_PNRUE83AWsm8QMuUlcDn8imIQrSVu0vhCo0ireJvN-sC46=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": false
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596289",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJKwB52A_51y0RhQa66yt2Z3E",
    "name": "Djavahaus Coffee and Eatery",
    "address": "Jl. Kedungsari No.82, Kedungdoro, Kec. Tegalsari, Surabaya, Jawa Timur 60261, Indonesia",
    "rating": "4.8",
    "reviewCount": 735,
    "placeId": "ChIJKwB52A_51y0RhQa66yt2Z3E",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Djavahaus%20Coffee%20and%20Eatery&query_place_id=ChIJKwB52A_51y0RhQa66yt2Z3E",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-6000-7345",
    "website": "http://www.djavahaus.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Kedungdoro, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noJCRyk_c1s19rugkjBpGhrvZh4KlmZx-pI_XluZ9B2vatNm21_FF_mtpNbninmMvjeZIxAR9O6o5CI19cjS4xW04UZVbtg8fjhkEzNHe-rTr9Gv2D7_B4tJGyt6O8BWxW0ZSUi2Q=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596315",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJI5l6gKD-1y0RV5GdOtknl_g",
    "name": "Affetto Gelato & Cafe",
    "address": "Jl. Raya Sukomanunggal Jaya No.2D 3, Sukomanunggal, Kec. Sukomanunggal, Surabaya, Jawa Timur 60188, Indonesia",
    "rating": "4.7",
    "reviewCount": 101,
    "placeId": "ChIJI5l6gKD-1y0RV5GdOtknl_g",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Affetto%20Gelato%20%26%20Cafe&query_place_id=ChIJI5l6gKD-1y0RV5GdOtknl_g",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-3982-8517",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "12 to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "12 to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "12 to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "12 to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "12 to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "12 to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "12 to 9 PM"
        }
      }
    ],
    "neighborhood": "Sukomanunggal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMmwPCNdL0MN4hzksT5iX5oQd7ibBywR_QT4Hfk=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.27,
      112.685
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596328",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ829qi-771y0REavtkYhbAWQ",
    "name": "Rolag Kopi Prapanca",
    "address": "Jl. Khairil Anwar No.15-19, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.4",
    "reviewCount": 6106,
    "placeId": "ChIJ829qi-771y0REavtkYhbAWQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rolag%20Kopi%20Prapanca&query_place_id=ChIJ829qi-771y0REavtkYhbAWQ",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 813-3290-5430",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noIojThzd8dlnoiTRXe1aREbPzmkADl5GLtNpUXrfkPRRbuk7hRSSYh_r4NS2HNU_JsY-0jcLq4AeC5xVBvYtGG1WQefqcthxoX0TNzOEHNDi3VMlJtnvXjl6-Czh31qKisFds=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596342",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJDZjI09X51y0R2KQwLsXRIpw",
    "name": "Demandailing Cafe n Eatery Tidar",
    "address": "Jl. Tidar No.67B, Sawahan, Kec. Sawahan, Surabaya, Jawa Timur 60251, Indonesia",
    "rating": "4.5",
    "reviewCount": 211,
    "placeId": "ChIJDZjI09X51y0R2KQwLsXRIpw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Demandailing%20Cafe%20n%20Eatery%20Tidar&query_place_id=ChIJDZjI09X51y0R2KQwLsXRIpw",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 35979069",
    "website": "http://instagram.com/demandailingcafe",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4no4vr7pV1z-eSTn5hkxAxCRNqOQTtMLuRCGuxOxFWx6pkLp49xFwR-1IAEfe-ghyAqXmhjNAGqFkPiUqBjSJ4WvalhHajDrCjt1ERSOsGaQYIJs9MSW05EjIKppgOQ4nWolI4qPMA=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596356",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJV3VE3O_71y0Ra3N5BO8t-s0",
    "name": "Rasa Baru Cafe & Resto",
    "address": "Jl. Khairil Anwar No.20, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.6",
    "reviewCount": 97,
    "placeId": "ChIJV3VE3O_71y0Ra3N5BO8t-s0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rasa%20Baru%20Cafe%20%26%20Resto&query_place_id=ChIJV3VE3O_71y0Ra3N5BO8t-s0",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 851-3337-0769",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM0YHc2oFq4M7KNDFd-Bw5no7-_EuEEOZXvsUDl=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596370",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJbSWd71X71y0RsSCxRSU2f7c",
    "name": "Andromeda Cafe",
    "address": "Jl. Kupang Gn. Tim. I No.24, Putat Jaya, Kec. Sawahan, Surabaya, Jawa Timur 60255, Indonesia",
    "rating": "4.7",
    "reviewCount": 87,
    "placeId": "ChIJbSWd71X71y0RsSCxRSU2f7c",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Andromeda%20Cafe&query_place_id=ChIJbSWd71X71y0RsSCxRSU2f7c",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-2677-7463",
    "website": "https://www.instagram.com/andromedacafe_",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 to 11:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "12 to 11:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "12 to 11:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 11:30 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 11:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "12 to 11:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "12 to 11:30 PM"
      }
    ],
    "neighborhood": "Putat Jaya, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOiD3Tlgfb4-zi_HJb8Cl1-dW-_5_5dYAitEjJX=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596383",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJkUsFJOf51y0Rl2yYpOMXN_E",
    "name": "Cafe Rooftop Mibimibi",
    "address": "Jl. Petemon 3 No. 136 Petemon, Lantai 4, belok KANAN, Kec. Sawahan, Surabaya, Jawa Timur 60252, Indonesia",
    "rating": "4.3",
    "reviewCount": 885,
    "placeId": "ChIJkUsFJOf51y0Rl2yYpOMXN_E",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20Rooftop%20Mibimibi&query_place_id=ChIJkUsFJOf51y0Rl2yYpOMXN_E",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 882-3130-0212",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "4 to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "4 to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "4 to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "4 to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "4 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "3 to 11 PM"
        }
      }
    ],
    "neighborhood": "belok KANAN, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipO0vx_rp5oxo1n7UFBF_N_88XDUTOUdbA4nkzQQ=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        },
        {
          "Takeout": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596396",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJt2kPHhb81y0R_LSixXwL1MA",
    "name": "Société Surabaya",
    "address": "Jl. Mayjen HR. Muhammad No.102, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60226, Indonesia",
    "rating": "4.6",
    "reviewCount": 3588,
    "placeId": "ChIJt2kPHhb81y0R_LSixXwL1MA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Soci%C3%A9t%C3%A9%20Surabaya&query_place_id=ChIJt2kPHhb81y0R_LSixXwL1MA",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 12 AM"
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMaTyDwezqetbJqsg3hgC7DznKIMD-Gcz6EZUqS=w408-h612-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "Unknown",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596667",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJNY4c7O391y0R8lLpphaK9QI",
    "name": "TITIK KUMPUL SURABAYA (WARKOP and CAFE)",
    "address": "Jl. Dukuh Kupang Utara I No.1 Blok 2, Putat Jaya, Kec. Sawahan, Surabaya, Jawa Timur 60225, Indonesia",
    "rating": "4.5",
    "reviewCount": 302,
    "placeId": "ChIJNY4c7O391y0R8lLpphaK9QI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=TITIK%20KUMPUL%20SURABAYA%20%28WARKOP%20and%20CAFE%29&query_place_id=ChIJNY4c7O391y0R8lLpphaK9QI",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-6455-9699",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Putat Jaya, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOC7bQjpm-NKG-Y-ZokGxe6Y0bF662RQJ-LtpwD=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596705",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJlQE9_I_91y0RZPNfC69XeXc",
    "name": "Creamson Cafe",
    "address": "Jl. Raya Darmo Harapan I Tierra Soho No.A 17, Tanjungsari, Kec. Sukomanunggal, Surabaya, Jawa Timur 60187, Indonesia",
    "rating": "5",
    "reviewCount": 405,
    "placeId": "ChIJlQE9_I_91y0RZPNfC69XeXc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Creamson%20Cafe&query_place_id=ChIJlQE9_I_91y0RZPNfC69XeXc",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 10 PM"
      }
    ],
    "neighborhood": "Tanjungsari, Sukomanunggal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPdycM9rvKlOwbg7xJ8Y1CulJWGXIPym5yaFH42=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.27,
      112.685
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596725",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJfxFklxL81y0R7zY1FJ_P-H4",
    "name": "DeMandailing Cafe",
    "address": "Ruko, Jl. Bukit Darmo Golf Jl. Putat Gede Timur No.1 1G, Putat Gede, Sukomanunggal, Surabaya, East Java 60189, Indonesia",
    "rating": "4.6",
    "reviewCount": 1638,
    "placeId": "ChIJfxFklxL81y0R7zY1FJ_P-H4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=DeMandailing%20Cafe&query_place_id=ChIJfxFklxL81y0R7zY1FJ_P-H4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 99146370",
    "website": "http://instagram.com/demandailingcafe",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Putat Gede, Sukomanunggal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPCCrLTFtcBwpSIUSs47d70yvqFt2a4NFdBsBvE=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.27,
      112.685
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596740",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ27FLG0__1y0RhcVwn4CZPiI",
    "name": "HUE Coffee",
    "address": "Jl. Darmo Harapan Utara VIII No.1, Tandes, Kec. Tandes, Surabaya, Jawa Timur 60187, Indonesia",
    "rating": "4.8",
    "reviewCount": 480,
    "placeId": "ChIJ27FLG0__1y0RhcVwn4CZPiI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=HUE%20Coffee&query_place_id=ChIJ27FLG0__1y0RhcVwn4CZPiI",
    "categories": [
      "Cafe",
      "Coffee shop",
      "Restaurant"
    ],
    "phone": "+62 812-4555-512",
    "website": "https://msha.ke/huecoffee.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 10:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 10:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 10:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 10:30 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 10:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 10:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 10:30 PM"
      }
    ],
    "neighborhood": "Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMzCg7GaP2LUqgPBcOA9mnm1tH1TwVgpMNC8-C3=w408-h544-k-no",
    "additionalInfo": {
      "From the business": [
        {
          "Identifies as women-owned": true
        }
      ],
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596755",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJweEV8Rb81y0RKXXblbbJ_yM",
    "name": "Monopole Coffee Lab",
    "address": "Jl. Raya Darmo Permai I No.38, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60226, Indonesia",
    "rating": "4.5",
    "reviewCount": 1921,
    "placeId": "ChIJweEV8Rb81y0RKXXblbbJ_yM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Monopole%20Coffee%20Lab&query_place_id=ChIJweEV8Rb81y0RKXXblbbJ_yM",
    "categories": [
      "Cafe",
      "Coffee shop",
      "Restaurant"
    ],
    "phone": "+62 811-3285-556",
    "website": "https://monopole.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "Closed"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 10 PM"
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": "Quaint coffeehouse serving eclectic global fare including Chinese, Indonesian & Western dishes.",
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMBUrbn23-an0A3OxtqTCHpqr1Xm5WBcQezd2Xk=w519-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.643Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596775",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ47MrfWr91y0Re0HX0Y1ENQ0",
    "name": "The Oak Tree Surabaya",
    "address": "Jl. Raya Darmo Permai I No.75, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60226, Indonesia",
    "rating": "4.7",
    "reviewCount": 216,
    "placeId": "ChIJ47MrfWr91y0Re0HX0Y1ENQ0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=The%20Oak%20Tree%20Surabaya&query_place_id=ChIJ47MrfWr91y0Re0HX0Y1ENQ0",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-3461-9056",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOdkiL3THwxNcLn6fWhF_r9FQP291jiQmKpFQ5i=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596793",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJaSxCoyX91y0RUj-XkjKji-o",
    "name": "️ Kollabora | The Best Thematic Cafe & Restaurant in Indonesia",
    "address": "Jl. Raya Kupang Indah No.51, Sonokwijenan, Kec. Sukomanunggal, Surabaya, Jawa Timur 60225, Indonesia",
    "rating": "4.7",
    "reviewCount": 1578,
    "placeId": "ChIJaSxCoyX91y0RUj-XkjKji-o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=%EF%B8%8F%20Kollabora%20%7C%20The%20Best%20Thematic%20Cafe%20%26%20Restaurant%20in%20Indonesia&query_place_id=ChIJaSxCoyX91y0RUj-XkjKji-o",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-3055-8888",
    "website": "https://kollabora.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Sonokwijenan, Sukomanunggal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPmdVcJaVvqpHvs8ZHcuo5N1LBmyPKQRQHykbcv=w408-h544-k-no",
    "additionalInfo": {
      "From the business": [
        {
          "Identifies as women-owned": true
        }
      ],
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.27,
      112.685
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596936",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJtfk1s9n91y0RssoOOlddQKM",
    "name": "NUSANTARA Coffee",
    "address": "Jl. Raya Sambikerep No.105, Sambikerep, Kec. Sambikerep, Surabaya, Jawa Timur 60217, Indonesia",
    "rating": "4.3",
    "reviewCount": 71,
    "placeId": "ChIJtfk1s9n91y0RssoOOlddQKM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=NUSANTARA%20Coffee&query_place_id=ChIJtfk1s9n91y0RssoOOlddQKM",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 853-3680-9603",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMlXzz_QRhPtp7P4r1ATWZIbGoo_HqZwteeS5Uo=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596980",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJj6RarPz91y0R9KOh_ifhtpc",
    "name": "Yoohoo Dessert",
    "address": "Plaza Graha Famili, Kompleks Ruko, C-25, Pradahkalikendal, Dukuhpakis, Surabaya, East Java 60226, Indonesia",
    "rating": "4",
    "reviewCount": 93,
    "placeId": "ChIJj6RarPz91y0R9KOh_ifhtpc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Yoohoo%20Dessert&query_place_id=ChIJj6RarPz91y0R9KOh_ifhtpc",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": "https://instagram.com/yoohoodesserts",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipORFr0GcMr8sI36KWDT71-_t8kvJiz9ymLx5nsL=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great dessert": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.596999",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJn2QFfwL71y0Rn341ekeTBaw",
    "name": "D'ADMIRAL Coffee & Eatery",
    "address": "Jl. Ketintang Baru III, Ketintang, Kec. Gayungan, Surabaya, Jawa Timur 60231, Indonesia",
    "rating": "4.7",
    "reviewCount": 102,
    "placeId": "ChIJn2QFfwL71y0Rn341ekeTBaw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=D%27ADMIRAL%20Coffee%20%26%20Eatery&query_place_id=ChIJn2QFfwL71y0Rn341ekeTBaw",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 to 11 AM"
        }
      }
    ],
    "neighborhood": "Ketintang, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npqcK5ms7C2y9WXLvAzCfEZF7-ks7vgURHpcf9s6XKe0Yuv2fg4FHTPXVZtKGl9FRgbmVMKaSlWzniW3GAWQfolW2ZwTd4l0yXcJm5pRhb3iDtMbGogKdTzcPXQeJ-_6wnGzb6G=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597018",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJqQZxFzb81y0RJ3r-Hy-XymA",
    "name": "Coffee TGC Loop",
    "address": "Loop Graha Family, Kondominium Graha Famili, Jl. Mayjend. Jonosewojo Stand No. 20, Jonosoewojo, Kec. Dukuhpakis, Surabaya, Jawa Timur 60216, Indonesia",
    "rating": "4.5",
    "reviewCount": 419,
    "placeId": "ChIJqQZxFzb81y0RJ3r-Hy-XymA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Coffee%20TGC%20Loop&query_place_id=ChIJqQZxFzb81y0RJ3r-Hy-XymA",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 823-3556-6772",
    "website": "http://www.coffeetgc.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 AM to 11:55 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 AM to 11:55 PM"
        }
      }
    ],
    "neighborhood": "Jonosoewojo, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOnIsmy8c_DvVPNHl-wMW6IAEAa2qpXG1WN6O-f=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        }
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597038",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJnQ8dVur71y0Rs03hD9iRFzU",
    "name": "Carpentier Kitchen",
    "address": "Jl. Untung Suropati No.83, DR. Soetomo, Kec. Tegalsari, Surabaya, Jawa Timur 60264, Indonesia",
    "rating": "4.6",
    "reviewCount": 2635,
    "placeId": "ChIJnQ8dVur71y0Rs03hD9iRFzU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Carpentier%20Kitchen&query_place_id=ChIJnQ8dVur71y0Rs03hD9iRFzU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3488-383",
    "website": "https://www.instagram.com/carpentierkitchen",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "1 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "DR. Soetomo, Tegalsari",
    "city": "Surabaya",
    "description": "International comfort food & coffees served in a laid-back cafe within a trendy clothes shop.",
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMU8zWFUGdH_-w5nNk_qQMz3Vr4RJ4jSEmmmseA=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Lunch reservations recommended": true
        },
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null,
        {
          "Valet parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597053",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJnR1SkB751y0RV4Y2ZZacGt8",
    "name": "Zaman Dulu Cafe",
    "address": "Jl. Perak Bar. No.71, RT.002/RW.12, Perak Bar., Kec. Krembangan, Surabaya, Jawa Timur 60177, Indonesia",
    "rating": "4.4",
    "reviewCount": 357,
    "placeId": "ChIJnR1SkB751y0RV4Y2ZZacGt8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Zaman%20Dulu%20Cafe&query_place_id=ChIJnR1SkB751y0RV4Y2ZZacGt8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-2020-2409",
    "website": "https://www.instagram.com/zamandulu.cafe/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "West Perak, Krembangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrLp1bviiVLDwjebpUzyIRP-3pFCU7ALxz-kLvPoFvT6kwyi0B4VLcmf89xXaRxbZ8AFUYIa3F_DesbZuzHl8rn8Fx0zq2vl8KAmV4-46YFG8Byr16B4xtrl6DMNcm823Qfis8=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Utara",
    "coordinates": [
      -7.248,
      112.725
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597069",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJI6zYPtr71y0Rdboo0EpKy40",
    "name": "BARA CAFE",
    "address": "Jl. Pagesangan Baru VIII No.1, Pagesangan, Kec. Jambangan, Surabaya, Jawa Timur 60232, Indonesia",
    "rating": "4.7",
    "reviewCount": 1954,
    "placeId": "ChIJI6zYPtr71y0Rdboo0EpKy40",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=BARA%20CAFE&query_place_id=ChIJI6zYPtr71y0Rdboo0EpKy40",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-1595-3377",
    "website": "https://instagram.com/baracafe.sub?igshid=rx0wwsq78emf",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 11:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Pagesangan, Jambangan",
    "city": "Surabaya",
    "description": "Airy, brick-lined venue offering rice bowls, spaghetti & chicken mentai, plus ice-cream desserts.",
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMb8AKBLWewpf-vbajjYmizB9HxFmguJWniCCqd=w432-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597087",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJiXgYY3j51y0R1KJeN5u-I5Y",
    "name": "EMAK KU Coffee Shop",
    "address": "Jl. Jolotundo Baru No.10, Pacar Keling, Kec. Tambaksari, Surabaya, Jawa Timur 60131, Indonesia",
    "rating": "4.3",
    "reviewCount": 435,
    "placeId": "ChIJiXgYY3j51y0R1KJeN5u-I5Y",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=EMAK%20KU%20Coffee%20Shop&query_place_id=ChIJiXgYY3j51y0R1KJeN5u-I5Y",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-5237-2245",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Pacar Keling, Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipODcgFmA9qxMr_0YvgdnywIjAmRtOTpeD6Gk0wQ=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.252,
      112.765
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597103",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJdVlD8cn71y0RJMB3p6Y1p6s",
    "name": "Kopi Vator",
    "address": "No Jl. Pucang Anom Timur III No.7, Kertajaya, Kec. Gubeng, Surabaya, Jawa Timur 60282, Indonesia",
    "rating": "4.7",
    "reviewCount": 142,
    "placeId": "ChIJdVlD8cn71y0RJMB3p6Y1p6s",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Vator&query_place_id=ChIJdVlD8cn71y0RJMB3p6Y1p6s",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3239-5500",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "5:30 PM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "5:30 PM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "5:30 PM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "5:30 PM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "5:30 PM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "5:30 PM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "Kertajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqoyAz58c0j2igynYa-7_eqf_PI4hAAsAMcZ7MjY0o0rDuz5NFuAwKTv-vEMcrqnVwdUsB88mAj2cT99n8-b-1KF5QLKaZ6db8yupIHPf2zm_s2OXJ_4ULv0Dn_5Qso9-8FunSA=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597116",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJs1sf7I_71y0R_5XJjaHuQME",
    "name": "Pernah Dekat",
    "address": "Jl. Raya Manyar No.29, Menur Pumpungan, Kec. Sukolilo, Surabaya, Jawa Timur 60284, Indonesia",
    "rating": "4.6",
    "reviewCount": 91,
    "placeId": "ChIJs1sf7I_71y0R_5XJjaHuQME",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Pernah%20Dekat&query_place_id=ChIJs1sf7I_71y0R_5XJjaHuQME",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 822-8998-8224",
    "website": "https://www.instagram.com/pernahdekat.sby?igsh=MXJnZHpkc3J4eTJ2aA==",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 2 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 2 AM"
        }
      }
    ],
    "neighborhood": "Menur Pumpungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipO2LKyAUwFI7LF1nH2IGOt-bHu-xaXiWYqEqIHL=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597130",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ_ZKGBQz51y0RVboSYJ7pPGA",
    "name": "Ronde Jl. Kenjeran",
    "address": "Jl. Kenjeran No.91, Gading, Kec. Tambaksari, Surabaya, Jawa Timur 60134, Indonesia",
    "rating": "4.6",
    "reviewCount": 191,
    "placeId": "ChIJ_ZKGBQz51y0RVboSYJ7pPGA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Ronde%20Jl.%20Kenjeran&query_place_id=ChIJ_ZKGBQz51y0RVboSYJ7pPGA",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 PM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 PM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 PM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 PM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 PM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 PM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 PM to 12 AM"
        }
      }
    ],
    "neighborhood": "Gading, Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nohDMfm-uMkbf8IS8KgvT_ytvjQh8w8yK33UdfQM7DXhynuiFlpF4XP9xmUxaXHPQPvFaRCsR7A-uOWVXZJ8_1es4JyEiBosoFDvLTzgxNcJ98Va2dupjyj5gzBlOq31ikf4yi-wA=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.252,
      112.765
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597146",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJK0UirlT71y0RiRWHaqVXogk",
    "name": "Mokhabika Coffee",
    "address": "Ruko RMI, Jl. Ngagel Jaya Sel. No.33 blok l, Baratajaya, Gubeng, Surabaya, East Java 60284, Indonesia",
    "rating": "4.7",
    "reviewCount": 261,
    "placeId": "ChIJK0UirlT71y0RiRWHaqVXogk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Mokhabika%20Coffee&query_place_id=ChIJK0UirlT71y0RiRWHaqVXogk",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-303-518",
    "website": "http://www.ptmma.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 5 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 5 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 5 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 5 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 5 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 3 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "Baratajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPP2HmcHdBXdrh7zfKa92qyb-7m1HSRp9mP3Npu=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        }
      ],
      "Accessibility": [
        {
          "Assistive hearing loop": false
        },
        {
          "Wheelchair accessible restroom": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597161",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJy0-6TBn51y0R6Arzs6Oa1v0",
    "name": "Warkop Sarkam",
    "address": "Jl. Nyamplungan No.97, Ampel, Kec. Semampir, Surabaya, Jawa Timur 60151, Indonesia",
    "rating": "4.7",
    "reviewCount": 255,
    "placeId": "ChIJy0-6TBn51y0R6Arzs6Oa1v0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Sarkam&query_place_id=ChIJy0-6TBn51y0R6Arzs6Oa1v0",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 857-9042-3595",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Ampel, Semampir",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPB9iPq6zeUCgUmVe7lw0LRKSmtTPXJyAlWuU-4=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": false
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        },
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.235,
      112.745
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597176",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJpxSDgd751y0RnrmuLoa18O0",
    "name": "Kedai Roemah Akiq",
    "address": "Jl. Sidotopo Lor No.57, Sidotopo, Kec. Semampir, Surabaya, Jawa Timur 60152, Indonesia",
    "rating": "4.4",
    "reviewCount": 81,
    "placeId": "ChIJpxSDgd751y0RnrmuLoa18O0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Roemah%20Akiq&query_place_id=ChIJpxSDgd751y0RnrmuLoa18O0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 838-8135-306",
    "website": "https://instagram.com/roemah_akiq?igshid=NzZlODBkYWE4Ng==&utm_source=qr",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "1 to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "1 to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "1 to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "1 to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "1 to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "1 to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "1 to 10 PM"
        }
      }
    ],
    "neighborhood": "Sidotopo, Semampir",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMNzCjyjCiN8MRr4da2jodpYkPtSjaqFUEz1ZKv=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Utara",
    "coordinates": [
      -7.235,
      112.745
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597249",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJpzwZXAD51y0R_BER04JdVdk",
    "name": "Rumah Oma",
    "address": "Jl. Achmad Jais No.124, Peneleh, Kec. Genteng, Surabaya, Jawa Timur 60274, Indonesia",
    "rating": "4.8",
    "reviewCount": 98,
    "placeId": "ChIJpzwZXAD51y0R_BER04JdVdk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rumah%20Oma&query_place_id=ChIJpzwZXAD51y0R_BER04JdVdk",
    "categories": [
      "Bakery",
      "Cafe"
    ],
    "phone": "+62 812-1616-8015",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "2 to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "2 to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "2 to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "2 to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "2 to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "Peneleh, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOSLxa6yrPb9pzNGefGcnZpoyXqaWXtLKDBnhVt=w408-h550-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "In-store pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Same-day delivery": true
        }
      ],
      "Planning": [
        {
          "Quick visit": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597266",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJHQtxpE361y0RIQ86qxjv8l4",
    "name": "Kedai De'Lentera",
    "address": "Jl. Manyar Rejo No.46, Menur Pumpungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.4",
    "reviewCount": 130,
    "placeId": "ChIJHQtxpE361y0RIQ86qxjv8l4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20De%27Lentera&query_place_id=ChIJHQtxpE361y0RIQ86qxjv8l4",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 31 5946616",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "Menur Pumpungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrJgW69oHmkUvA_T2Zo79N0qw_puOwCIR68zJEK0SGhjOgpyvfitXBvEUIpKY_A03zzRjV6hsuJrHkhtQQeUcUDaf4emIESdvJWRLMmF3fzL1DF0Qo_WdzVPJLDo3oSYvAdcpagWw=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597283",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJqZmzL7z71y0Rtc9dQk2BDQs",
    "name": "Kafe GUNOZ",
    "address": "Jl. Ngagel No.152, Ngagel, Kec. Wonokromo, Surabaya, Jawa Timur 60245, Indonesia",
    "rating": "4.3",
    "reviewCount": 179,
    "placeId": "ChIJqZmzL7z71y0Rtc9dQk2BDQs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kafe%20GUNOZ&query_place_id=ChIJqZmzL7z71y0Rtc9dQk2BDQs",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 898-1563-143",
    "website": "https://www.instagram.com/angkringan_rakyatsub?igsh=MW9vZDZtcWtucTNkdg==",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6:30 PM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6:30 PM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6:30 PM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6:30 PM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6:30 PM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6:30 PM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6:30 PM to 12 AM"
        }
      }
    ],
    "neighborhood": "Ngagel, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOYb2n7XIWj9tI-e1HdCC5BMV-iwf7kLfWlFwYz=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597300",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJOf7_lLv71y0R-QL8wuHOY5I",
    "name": "STMJ Bu Nunuk - Pojok Ngagel",
    "address": "Jl. Bung Tomo No.39, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "4.4",
    "reviewCount": 1767,
    "placeId": "ChIJOf7_lLv71y0R-QL8wuHOY5I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=STMJ%20Bu%20Nunuk%20-%20Pojok%20Ngagel&query_place_id=ChIJOf7_lLv71y0R-QL8wuHOY5I",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 856-4535-4436",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "5 PM to 2 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "5 PM to 2 AM"
        }
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": "Traditional Javanese dishes & milk drinks offered in roomy, simple quarters with an industrial vibe.",
    "imageUrl": "https://lh3.googleusercontent.com/gps-proxy/ALd4DhHYBWXEXBtP7IOVgLH9anV9JW4KLUPGvLkPDYbdtN0QENtvxs_szeHBLWrYNjn9cVQQ-pgB_R6fWuuPaKAtwfx8BADbTM8OPwUP4swf-1Z6DCBNOF4KOe7I3oeUYg2apECQ-P5xCyWRggeGbMTQqp60nJtqCPUrtR8ihTIDQFUnZvHvZe-K6UnrZhS1ykZ-Ymw3rA=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        },
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597314",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJyWr1hlf51y0R2gqIg5gukAA",
    "name": "Warkop TS Corner",
    "address": "Jl. Teluk Sampit No.1, Perak Utara, Kec. Pabean Cantikan, Surabaya, Jawa Timur 60165, Indonesia",
    "rating": "4.5",
    "reviewCount": 124,
    "placeId": "ChIJyWr1hlf51y0R2gqIg5gukAA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20TS%20Corner&query_place_id=ChIJyWr1hlf51y0R2gqIg5gukAA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 3281669",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "North Perak, Pabean Cantikan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noyLwnJ9zKPwZCM0BulyysC2MajQnh4keDrXRO-Qk9peSzufrzGWPakPLv5oXYGFnLvPWe_gCXDpXBbNbc4uBVOnIDgjH_ZpxcKWs4vte6HBfQ9pXtlwacprkroptRGyRCNbywy=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.735
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597329",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJDV5VFpv51y0RplxZA6-TKCI",
    "name": "Petekan Riverside",
    "address": "Jl. Kalimas Baru No.22, Perak Utara, Kec. Pabean Cantikan, Surabaya, Jawa Timur 60165, Indonesia",
    "rating": "4.5",
    "reviewCount": 307,
    "placeId": "ChIJDV5VFpv51y0RplxZA6-TKCI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Petekan%20Riverside&query_place_id=ChIJDV5VFpv51y0RplxZA6-TKCI",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 9:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 9:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 9:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 9:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 9:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 9:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 9:30 PM"
        }
      }
    ],
    "neighborhood": "North Perak, Pabean Cantikan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noEachs-mBCPRiQ1cx-W7iTxBZoaRME7wT5BsPEQshOI7haVAZU6njRiouLzZlip2MrxG5_8Blz4ojhboFyP_nd15xfMfz90d6uDCOoGfNqqiNlNcGCV5USaM90I9O0iZwV6jPj=w408-h271-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.735
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597347",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJqY1xVMb41y0Rqa8ha7Xs0Vw",
    "name": "Cafe Pisang - RS PHC",
    "address": "QPRP+36J, Jl. Prapat Kurung Selatan, Perak Utara, Kec. Pabean Cantikan, Surabaya, Jawa Timur 60165, Indonesia",
    "rating": "4",
    "reviewCount": 105,
    "placeId": "ChIJqY1xVMb41y0Rqa8ha7Xs0Vw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20Pisang%20-%20RS%20PHC&query_place_id=ChIJqY1xVMb41y0Rqa8ha7Xs0Vw",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 8:30 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 9 PM"
      }
    ],
    "neighborhood": "North Perak, Pabean Cantikan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNM7Uw5UXWqnZ5DrhHDD6FBOxBDrinvAWXK1a2I=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.735
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597363",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJlTzlnMn71y0RyozRabLVEHE",
    "name": "Sermo Cafe",
    "address": "Jl. Sidosermo Pd. I No.156, Sidosermo, Kec. Wonocolo, Surabaya, Jawa Timur 60239, Indonesia",
    "rating": "4.5",
    "reviewCount": 95,
    "placeId": "ChIJlTzlnMn71y0RyozRabLVEHE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Sermo%20Cafe&query_place_id=ChIJlTzlnMn71y0RyozRabLVEHE",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-1100-5885",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Sidosermo, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMw5KDhpFVrZSIiBaQ8C_dOhZbwEAFp_t96dQmC=w408-h510-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597381",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJsd30WZ771y0R_oglc2Fv_dY",
    "name": "Starbucks Coffee - Jemursari Timur",
    "address": "MPHW+GFW, Jl. Jemursari Tim. II, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.6",
    "reviewCount": 1089,
    "placeId": "ChIJsd30WZ771y0R_oglc2Fv_dY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Starbucks%20Coffee%20-%20Jemursari%20Timur&query_place_id=ChIJsd30WZ771y0R_oglc2Fv_dY",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 31 99856723",
    "website": "http://www.starbucks.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 10 PM"
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMWKEcHu1cjP9N11T9QKnWU6WP4zNrCMKNKD_Xn=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.294,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597395",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_verified": false,
    "coordinates_estimated": true
  },
  {
    "id": "ChIJnwz2fuL61y0Ryo6BMwZyaVg",
    "name": "Angling Darmo Coffee Shop",
    "address": "Jl. Raya Tenggilis Mejoyo No.2 B-C 04, Tenggilis Mejoyo, Kec. Wonokromo, Surabaya, Jawa Timur 60293, Indonesia",
    "rating": "4.5",
    "reviewCount": 309,
    "placeId": "ChIJnwz2fuL61y0Ryo6BMwZyaVg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Angling%20Darmo%20Coffee%20Shop&query_place_id=ChIJnwz2fuL61y0Ryo6BMwZyaVg",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Tenggilis Mejoyo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOnPx37I-9eX0PxzEKlzdQby2NRo8tRbXSUPBQk=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597410",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJG2HVxEr71y0R3X68CwSSNPs",
    "name": "Kedai Semoga Sukses",
    "address": "Jl. Raya Tenggilis No.64, Kendangsari, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60292, Indonesia",
    "rating": "4.6",
    "reviewCount": 860,
    "placeId": "ChIJG2HVxEr71y0R3X68CwSSNPs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Semoga%20Sukses&query_place_id=ChIJG2HVxEr71y0R3X68CwSSNPs",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 1 AM"
      }
    ],
    "neighborhood": "Kendangsari, Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOKdKgfT6Z8J1Thh4ntfeA1xbparXDCE98rnz3h=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597425",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJM4G4PPz71y0R8JKt63fDB5s",
    "name": "Tellu Kopi",
    "address": "Jl. Ngagel Jaya Tengah No.65a, Baratajaya, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "4.8",
    "reviewCount": 127,
    "placeId": "ChIJM4G4PPz71y0R8JKt63fDB5s",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tellu%20Kopi&query_place_id=ChIJM4G4PPz71y0R8JKt63fDB5s",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-3993-1746",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10:30 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10:30 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10:30 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10:30 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "1 to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10:30 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10:30 AM to 10 PM"
      }
    ],
    "neighborhood": "Baratajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOJfhG9h_9DDCV5UsKcHNDydcuIb_K3gHZ2najV=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597438",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ95NZRKP71y0RiTT7EskTb8U",
    "name": "MOJAKO CAFE - MERR",
    "address": "Jl. Semampir Tengah IV A, Medokan Semampir, Kec. Sukolilo, Surabaya, Jawa Timur 60119, Indonesia",
    "rating": "4.5",
    "reviewCount": 659,
    "placeId": "ChIJ95NZRKP71y0RiTT7EskTb8U",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=MOJAKO%20CAFE%20-%20MERR&query_place_id=ChIJ95NZRKP71y0RiTT7EskTb8U",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 821-1992-9966",
    "website": "https://www.instagram.com/mojako.id/?hl=en",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "5 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "5 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "5 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "5 PM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "12 AM to 12 PM, 5 to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "5 PM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "5 PM to 12 AM"
      }
    ],
    "neighborhood": "Medokan Semampir, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipP4P5S5uQCDrxIX1KdM8XrYm4hywvE0n9hvNtic=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597453",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJGzG8LnD71y0RvUAwIaQWY2Q",
    "name": "TYE Coffee House",
    "address": "Jl. Semolo Waru No.4, Medokan Semampir, Kec. Sukolilo, Surabaya, Jawa Timur 60119, Indonesia",
    "rating": "4.5",
    "reviewCount": 514,
    "placeId": "ChIJGzG8LnD71y0RvUAwIaQWY2Q",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=TYE%20Coffee%20House&query_place_id=ChIJGzG8LnD71y0RvUAwIaQWY2Q",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": null,
    "website": "https://www.instagram.com/tye.coffeehouse/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 11 PM"
      }
    ],
    "neighborhood": "Medokan Semampir, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN921L6DU-8RhRWcoeueroYuHpiH8Sf6FMEWaRt=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597468",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJrTtmr6r71y0RgqO3b6xqFlc",
    "name": "STMJ Bu mun",
    "address": "Jalan Nginden Raya No.135 B, Nginden Jangkungan, Kec. Sukolilo, Surabaya, Jawa Timur 60284, Indonesia",
    "rating": "4.6",
    "reviewCount": 1050,
    "placeId": "ChIJrTtmr6r71y0RgqO3b6xqFlc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=STMJ%20Bu%20mun&query_place_id=ChIJrTtmr6r71y0RgqO3b6xqFlc",
    "categories": [
      "Cafe",
      "Art cafe"
    ],
    "phone": "+62 857-3070-0081",
    "website": "http://www.instagram.com/stmjbumunsurabaya",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Ngenden Jangkungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNn2LJ8VNVHHh2pYe95yRZwRI6tq6bYuk7taix2=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        },
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597482",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJF1hrVXz71y0R_JBdTlKZQWk",
    "name": "EASTBOSS",
    "address": "Jl. Arief Rahman Hakim No.45A, Klampis Ngasem, Kec. Sukolilo, Surabaya, Jawa Timur 60117, Indonesia",
    "rating": "4.6",
    "reviewCount": 110,
    "placeId": "ChIJF1hrVXz71y0R_JBdTlKZQWk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=EASTBOSS&query_place_id=ChIJF1hrVXz71y0R_JBdTlKZQWk",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 10 PM"
      }
    ],
    "neighborhood": "Klampis Ngasem, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPRV_u2lmUR80WLsGPYNEFhkJ99PWFcmmE0CnRs=w408-h545-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597496",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJvyRDbqn71y0RcLUExTFBJTU",
    "name": "Kopi Soe Ubaya",
    "address": "Tenggilis Mejoyo Blok AN 25, Kali Rungkut, Kec. Rungkut, Surabaya, Jawa Timur 60293, Indonesia",
    "rating": "4.6",
    "reviewCount": 221,
    "placeId": "ChIJvyRDbqn71y0RcLUExTFBJTU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Soe%20Ubaya&query_place_id=ChIJvyRDbqn71y0RcLUExTFBJTU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 817-1780-8383",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 10 PM"
      }
    ],
    "neighborhood": "Kali Rungkut, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNL9jZhOMqR75eosbStcJawy79HnkJ3f0R1j31K=w408-h543-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597511",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJn6S2EUz71y0R_EqJuichmsg",
    "name": "Patera",
    "address": "Jl. Manyar Indah IX No.1, RT.003/RW.06, Menur Pumpungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.8",
    "reviewCount": 137,
    "placeId": "ChIJn6S2EUz71y0R_EqJuichmsg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Patera&query_place_id=ChIJn6S2EUz71y0R_EqJuichmsg",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": "http://www.instagram.com/patera_co",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "2 to 11 PM"
      }
    ],
    "neighborhood": "Menur Pumpungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNF7vzd483wbrO_x4sRnv6WFfF4qfKX635lzDZT=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597526",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ9wTqYRr71y0RpCUxmPkClro",
    "name": "NESC COFFEE",
    "address": "Jl. Ngagel Tim. No.32, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60243, Indonesia",
    "rating": "4.8",
    "reviewCount": 364,
    "placeId": "ChIJ9wTqYRr71y0RpCUxmPkClro",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=NESC%20COFFEE&query_place_id=ChIJ9wTqYRr71y0RpCUxmPkClro",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-3274-3500",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "3 PM to 3 AM"
      },
      {
        "day": "Thursday",
        "hours": "3 PM to 3 AM"
      },
      {
        "day": "Friday",
        "hours": "3 PM to 3 AM"
      },
      {
        "day": "Saturday",
        "hours": "3 PM to 3 AM"
      },
      {
        "day": "Sunday",
        "hours": "3 PM to 3 AM"
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMCIsT0Tb-m0ZRgOBzTFAm3OmkPvvSMcAJ-U0rP=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking garage": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null,
        {
          "Valet parking": true
        }
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597541",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ7U5qS7T71y0RYnc3tw937NE",
    "name": "D'Coffee Cup",
    "address": "Ngagel Jaya Selatan St No.63, Pucang Sewu, Gubeng, Surabaya, East Java 60000, Indonesia",
    "rating": "3.9",
    "reviewCount": 1163,
    "placeId": "ChIJ7U5qS7T71y0RYnc3tw937NE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=D%27Coffee%20Cup&query_place_id=ChIJ7U5qS7T71y0RYnc3tw937NE",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": "https://dcoffeecup.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOsp3Rk6nC12d7Z6hq8Mg3s-pP_3z2LV8JFtpMX=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Rooftop seating": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Assistive hearing loop": false
        },
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597556",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ6cNnqHL51y0Rwp_tgSUWXFY",
    "name": "DANNBAM COFFEE SURABAYA",
    "address": "Jl. Makam Peneleh No.77, Peneleh, Kec. Genteng, Surabaya, Jawa Timur 60274, Indonesia",
    "rating": "5",
    "reviewCount": 83,
    "placeId": "ChIJ6cNnqHL51y0Rwp_tgSUWXFY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=DANNBAM%20COFFEE%20SURABAYA&query_place_id=ChIJ6cNnqHL51y0Rwp_tgSUWXFY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-1958-5729",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "12 AM to 12 PM, 3 PM to 12 AM"
      }
    ],
    "neighborhood": "Peneleh, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOa6st_SZhDW3P17eRwjpRWfNB8pvMdb1UcMvPs=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597569",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ-eo7mbP51y0RKtAkma1vob4",
    "name": "Fifteenth Coffee Kota Lama Surabaya",
    "address": "Jl. Mliwis No.9, Krembangan Sel., Kec. Krembangan, Surabaya, Jawa Timur 60175, Indonesia",
    "rating": "4.8",
    "reviewCount": 177,
    "placeId": "ChIJ-eo7mbP51y0RKtAkma1vob4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Fifteenth%20Coffee%20Kota%20Lama%20Surabaya&query_place_id=ChIJ-eo7mbP51y0RKtAkma1vob4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-6513-8771",
    "website": "https://fifteenth.markdesign.net/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "3 PM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "1 PM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 12 AM"
      }
    ],
    "neighborhood": "South Krembangan, Krembangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMxGDb17pUmsPTypGdBT41HqgfnEqb_JQRoMGMu=w408-h613-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.248,
      112.725
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597585",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJTULir3D51y0RvAUn5YfGvDs",
    "name": "Bunda Cafe",
    "address": "Jl. Teratai R No.7, Tambaksari, Kec. Tambaksari, Surabaya, Jawa Timur 60131, Indonesia",
    "rating": "4.4",
    "reviewCount": 204,
    "placeId": "ChIJTULir3D51y0RvAUn5YfGvDs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Bunda%20Cafe&query_place_id=ChIJTULir3D51y0RvAUn5YfGvDs",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "6 AM to 2 AM"
      },
      {
        "day": "Tuesday",
        "hours": "6 AM to 2 AM"
      },
      {
        "day": "Wednesday",
        "hours": "6 AM to 2 AM"
      },
      {
        "day": "Thursday",
        "hours": "6 AM to 2 AM"
      },
      {
        "day": "Friday",
        "hours": "6 AM to 2 AM"
      },
      {
        "day": "Saturday",
        "hours": "6 AM to 2 AM"
      },
      {
        "day": "Sunday",
        "hours": "6 AM to 2 AM"
      }
    ],
    "neighborhood": "Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB-HaRdY3o7sxHaQhh_fi_LUTNZNeJYPwWHT9ej17wahA4G_b-rlSyT0QNn7QeA2EQ1QZ2y7tuyTylpTHC0S8KRjz6ocPeJ0bR-rM9KrAf9K5uEHcAY0DizTBkpAVaz7nVSt_YT_=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.252,
      112.765
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597610",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ16NoeYP71y0R7QabkugaKUk",
    "name": "Fudgybro Surabaya at Pasar Tunjungan",
    "address": "Ps. Tunjungan, Jl. Embong Malang unit 17, Genteng, Kec. Genteng, Surabaya, Jawa Timur 60264, Indonesia",
    "rating": "4.7",
    "reviewCount": 397,
    "placeId": "ChIJ16NoeYP71y0R7QabkugaKUk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Fudgybro%20Surabaya%20at%20Pasar%20Tunjungan&query_place_id=ChIJ16NoeYP71y0R7QabkugaKUk",
    "categories": [
      "Dessert shop",
      "Cafe",
      "Chocolate shop",
      "Ice cream shop",
      "Restaurant"
    ],
    "phone": "+62 856-9366-8362",
    "website": "https://linktr.ee/fudgybro",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 to 8:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "12 to 8:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "12 to 8:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "12 to 8:30 PM"
      },
      {
        "day": "Friday",
        "hours": "1 to 8:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "12 to 9:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "12 to 9:30 PM"
      }
    ],
    "neighborhood": "Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPoWR1NK7g_PPCvIgCy9ZobHZqGMXVvJ99zCTSZ=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "In-store pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Same-day delivery": true
        }
      ],
      "Planning": [
        {
          "Quick visit": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597624",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJJ9baxu771y0RhpXCcxTCb5c",
    "name": "Asana kopi",
    "address": "Ruko Manyar garden, Jl. Nginden Semolo No.101/26, Menur Pumpungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.7",
    "reviewCount": 185,
    "placeId": "ChIJJ9baxu771y0RhpXCcxTCb5c",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Asana%20kopi&query_place_id=ChIJJ9baxu771y0RhpXCcxTCb5c",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Menur Pumpungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB9PAn7-0b0HW5KMUmCVraQWnkCe15e983jwrKk_miV4gzsMiXB4VIH2kXV88gPP7_NzFX0Ec1R1999KT7siTB7PMqa-ll0L1_D8gk1VFPUEuJERx5d-_vPQOIz_rTvPoYKI_285=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597639",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ2T0y4bb71y0R2kXSGuBGaH0",
    "name": "Re'solusi Kopi",
    "address": "Jl. Medokan Semampir AWS No.6, RT.005/RW.04, Medokan Semampir, Kec. Sukolilo, Surabaya, Jawa Timur 60119, Indonesia",
    "rating": "4.6",
    "reviewCount": 131,
    "placeId": "ChIJ2T0y4bb71y0R2kXSGuBGaH0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Re%27solusi%20Kopi&query_place_id=ChIJ2T0y4bb71y0R2kXSGuBGaH0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 817-7500-0573",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Medokan Semampir, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNIKCcWc-61VXJQqe2dxV0hsy1pI2keGV5vzEGm=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597654",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJpXBn5VP61y0RNlb-GsF-sGo",
    "name": "Pohon Kopi",
    "address": "Jl. Manyar Jaya V No.A27/1, Menur Pumpungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.5",
    "reviewCount": 734,
    "placeId": "ChIJpXBn5VP61y0RNlb-GsF-sGo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Pohon%20Kopi&query_place_id=ChIJpXBn5VP61y0RNlb-GsF-sGo",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Menur Pumpungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM3nvQFjKozIEu31U53MdZ_oITYMu3prUGmKyQ3=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597668",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJO5mvpcb71y0RNgCTjg1AEi4",
    "name": "Meet Garden (MG) Cafe & Resto",
    "address": "Jl. Dr. Ir. H. Soekarno No.307, Kedung Baruk, Kec. Rungkut, Surabaya, Jawa Timur 60298, Indonesia",
    "rating": "4.5",
    "reviewCount": 227,
    "placeId": "ChIJO5mvpcb71y0RNgCTjg1AEi4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Meet%20Garden%20%28MG%29%20Cafe%20%26%20Resto&query_place_id=ChIJO5mvpcb71y0RNgCTjg1AEi4",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 881-5082-177",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 AM to 5 PM"
      },
      {
        "day": "Tuesday",
        "hours": "12 to 3 PM, 5 to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "12 to 3 PM, 5 to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "12 to 3 PM, 5 to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "12 to 3 PM, 5 PM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "12 to 3 PM, 5 PM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "12 to 3 PM, 5 PM to 12 AM"
      }
    ],
    "neighborhood": "Kedung Baruk, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNoHtbXeXwioK_pG9DU_scYl4cohmGzSnMp6Yrf=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597683",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ4RHnD8f71y0RN-Nb-2gxVP0",
    "name": "Rakki Koffie - Ngagel Surabaya",
    "address": "No.133-C, Jl. Ngagel, Ngagel, Kec. Wonokromo, Surabaya, Jawa Timur 60246, Indonesia",
    "rating": "4.5",
    "reviewCount": 80,
    "placeId": "ChIJ4RHnD8f71y0RN-Nb-2gxVP0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rakki%20Koffie%20-%20Ngagel%20Surabaya&query_place_id=ChIJ4RHnD8f71y0RN-Nb-2gxVP0",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-1672-4572",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 11:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 11:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 11:30 PM"
      }
    ],
    "neighborhood": "Ngagel, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMRFc8FR9hhR5CU0Qjgm9JBq0A2xeef56VeEywE=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597698",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJfTLeKoL71y0RZ8wu5060Ges",
    "name": "Skut Cafe",
    "address": "Jl. Sidosermo II Airdas No.11, Sidosermo, Kec. Wonocolo, Surabaya, Jawa Timur 60239, Indonesia",
    "rating": "4.6",
    "reviewCount": 86,
    "placeId": "ChIJfTLeKoL71y0RZ8wu5060Ges",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Skut%20Cafe&query_place_id=ChIJfTLeKoL71y0RZ8wu5060Ges",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-4478-2435",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 1 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 1 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 1 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 1 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Sunday",
        "hours": "4 PM to 1 AM"
      }
    ],
    "neighborhood": "Sidosermo, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPuK0MOLwwsdlKDbwe8LfLVPrjOwIO0WlHbPfo=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597716",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJj5AVwr371y0RrhbkbypPBy0",
    "name": "Kopi Titik Koma Tenggilis",
    "address": "Jl. Rungkut Mejoyo Utara No.61, Kali Rungkut, Kec. Rungkut, Surabaya, Jawa Timur 60293, Indonesia",
    "rating": "4.5",
    "reviewCount": 749,
    "placeId": "ChIJj5AVwr371y0RrhbkbypPBy0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Titik%20Koma%20Tenggilis&query_place_id=ChIJj5AVwr371y0RrhbkbypPBy0",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 811-3210-048",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 11 PM"
      }
    ],
    "neighborhood": "Kali Rungkut, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM-aCNsbDY_yBxeHAir80iU7XwjSQq8QKmd5wkH=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible seating": true
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597731",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ3U38U_n71y0RMyy6eNyYKSo",
    "name": "Slice n Sip",
    "address": "Jl. Nginden Intan Sel. No.65, Nginden Jangkungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.9",
    "reviewCount": 506,
    "placeId": "ChIJ3U38U_n71y0RMyy6eNyYKSo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Slice%20n%20Sip&query_place_id=ChIJ3U38U_n71y0RMyy6eNyYKSo",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3518-233",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 10 PM"
      }
    ],
    "neighborhood": "Ngenden Jangkungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNBOIPkpcMLstgR5ApreUEJS3mtBFVl5VWQXUIg=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "On-site parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597746",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJlWd7NTn71y0RNvgMz-Bh-5o",
    "name": "Warung Sekawan",
    "address": "Jl. Srikana Tim. No.44, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60286, Indonesia",
    "rating": "4.7",
    "reviewCount": 125,
    "placeId": "ChIJlWd7NTn71y0RNvgMz-Bh-5o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warung%20Sekawan&query_place_id=ChIJlWd7NTn71y0RNvgMz-Bh-5o",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3174-6479",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "Closed"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 11 PM"
      }
    ],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMLWKz5KJAfo-GGlg_Fm3YSPYmlzNTsPCysYVVv=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Accessibility": [
        {
          "Assistive hearing loop": false
        },
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible restroom": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597759",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJqc4EmE_71y0RK4SripuuUCg",
    "name": "Kedai ORI Manyar",
    "address": "Jl. Manyar Tirtoyoso No.90, Manyar Sabrangan, Kec. Mulyorejo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.4",
    "reviewCount": 536,
    "placeId": "ChIJqc4EmE_71y0RK4SripuuUCg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20ORI%20Manyar&query_place_id=ChIJqc4EmE_71y0RK4SripuuUCg",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 11 PM"
      }
    ],
    "neighborhood": "Manyar Sabrangan, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN-h2V2nDflSc4Q4lvJ-7-Famzk0MmsTI7YZM8=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597775",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJs7nVbBb51y0Rh-NgWY5J0BI",
    "name": "LODJI BESAR",
    "address": "Jl. Makam Peneleh No.46, Peneleh, Kec. Genteng, Surabaya, Jawa Timur 60274, Indonesia",
    "rating": "4.3",
    "reviewCount": 202,
    "placeId": "ChIJs7nVbBb51y0Rh-NgWY5J0BI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=LODJI%20BESAR&query_place_id=ChIJs7nVbBb51y0Rh-NgWY5J0BI",
    "categories": [
      "Art cafe",
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Peneleh, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNY0cXrMz3yWozx5CR0tquQ7IXAKI6NVB_gleg1=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Historic": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597789",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJr2yUaWv51y0RTIP3W14sJx0",
    "name": "Kafetien 88",
    "address": "Jl. Jagalan No.88, Bongkaran, Kec. Pabean Cantikan, Surabaya, Jawa Timur 60274, Indonesia",
    "rating": "4.5",
    "reviewCount": 866,
    "placeId": "ChIJr2yUaWv51y0RTIP3W14sJx0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kafetien%2088&query_place_id=ChIJr2yUaWv51y0RTIP3W14sJx0",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 31 3531281",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 7 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 7 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 7 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 7 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 7 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 7 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 4 PM"
      }
    ],
    "neighborhood": "Bongkaran, Pabean Cantikan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPukGCAawC4VbWWscRhnaRhQ1HZdjdFs-8UD63m=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.735
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597804",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJHzeNdW351y0RaEZNZnQEgHY",
    "name": "Fortunate Coffee",
    "address": "Jl. Undaan Wetan No.66A, Kapasari, Kec. Genteng, Surabaya, Jawa Timur 60273, Indonesia",
    "rating": "4.4",
    "reviewCount": 146,
    "placeId": "ChIJHzeNdW351y0RaEZNZnQEgHY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Fortunate%20Coffee&query_place_id=ChIJHzeNdW351y0RaEZNZnQEgHY",
    "categories": [
      "Vegetarian cafe and deli",
      "Coffee shop"
    ],
    "phone": "+62 816-526-999",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 5 PM"
      },
      {
        "day": "Tuesday",
        "hours": "Closed"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 7 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 7 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 7 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 7 PM"
      }
    ],
    "neighborhood": "Kapasari, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOEscKH1_IxqVzw3nwo6RDgqWTgfdtxTd2g26Z6=w408-h724-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597818",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJJ16lbSz71y0R8H6DnExv0Nk",
    "name": "Prens Coffee",
    "address": "Jl. Ngagel Tim. No.26, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "4.8",
    "reviewCount": 105,
    "placeId": "ChIJJ16lbSz71y0R8H6DnExv0Nk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Prens%20Coffee&query_place_id=ChIJJ16lbSz71y0R8H6DnExv0Nk",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 895-2499-1726",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOPR4a1rbdxu3NDG7s-OLqhHWqN6WIQzVIDWeiQ=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible restroom": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597832",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJJSEdqUb61y0Rdep0VPWP_UE",
    "name": "Wheels and Brakes Cafe",
    "address": "Jl. Deles I No.9, Klampis Ngasem, Kec. Sukolilo, Surabaya, Jawa Timur 60117, Indonesia",
    "rating": "4.2",
    "reviewCount": 170,
    "placeId": "ChIJJSEdqUb61y0Rdep0VPWP_UE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Wheels%20and%20Brakes%20Cafe&query_place_id=ChIJJSEdqUb61y0Rdep0VPWP_UE",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5926555",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 6 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 10 PM"
      }
    ],
    "neighborhood": "Klampis Ngasem, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://assets-pergikuliner.com/x-eezfzn0N7RSMUpPWwEXqL3UHk=/fit-in/1366x768/smart/filters:watermark(https://assets-pergikuliner.com/uploads/image/picture/456298/picture-1486167249.png,-0,-3,20):no_upscale()/https://assets-pergikuliner.com/uploads/image/picture/479099/picture-1488249170.JPG",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597846",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJQQZBHEb71y0RJsT4fVGn3qI",
    "name": "Kopitagram - Tenggilis",
    "address": "Jl. Raya Tenggilis No.93, Tenggilis Mejoyo, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60292, Indonesia",
    "rating": "4.6",
    "reviewCount": 1416,
    "placeId": "ChIJQQZBHEb71y0RJsT4fVGn3qI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopitagram%20-%20Tenggilis&query_place_id=ChIJQQZBHEb71y0RJsT4fVGn3qI",
    "categories": [
      "Coffee shop",
      "Cafe",
      "Restaurant"
    ],
    "phone": null,
    "website": "http://www.kopitagram.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 11 PM"
      }
    ],
    "neighborhood": "Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPZVw0NhdQHqP2WKpAdEg7sDWQkVpOyRZATJtgp=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597860",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJwT23xk771y0Rs5VEmEIOAOA",
    "name": "3C Cafe - Margorejo Indah",
    "address": "A513, Jl. Margorejo Indah, Margorejo, Wonocolo, Surabaya, East Java 60238, Indonesia",
    "rating": "4.7",
    "reviewCount": 165,
    "placeId": "ChIJwT23xk771y0Rs5VEmEIOAOA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=3C%20Cafe%20-%20Margorejo%20Indah&query_place_id=ChIJwT23xk771y0Rs5VEmEIOAOA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-308-199",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Margorejo, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN4-ODs_yDgKURv91Ax8XU92PxmiGuJ9bZpLZTG=w408-h271-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597878",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJS_CGB6j71y0RNKpfC1NkY2s",
    "name": "Chick-So Cafe & Resto",
    "address": "Jl. Margorejo Indah No.A702, Margorejo, Kec. Wonocolo, Surabaya, Jawa Timur 60238, Indonesia",
    "rating": "4.8",
    "reviewCount": 116,
    "placeId": "ChIJS_CGB6j71y0RNKpfC1NkY2s",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Chick-So%20Cafe%20%26%20Resto&query_place_id=ChIJS_CGB6j71y0RNKpfC1NkY2s",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 812-3165-4525",
    "website": "http://linktr.ee/chickso.id",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 10 PM"
      }
    ],
    "neighborhood": "Margorejo, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM5kP6Y9m92AtemVpYOsLqJXPJcVs43UBdK5mRF=w408-h302-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597896",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJzat_iqv71y0RDAziJxyKjCo",
    "name": "KUNOKINI Cafe & Resto",
    "address": "Jl. Raya Prapen No.69, Panjang Jiwo, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60299, Indonesia",
    "rating": "4.5",
    "reviewCount": 3942,
    "placeId": "ChIJzat_iqv71y0RDAziJxyKjCo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KUNOKINI%20Cafe%20%26%20Resto&query_place_id=ChIJzat_iqv71y0RDAziJxyKjCo",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 99844520",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "1 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Panjang Jiwo, Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipO0kT_qYy198t4qoseTZlZ10yK1EgwSZEasR6H_=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597911",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJzaWYLWP71y0R9Jxhpfj1U7w",
    "name": "OEBIN",
    "address": "Jl. Raya Manyar No.49, Menur Pumpungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.9",
    "reviewCount": 254,
    "placeId": "ChIJzaWYLWP71y0R9Jxhpfj1U7w",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=OEBIN&query_place_id=ChIJzaWYLWP71y0R9Jxhpfj1U7w",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 852-3551-3388",
    "website": "https://www.instagram.com/oebin.cafe/",
    "openingHours": [],
    "neighborhood": "Menur Pumpungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNP_B_6qZ7JI7JU5Q4tJK2TX3VQ3jSW29gBrYEs=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597934",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJW0ZBL3f61y0R7l2NFPFVlQc",
    "name": "Kedai Rhythm",
    "address": "Jl. Ngagel Jaya Utara No.50, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.4",
    "reviewCount": 542,
    "placeId": "ChIJW0ZBL3f61y0R7l2NFPFVlQc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Rhythm&query_place_id=ChIJW0ZBL3f61y0R7l2NFPFVlQc",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 878-5353-7707",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipP6hmGuv7YjMrTqNzjAvof3OOGs9NRqHEvj4NlK=w425-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597947",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJO1C40CX71y0RRvxQ87mDjk8",
    "name": "Konoae Warung A La Cafe, Keputih",
    "address": "Jl. Arief Rahman Hakim No.40, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.6",
    "reviewCount": 513,
    "placeId": "ChIJO1C40CX71y0RRvxQ87mDjk8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Konoae%20Warung%20A%20La%20Cafe%2C%20Keputih&query_place_id=ChIJO1C40CX71y0RRvxQ87mDjk8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3404-6606",
    "website": "https://linktr.ee/konoae.sby",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nolzMopMw4VNU13Oph5w368XA66pVmr51JwLQBOMI28U4JX8zxuyyeUm59AiK4NcqGa8_UoSOwc0zzl02OYk4pCBXMrRmporRCspbA7P0hcsVIyeM1YnJXs3YLL9w640BR-jt9t=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597962",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJs7npyHf71y0REtzuYdvssTk",
    "name": "Brunsj Cafe",
    "address": "Ruko Nirwana Eksekutif, Jl. Wonorejo Permai No.63, Wonorejo, Rungkut, Surabaya, East Java 60296, Indonesia",
    "rating": "4.6",
    "reviewCount": 243,
    "placeId": "ChIJs7npyHf71y0REtzuYdvssTk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Brunsj%20Cafe&query_place_id=ChIJs7npyHf71y0REtzuYdvssTk",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3329-6316",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 9 PM"
      }
    ],
    "neighborhood": "Wonorejo, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPpnGsBpR7xOi96XAIiTbhypslfvQUEcV2ypC7n=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597976",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ_1wGnkb71y0R8_u3FwqwttQ",
    "name": "D'THIRTYTREE",
    "address": "Jl. Raya Manyar No.33, Menur Pumpungan, Kec. Sukolilo, Surabaya, Jawa Timur 60284, Indonesia",
    "rating": "4.3",
    "reviewCount": 397,
    "placeId": "ChIJ_1wGnkb71y0R8_u3FwqwttQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=D%27THIRTYTREE&query_place_id=ChIJ_1wGnkb71y0R8_u3FwqwttQ",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 889-8898-9000",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 2 AM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 2 AM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 12 AM"
      }
    ],
    "neighborhood": "Menur Pumpungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNch4jnkD2UswKrcdpZmXN0foe8yYLCd6xW9GJh=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.597990",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJF877x9r71y0R3Ee0qnP8PrM",
    "name": "STMJ Ronde Biliton",
    "address": "Jl. Biliton No.73, Gubeng, Kec. Gubeng, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.5",
    "reviewCount": 1671,
    "placeId": "ChIJF877x9r71y0R3Ee0qnP8PrM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=STMJ%20Ronde%20Biliton&query_place_id=ChIJF877x9r71y0R3Ee0qnP8PrM",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "5 PM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "5 PM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "5 PM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "5 PM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "5 PM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "5 PM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "5 PM to 12 AM"
      }
    ],
    "neighborhood": "Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOox4SVF47z3vEGkbKuUmJFmjfk521O0JYk2Yz2=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": false
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598004",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJY7tnUyb51y0RZa3gHYOVG0c",
    "name": "Laritta Bakery - Perak Timur",
    "address": "Jl. Perak Timur No.30, Perak Tim., Kec. Pabean Cantikan, Surabaya, Jawa Timur 60164, Indonesia",
    "rating": "4.6",
    "reviewCount": 1287,
    "placeId": "ChIJY7tnUyb51y0RZa3gHYOVG0c",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Laritta%20Bakery%20-%20Perak%20Timur&query_place_id=ChIJY7tnUyb51y0RZa3gHYOVG0c",
    "categories": [
      "Bakery",
      "Cafe"
    ],
    "phone": "+62 895-6318-31979",
    "website": "https://www.larittabakery.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "6 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "6 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "6 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "6 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "6 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "6 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "6 AM to 9 PM"
      }
    ],
    "neighborhood": "East Perak, Pabean Cantikan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPRx9Q0dCu0D8QdZWKTMhq0pal_5B9pdiLd3CYM=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "In-store pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Same-day delivery": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Amenities": [
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Planning": [
        {
          "Quick visit": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.735
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598021",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJrXDril_51y0RPWqPXCFX4xg",
    "name": "Tjap Pregolan F&B Garden",
    "address": "Jl. Pregolan Bunder No.42-44, Tegalsari, Kec. Tegalsari, Surabaya, Jawa Timur 60262, Indonesia",
    "rating": "4.3",
    "reviewCount": 227,
    "placeId": "ChIJrXDril_51y0RPWqPXCFX4xg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tjap%20Pregolan%20F%26B%20Garden&query_place_id=ChIJrXDril_51y0RPWqPXCFX4xg",
    "categories": [
      "Cafe",
      "Coffee shop",
      "Ice cream shop",
      "Restaurant"
    ],
    "phone": "+62 812-2019-578",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMYTfu51Wq6gVpx5mB7fj7R__2KwgxRMvdWG71-=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Dine-in": true
        },
        {
          "Takeout": false
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        },
        {
          "Wheelchair accessible entrance": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Organic dishes": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": false
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598035",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJK-zG85D71y0RsLzGKfXhqXs",
    "name": "DE BUN",
    "address": "Jl. Biliton No.51, Gubeng, Kec. Gubeng, Surabaya, Jawa Timur 60271, Indonesia",
    "rating": "4.5",
    "reviewCount": 342,
    "placeId": "ChIJK-zG85D71y0RsLzGKfXhqXs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=DE%20BUN&query_place_id=ChIJK-zG85D71y0RsLzGKfXhqXs",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5038342",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 11 PM"
      }
    ],
    "neighborhood": "Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP_ajePnFBZP9vl8Mhd4y5FRWOS3g6uo0PhCzo_=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Organic dishes": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598049",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJE2AMtQn71y0RHtD7Y6gjF2A",
    "name": "BnD Cafe",
    "address": "Jl. Semolo Waru No.19, Medokan Semampir, Kec. Sukolilo, Surabaya, Jawa Timur 60119, Indonesia",
    "rating": "4.7",
    "reviewCount": 421,
    "placeId": "ChIJE2AMtQn71y0RHtD7Y6gjF2A",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=BnD%20Cafe&query_place_id=ChIJE2AMtQn71y0RHtD7Y6gjF2A",
    "categories": [
      "Cafe",
      "Coffee shop",
      "Restaurant"
    ],
    "phone": "+62 817-0758-811",
    "website": "https://instagram.com/bnd.cafe",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 11 PM"
      }
    ],
    "neighborhood": "Medokan Semampir, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP4NfLiiz2I1BAg7pURaImnvRXBtOfyywXrHOSE=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Assistive hearing loop": false
        },
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Organic dishes": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598064",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJwWgZCdj71y0RZ-c_P8-OMco",
    "name": "Garden Resto Pandan Sewu",
    "address": "Kayoon St No.9 B, Embong Kaliasin, Genteng, Surabaya, East Java 60271, Indonesia",
    "rating": "4.4",
    "reviewCount": 99,
    "placeId": "ChIJwWgZCdj71y0RZ-c_P8-OMco",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Garden%20Resto%20Pandan%20Sewu&query_place_id=ChIJwWgZCdj71y0RZ-c_P8-OMco",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "3 to 11:29 PM"
      },
      {
        "day": "Tuesday",
        "hours": "3 to 11:29 PM"
      },
      {
        "day": "Wednesday",
        "hours": "3 to 11:29 PM"
      },
      {
        "day": "Thursday",
        "hours": "3 to 11:29 PM"
      },
      {
        "day": "Friday",
        "hours": "3 to 11:29 PM"
      },
      {
        "day": "Saturday",
        "hours": "3 to 11:29 PM"
      },
      {
        "day": "Sunday",
        "hours": "3 to 11:29 PM"
      }
    ],
    "neighborhood": "Embong Kaliasin, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB-o5r4MNHpfgNPiYsEuJcFWukbOseyjyukym4j9MzuaOTEIl8ivZN5o_3tHiLlNvnbwsbsIiyjWTRKoF7vqFSTu0I7u_Smi5bs4FMJllwAt-Flj7OcURmF9liF2hBB1GqcyiN5a=w408-h543-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598077",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ_RxtFKr71y0RL10s_W5SP4I",
    "name": "Uptown Coffee Surabaya",
    "address": "Jl. Ngagel Jaya Utara No.67, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "4.5",
    "reviewCount": 123,
    "placeId": "ChIJ_RxtFKr71y0RL10s_W5SP4I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Uptown%20Coffee%20Surabaya&query_place_id=ChIJ_RxtFKr71y0RL10s_W5SP4I",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 821-1818-9696",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 12 AM"
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNJBerkQoFyhgwITm6vZU3SO9IkxoL-ESkAG2VS=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598091",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ4etu3rr71y0Rzf_T8k99l0I",
    "name": "Picaroll Cafe & Bakery",
    "address": "Jl. Ngagel Jaya Utara No.21, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "5",
    "reviewCount": 156,
    "placeId": "ChIJ4etu3rr71y0Rzf_T8k99l0I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Picaroll%20Cafe%20%26%20Bakery&query_place_id=ChIJ4etu3rr71y0Rzf_T8k99l0I",
    "categories": [
      "Cafe",
      "Bakery"
    ],
    "phone": "+62 812-1812-1847",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "Closed"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "Closed"
      },
      {
        "day": "Saturday",
        "hours": "Closed"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 9 PM"
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPFb2jk9LiMnCw5lFZtMdyK5aFE1dt36t9Gv57N=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dessert": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598103",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJRd4s_J_71y0RR0d_5keT318",
    "name": "Yoi Kona 2.0",
    "address": "Jl. Embong Cerme No.3, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271, Indonesia",
    "rating": "4.6",
    "reviewCount": 784,
    "placeId": "ChIJRd4s_J_71y0RR0d_5keT318",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Yoi%20Kona%202.0&query_place_id=ChIJRd4s_J_71y0RR0d_5keT318",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Embong Kaliasin, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMCTfLRm01nrQ5XDwQKr9h44KuhcREz9iaSeZqq=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null,
        {
          "Valet parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598118",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ9fUz-FT71y0Rm92mpSylEXg",
    "name": "Komunitas coffee and space",
    "address": "Ngagel Jaya Selatan St No.127, RT.08/RW.01, Baratajaya, Gubeng, Surabaya, East Java 60284, Indonesia",
    "rating": "4.8",
    "reviewCount": 443,
    "placeId": "ChIJ9fUz-FT71y0Rm92mpSylEXg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Komunitas%20coffee%20and%20space&query_place_id=ChIJ9fUz-FT71y0Rm92mpSylEXg",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 812-1330-296",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 9 PM"
      }
    ],
    "neighborhood": "Baratajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMRuOctxA736r-m7vsABsrMFdFDNUMKTd1mirXT=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598133",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJSbyza7H71y0Ri9kipWEinko",
    "name": "Libreria Eatery",
    "address": "Jl. Ngagel Jaya No.89, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "4.5",
    "reviewCount": 1869,
    "placeId": "ChIJSbyza7H71y0Ri9kipWEinko",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Libreria%20Eatery&query_place_id=ChIJSbyza7H71y0Ri9kipWEinko",
    "categories": [
      "Cafe",
      "Coffee shop",
      "Restaurant"
    ],
    "phone": "+62 895-8108-36070",
    "website": "http://www.libreriaeatery.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": "Tempat nongkrong yg menyediakan aneka buku untuk menemani,serta alunan musik dan aneka menu makanan.",
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNmQ2T12eZ40rKDaR4Og2qYRfpajoB2Q8vydQeN=w501-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598147",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ6c8BeaX71y0RiEsKuU9mPSE",
    "name": "Avere cafe",
    "address": "Jl. Ngagel Jaya Barat No.52, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "4.5",
    "reviewCount": 720,
    "placeId": "ChIJ6c8BeaX71y0RiEsKuU9mPSE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Avere%20cafe&query_place_id=ChIJ6c8BeaX71y0RiEsKuU9mPSE",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3139-3005",
    "website": "https://instagram.com/avere.sub?utm_medium=copy_link",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "2 PM to 4 AM"
      },
      {
        "day": "Tuesday",
        "hours": "2 PM to 4 AM"
      },
      {
        "day": "Wednesday",
        "hours": "2 PM to 4 AM"
      },
      {
        "day": "Thursday",
        "hours": "2 PM to 4 AM"
      },
      {
        "day": "Friday",
        "hours": "2 PM to 4 AM"
      },
      {
        "day": "Saturday",
        "hours": "2 PM to 4 AM"
      },
      {
        "day": "Sunday",
        "hours": "2 PM to 4 AM"
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMgTsn7UxPBxrJ32xuwoqU11fd_emXFRr2pC2Af=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Organic dishes": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598160",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJH2QvWa371y0RsyqTX7ddZ2k",
    "name": "Sult Cafe & Eatery",
    "address": "Jl. Arief Rahman Hakim No.185, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.6",
    "reviewCount": 763,
    "placeId": "ChIJH2QvWa371y0RsyqTX7ddZ2k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Sult%20Cafe%20%26%20Eatery&query_place_id=ChIJH2QvWa371y0RsyqTX7ddZ2k",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 11 PM"
      }
    ],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMemTSqht22VnC-Hd4Ay36QoMSLIFvdqCdDO0Zr=w532-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598175",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJucpXV0b71y0R5XKCKB2Nt10",
    "name": "Andzero",
    "address": "Jl. Nginden Intan Raya No.39, Nginden Jangkungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.7",
    "reviewCount": 345,
    "placeId": "ChIJucpXV0b71y0R5XKCKB2Nt10",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Andzero&query_place_id=ChIJucpXV0b71y0R5XKCKB2Nt10",
    "categories": [
      "Cafe",
      "Bistro"
    ],
    "phone": "+62 815-1575-8888",
    "website": "https://www.instagram.com/andzero.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 9 PM"
      }
    ],
    "neighborhood": "Ngenden Jangkungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMWMNEnvoQWCYXFApk3M_VoYaetAz2lFaN_5fEl=w408-h543-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598189",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJkwo_QR_71y0RXKsTBl_pVzw",
    "name": "Harman Cafe",
    "address": "Jl. Nginden Semolo No.46a, Nginden Jangkungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.6",
    "reviewCount": 113,
    "placeId": "ChIJkwo_QR_71y0RXKsTBl_pVzw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Harman%20Cafe&query_place_id=ChIJkwo_QR_71y0RXKsTBl_pVzw",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-5893-1011",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "9:30 AM to 10 PM"
      }
    ],
    "neighborhood": "Ngenden Jangkungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM9keQhMl2FFIlmAQGcT237zvm8yV5nFdQoqPA=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598203",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJCymVJZr71y0Ro8PJWCekMkA",
    "name": "AADK Coffee & Eatery (AR. Hakim)",
    "address": "Jl. Arief Rahman Hakim No.181, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.7",
    "reviewCount": 1152,
    "placeId": "ChIJCymVJZr71y0Ro8PJWCekMkA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=AADK%20Coffee%20%26%20Eatery%20%28AR.%20Hakim%29&query_place_id=ChIJCymVJZr71y0Ro8PJWCekMkA",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 896-5676-3456",
    "website": "https://www.instagram.com/adaapadengankopi/?hl=en",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 11 PM"
      }
    ],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMiGF1xms695uQ5zsXJPDpYbR3nyMr9Rxj6DV-u=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598218",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ9b2zI9L71y0RnOHjTQAIp8Q",
    "name": "Basecamp Ngopi",
    "address": "Jl. Gubeng Kertajaya IX Raya No.68, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60286, Indonesia",
    "rating": "4.7",
    "reviewCount": 161,
    "placeId": "ChIJ9b2zI9L71y0RnOHjTQAIp8Q",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Basecamp%20Ngopi&query_place_id=ChIJ9b2zI9L71y0RnOHjTQAIp8Q",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-3056-7164",
    "website": "https://www.instagram.com/basecampngopi/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Tuesday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Wednesday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Thursday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Friday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "6 AM to 1 AM"
      }
    ],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipO38Os5bmu9o_Pgk_1RTy2oBvITGwZxfPzwo_kH=w480-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598231",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJiYwl9dH71y0RyTcJjjXLIzc",
    "name": "Revolusi Coffee Bawean",
    "address": "Jl. Bawean No.42, Ngagel, Kec. Wonokromo, Surabaya, Jawa Timur 60246, Indonesia",
    "rating": "4.6",
    "reviewCount": 117,
    "placeId": "ChIJiYwl9dH71y0RyTcJjjXLIzc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Revolusi%20Coffee%20Bawean&query_place_id=ChIJiYwl9dH71y0RyTcJjjXLIzc",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 11 PM"
      }
    ],
    "neighborhood": "Ngagel, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOAcorDCIQpPwBzDJu2BCzKxrlTspk0EINJKzYF=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598245",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ02oEwqj71y0RE77YMrFzkys",
    "name": "The Good Press and Co",
    "address": "Jl. Embong Kenongo No.79A, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271, Indonesia",
    "rating": "4.8",
    "reviewCount": 108,
    "placeId": "ChIJ02oEwqj71y0RE77YMrFzkys",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=The%20Good%20Press%20and%20Co&query_place_id=ChIJ02oEwqj71y0RE77YMrFzkys",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-2844-9001",
    "website": "http://www.thegoodpressand.co/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 5 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 5 PM"
      }
    ],
    "neighborhood": "Embong Kaliasin, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPWUao-TCAUBpe0FRohI74EzArT181NaRTgp4vJ=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598259",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJmTOs7iT51y0Ru_kgmHoLDxc",
    "name": "Rollaas Coffee and Tea",
    "address": "Jl. Indrapura No.33A, Krembangan Sel., Kec. Krembangan, Surabaya, Jawa Timur 60175, Indonesia",
    "rating": "4.5",
    "reviewCount": 109,
    "placeId": "ChIJmTOs7iT51y0Ru_kgmHoLDxc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rollaas%20Coffee%20and%20Tea&query_place_id=ChIJmTOs7iT51y0Ru_kgmHoLDxc",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 823-5766-1212",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Saturday",
        "hours": "Closed"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "South Krembangan, Krembangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPBbk4-vyUzG8hSONmRsJGamzWqXr0w0vArK12t=w408-h318-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.248,
      112.725
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598280",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJtSPgxWP51y0Ru_u4Sx6fbRw",
    "name": "Zangrandi Ice Cream - Yos Sudarso",
    "address": "Jl. Yos Sudarso No.15, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271, Indonesia",
    "rating": "4.6",
    "reviewCount": 10660,
    "placeId": "ChIJtSPgxWP51y0Ru_u4Sx6fbRw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Zangrandi%20Ice%20Cream%20-%20Yos%20Sudarso&query_place_id=ChIJtSPgxWP51y0Ru_u4Sx6fbRw",
    "categories": [
      "Ice cream shop",
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 823-3665-8878",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Embong Kaliasin, Genteng",
    "city": "Surabaya",
    "description": "Cozy hangout with a relaxed vibe serving a wide variety of creative frozen treats.",
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMFX3J0myaHh2Zdb4RYsJcF56zkvXLR8dZ88BPu=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "In-store pickup": true
        },
        {
          "In-store shopping": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Same-day delivery": false
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598294",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJbSOfp4b51y0RPYXFoA6w-Bg",
    "name": "Tonggi Coffee Rooftop Cafe",
    "address": "Jl. Perak Timur No.148, Perak Tim., Kec. Pabean Cantikan, Surabaya, Jawa Timur 60164, Indonesia",
    "rating": "4.6",
    "reviewCount": 125,
    "placeId": "ChIJbSOfp4b51y0RPYXFoA6w-Bg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tonggi%20Coffee%20Rooftop%20Cafe&query_place_id=ChIJbSOfp4b51y0RPYXFoA6w-Bg",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 822-8998-7922",
    "website": "http://www.tonggicoffee.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "East Perak, Pabean Cantikan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNd61KEEmKvgneRrFKFpUUCuvnrLktCFHo9KSQ=w408-h660-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.735
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598321",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJj-Ve6TT51y0RSDYgKR3ikrQ",
    "name": "HOHO Coffee",
    "address": "001, Jl. Tunjungan No.72, RW.03, Genteng, Surabaya, East Java 60275, Indonesia",
    "rating": "4.1",
    "reviewCount": 117,
    "placeId": "ChIJj-Ve6TT51y0RSDYgKR3ikrQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=HOHO%20Coffee&query_place_id=ChIJj-Ve6TT51y0RSDYgKR3ikrQ",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 888-0555-7312",
    "website": "https://instagram.com/hohocoffee.id?utm_medium=copy_link",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPGCqWp4-DEiG0OmFR3zBxSne0p8Wumg6naFXV9=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598335",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJA02Ag2H71y0Rrz5NaQIXo2s",
    "name": "Kosaku Coffee Lab",
    "address": "Jl. Manyar Kertoarjo IV No.8, Mojo, Kec. Gubeng, Surabaya, Jawa Timur 60285, Indonesia",
    "rating": "4.5",
    "reviewCount": 394,
    "placeId": "ChIJA02Ag2H71y0Rrz5NaQIXo2s",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kosaku%20Coffee%20Lab&query_place_id=ChIJA02Ag2H71y0Rrz5NaQIXo2s",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3446-0168",
    "website": "https://www.instagram.com/kosakucoffee",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Mojo, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPkN08HkHBj2oQKQWHcsXSwaWtBmnQZVtOaVCZ2=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598348",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ42SUK2P51y0Rf4_3h_6ar5Q",
    "name": "My Kopi-O! - Grand City Mall Surabaya",
    "address": "unit 3.23, Grand City, Jl. Walikota Mustajab No.1 3rd Floor, Ketabang, Genteng, Surabaya, East Java 60272, Indonesia",
    "rating": "4.8",
    "reviewCount": 1209,
    "placeId": "ChIJ42SUK2P51y0Rf4_3h_6ar5Q",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=My%20Kopi-O%21%20-%20Grand%20City%20Mall%20Surabaya&query_place_id=ChIJ42SUK2P51y0Rf4_3h_6ar5Q",
    "categories": [
      "Cafe",
      "Coffee shop",
      "Restaurant"
    ],
    "phone": "+62 31 52405918",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Ketabang, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM-qerXWRBTHQvw9ketirNzK1GdcKKxwNLsu_g7=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598362",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJTftwu-r71y0RyPvLnn2BqOY",
    "name": "Coffee Toffee Dharmawangsa",
    "address": "Jl. Dharmawangsa No.1, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60286, Indonesia",
    "rating": "4.6",
    "reviewCount": 628,
    "placeId": "ChIJTftwu-r71y0RyPvLnn2BqOY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Coffee%20Toffee%20Dharmawangsa&query_place_id=ChIJTftwu-r71y0RyPvLnn2BqOY",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 31 99443559",
    "website": "https://coffeetoffee.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "1 PM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "1 PM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "1 to 11 PM"
      }
    ],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB8XFbhxchiwW2hy3Ag2S5wle74ZWL10u4j6H7Om9VLGiMETgj3kCM30bPwK93WlKf8x2Sh44dh4iJO7mj6XAwX4Sif6UDfmHlSQepbXYDkklDxjV9vkTHKcLErHXj9SFNJkZ3mo7A=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598375",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ24up-Uv51y0R_5BdKMtiKXU",
    "name": "Warkop Bunk Baroqh",
    "address": "Jl. Demak, Gundih, Kec. Bubutan, Surabaya, Jawa Timur 60173, Indonesia",
    "rating": "4.4",
    "reviewCount": 104,
    "placeId": "ChIJ24up-Uv51y0R_5BdKMtiKXU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Bunk%20Baroqh&query_place_id=ChIJ24up-Uv51y0R_5BdKMtiKXU",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-2110-7388",
    "website": null,
    "openingHours": [],
    "neighborhood": "Gundih, Bubutan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNzj1LPFZqfrfMgf2u0lLEFF78S4TqFWp_wJ3hN=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598403",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJE6ySXq751y0R_3LZgldMgHY",
    "name": "Haya Coffee Shop",
    "address": "Jl. Kaliasin Tegalsari No.2A, Kedungdoro, Kec. Tegalsari, Surabaya, Jawa Timur 60261, Indonesia",
    "rating": "4.6",
    "reviewCount": 260,
    "placeId": "ChIJE6ySXq751y0R_3LZgldMgHY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Haya%20Coffee%20Shop&query_place_id=ChIJE6ySXq751y0R_3LZgldMgHY",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 811-3557-676",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Friday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 10:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 9:30 PM"
      }
    ],
    "neighborhood": "Kedungdoro, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOgpnjb-wEJ6CnFAmQKnWY1wh7ewKem_XAwWPPV=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598417",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJCdr6aZP71y0RykctPAfwVF8",
    "name": "Shisha Boss Cafe Surabaya",
    "address": "Jl. R.A Kartini No.34, DR. Soetomo, Kec. Tegalsari, Surabaya, Jawa Timur 60264, Indonesia",
    "rating": "4.7",
    "reviewCount": 286,
    "placeId": "ChIJCdr6aZP71y0RykctPAfwVF8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Shisha%20Boss%20Cafe%20Surabaya&query_place_id=ChIJCdr6aZP71y0RykctPAfwVF8",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 813-3259-9227",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 PM to 2 AM"
      },
      {
        "day": "Tuesday",
        "hours": "12 PM to 2 AM"
      },
      {
        "day": "Wednesday",
        "hours": "12 PM to 2 AM"
      },
      {
        "day": "Thursday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Friday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Saturday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Sunday",
        "hours": "4 PM to 2 AM"
      }
    ],
    "neighborhood": "DR. Soetomo, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNA0-FNmZcQquvuFDWI3DT27uxVxfBBUYe6zN8=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598431",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ1zN3E1n71y0Rp8jfNvYXaT0",
    "name": "Lokalisasi Kopi \"Kolokial\" Karimata",
    "address": "Jl. Bagong Karimata No.6, Ngagel, Kec. Wonokromo, Surabaya, Jawa Timur 60246, Indonesia",
    "rating": "4.6",
    "reviewCount": 365,
    "placeId": "ChIJ1zN3E1n71y0Rp8jfNvYXaT0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Lokalisasi%20Kopi%20%22Kolokial%22%20Karimata&query_place_id=ChIJ1zN3E1n71y0Rp8jfNvYXaT0",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-3302-266",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Ngagel, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMl03XRr-dAvmtzlXS2LcMtg4HQx60NLa1MPq4c=w522-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598445",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJDRdFry751y0RzvrRhws78HM",
    "name": "Griffon cafe and lounge",
    "address": "Blauran St No.57-75, Genteng, Surabaya, East Java 60275, Indonesia",
    "rating": "4",
    "reviewCount": 176,
    "placeId": "ChIJDRdFry751y0RzvrRhws78HM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Griffon%20cafe%20and%20lounge&query_place_id=ChIJDRdFry751y0RzvrRhws78HM",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-3536-7822",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB-SB4autMiW_z90IyROq4GaDZqcxDO3_nrR3S4g4bzlVrQGk7FxiZvnd1DSsOvx6tgLrqDKUw9SjarefqS06t9kWKbhIip9oJonwwxur2zsxpLmuFcpqTgTpEcccjwRCoKvY68W=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null,
        {
          "Valet parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598458",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJAT-Jp-D71y0R1ZKK3gQ0H4I",
    "name": "Pukul Satu Kopi - Dharmawangsa",
    "address": "Jl. Dharmawangsa No.142a, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60286, Indonesia",
    "rating": "4.7",
    "reviewCount": 731,
    "placeId": "ChIJAT-Jp-D71y0R1ZKK3gQ0H4I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Pukul%20Satu%20Kopi%20-%20Dharmawangsa&query_place_id=ChIJAT-Jp-D71y0R1ZKK3gQ0H4I",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-8393-999",
    "website": "http://instagram.com/pukulsatukopi",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMkBqqXCqpz2YQ04SL3XWt9j78Jl0i3-BEziaup=w408-h405-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598471",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJTTjKi0v71y0RqTMSIAoN_zY",
    "name": "MeokGo Cafe & Meet Up Point",
    "address": "Kedungsari no.27, Surabaya, Jawa Timur 60263, Indonesia",
    "rating": "4.7",
    "reviewCount": 99,
    "placeId": "ChIJTTjKi0v71y0RqTMSIAoN_zY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=MeokGo%20Cafe%20%26%20Meet%20Up%20Point&query_place_id=ChIJTTjKi0v71y0RqTMSIAoN_zY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 858-0887-0916",
    "website": null,
    "openingHours": [],
    "neighborhood": "Wonorejo, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMZiqIuEK7Gq2RnlrLllDNhDnVcXAjJlck6ToTJ=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598506",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJt4fCJc771y0R7b8BP3oc2Q0",
    "name": "Cafe ESCO",
    "address": "Jl. Gubeng Kertajaya V B No.58, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60286, Indonesia",
    "rating": "4.5",
    "reviewCount": 462,
    "placeId": "ChIJt4fCJc771y0R7b8BP3oc2Q0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20ESCO&query_place_id=ChIJt4fCJc771y0R7b8BP3oc2Q0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3632-053",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM5ENZ-6OoW_AfK0eHNbLiqp1MEr8ZS5bvaSXNj=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.644Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598520",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJyY-BasH71y0RkZognb68P0g",
    "name": "Cafe Doho 22",
    "address": "Jl. Doho No.22, Keputran, Kec. Tegalsari, Surabaya, Jawa Timur 60265, Indonesia",
    "rating": "4.3",
    "reviewCount": 395,
    "placeId": "ChIJyY-BasH71y0RkZognb68P0g",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20Doho%2022&query_place_id=ChIJyY-BasH71y0RkZognb68P0g",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 852-3069-8653",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10:30 AM to 7:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10:30 AM to 7:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10:30 AM to 7:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "10:30 AM to 7:30 PM"
      },
      {
        "day": "Friday",
        "hours": "10:30 AM to 7:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "10:30 AM to 7:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "Keputran, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOBgW09fl8SfxmOvkrf3eyHlQaCRZVq99v_LDg=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598532",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJpY0jZKH71y0RpssrxAx0Rvo",
    "name": "Insomnia Timewalk Cafe",
    "address": "Jl. Lombok No.9, Ngagel, Kec. Wonokromo, Surabaya, Jawa Timur 60246, Indonesia",
    "rating": "4.7",
    "reviewCount": 124,
    "placeId": "ChIJpY0jZKH71y0RpssrxAx0Rvo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Insomnia%20Timewalk%20Cafe&query_place_id=ChIJpY0jZKH71y0RpssrxAx0Rvo",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 895-0518-1777",
    "website": "https://instagram.com/insomnia_id?utm_medium=copy_link",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 10 PM"
      }
    ],
    "neighborhood": "Ngagel, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMWa3RMhxKvgra1VJrNIzd7et4vcueNHmS491U_=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598546",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJHwuDTjf71y0RKUUfPSDjruM",
    "name": "ANGKRINGAN WONGSOJOYO 2",
    "address": "Jl. Ketintang Madya No.92 A, Gayungan, Kec. Gayungan, Surabaya, Jawa Timur 60231, Indonesia",
    "rating": "4.6",
    "reviewCount": 160,
    "placeId": "ChIJHwuDTjf71y0RKUUfPSDjruM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=ANGKRINGAN%20WONGSOJOYO%202&query_place_id=ChIJHwuDTjf71y0RKUUfPSDjruM",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 856-4866-0550",
    "website": "https://www.instagram.com/p/B19kQqUlxg9/?igshid=1wl97pj9667qf",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "5 PM to 1 AM"
      },
      {
        "day": "Tuesday",
        "hours": "5 PM to 1 AM"
      },
      {
        "day": "Wednesday",
        "hours": "5 PM to 1 AM"
      },
      {
        "day": "Thursday",
        "hours": "5 PM to 1 AM"
      },
      {
        "day": "Friday",
        "hours": "5 PM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "5 PM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "5 PM to 1 AM"
      }
    ],
    "neighborhood": "Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPZcQP1OYniQHsQfGsL2H6b_EMGkVWkfTGm9eOy=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598563",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJnRVa9ef71y0Rt3k-yQXsyz4",
    "name": "FULL MOON Cafe and Eatery",
    "address": "Jl. Karang Menur No.22, RT.008/RW.07, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60286, Indonesia",
    "rating": "4.6",
    "reviewCount": 233,
    "placeId": "ChIJnRVa9ef71y0Rt3k-yQXsyz4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=FULL%20MOON%20Cafe%20and%20Eatery&query_place_id=ChIJnRVa9ef71y0Rt3k-yQXsyz4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-2045-5505",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "4 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "4 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "4 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "4 to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "4 to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "4 to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "4 to 10 PM"
      }
    ],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP-eKKdHdmPdyepsbU54ryXpzRgkFmsNtQ5w5vp=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598576",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJsRznS8z_1y0RssvVICazB84",
    "name": "Pentol Bakar Faizah",
    "address": "Jl. Manukan Mukti IV No.11E/8, Manukan Kulon, Kec. Tandes, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.9",
    "reviewCount": 130,
    "placeId": "ChIJsRznS8z_1y0RssvVICazB84",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Pentol%20Bakar%20Faizah&query_place_id=ChIJsRznS8z_1y0RssvVICazB84",
    "categories": [
      "Restaurant",
      "Cafe"
    ],
    "phone": "+62 895-2556-2635",
    "website": "http://linktr.ee/pentol_faizah",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7:30 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7:30 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7:30 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "7:30 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "7:30 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "7:30 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "7:30 AM to 9 PM"
      }
    ],
    "neighborhood": "Manukan Kulon, Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOYMMSxgnzIA9xxhJXTaINqzPgsuKTC9LLslTIg=w408-h576-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Halal food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Amenities": [
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.258,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598588",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJgb1c5ov81y0RsLoWPANJ-hA",
    "name": "Warkop 21",
    "address": "Jl. Raya Menganti Wiyung No.21, Wiyung, Kec. Wiyung, Surabaya, Jawa Timur 60228, Indonesia",
    "rating": "4.4",
    "reviewCount": 165,
    "placeId": "ChIJgb1c5ov81y0RsLoWPANJ-hA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%2021&query_place_id=ChIJgb1c5ov81y0RsLoWPANJ-hA",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 822-4518-7665",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 9 PM"
      }
    ],
    "neighborhood": "Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipO1NfMcY0cMJfb8dF2ENACYYAKAFhRc18asenV8=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598601",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJrXQmLm771y0RO3z2qOJ39Oo",
    "name": "Warkop Ojo Gelo",
    "address": "Jl. Ketintang Baru I No.20, Ketintang, Kec. Gayungan, Surabaya, Jawa Timur 60231, Indonesia",
    "rating": "4.3",
    "reviewCount": 758,
    "placeId": "ChIJrXQmLm771y0RO3z2qOJ39Oo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Ojo%20Gelo&query_place_id=ChIJrXQmLm771y0RO3z2qOJ39Oo",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 3 AM"
      }
    ],
    "neighborhood": "Ketintang, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP22VHX8e_1yRh6uy4QJLoY8aT_fQ1Lwn_rU2nH=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        },
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598618",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJE2ARq9D71y0R8j30bWrQbMw",
    "name": "Kofie Paste",
    "address": "Jl. Gubeng Kertajaya No.7C/56 Lantai 2, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60282, Indonesia",
    "rating": "4.7",
    "reviewCount": 112,
    "placeId": "ChIJE2ARq9D71y0R8j30bWrQbMw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kofie%20Paste&query_place_id=ChIJE2ARq9D71y0R8j30bWrQbMw",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 813-3334-4162",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 10 PM"
      }
    ],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMu9-Hxyenk4PVuYBMp4BxHATyBOg2scuNGYzmM=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598631",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ1T0u24v71y0Rrvccr3iDKXA",
    "name": "KOI Cafe",
    "address": "Ciputra World, Jl. Mayjen Sungkono No.52, Gn. Sari, Kec. Dukuhpakis, Surabaya, Jawa Timur 60224, Indonesia",
    "rating": "4.3",
    "reviewCount": 148,
    "placeId": "ChIJ1T0u24v71y0Rrvccr3iDKXA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KOI%20Cafe&query_place_id=ChIJ1T0u24v71y0Rrvccr3iDKXA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 99535209",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Gunung Sari, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPFkklhOXtZlMbQmg-qKwpDh53dR1jd2l2__kx6=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.645Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598649",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJfZ0frPL71y0R8nsJtSOFSyM",
    "name": "KANTHI COFFEE AND EATERY",
    "address": "Jl. Dharmawangsa No.138A, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60286, Indonesia",
    "rating": "4.6",
    "reviewCount": 325,
    "placeId": "ChIJfZ0frPL71y0R8nsJtSOFSyM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KANTHI%20COFFEE%20AND%20EATERY&query_place_id=ChIJfZ0frPL71y0R8nsJtSOFSyM",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 857-9145-1835",
    "website": "https://www.instagram.com/kanthicoffeeandeatery/",
    "openingHours": [],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOItRW9obGcJqcy2IjXNoUkmbgKAeRtUSJVN0gf=w408-h883-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Parking": [
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598662",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJf0DYpOv71y0RimJufjp6bGQ",
    "name": "Coffee at Louis",
    "address": "Jl. Trunojoyo No.69, DR. Soetomo, Kec. Tegalsari, Surabaya, Jawa Timur 60264, Indonesia",
    "rating": "4.6",
    "reviewCount": 934,
    "placeId": "ChIJf0DYpOv71y0RimJufjp6bGQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Coffee%20at%20Louis&query_place_id=ChIJf0DYpOv71y0RimJufjp6bGQ",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 813-8743-1266",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "Closed"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "Closed"
      },
      {
        "day": "Friday",
        "hours": "Closed"
      },
      {
        "day": "Saturday",
        "hours": "Closed"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "DR. Soetomo, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPbWhslBNGsUbpKLjzqrGLtHgI63ZR2VlNHfutX=w512-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "On-site parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598674",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJp8c0nGP71y0RzLuQU1n5KuA",
    "name": "Kateko Surabaya",
    "address": "Jl. Sumatera No.21, Pacar Keling, Kec. Tambaksari, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.6",
    "reviewCount": 322,
    "placeId": "ChIJp8c0nGP71y0RzLuQU1n5KuA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kateko%20Surabaya&query_place_id=ChIJp8c0nGP71y0RzLuQU1n5KuA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3290-086",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 10 PM"
      }
    ],
    "neighborhood": "Pacar Keling, Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPrlNRWnZzT107ZoHo-DTjR7-EFhUSmtCYgpRc3=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.252,
      112.765
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598690",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJDT1jyvX71y0RKc_IBMEBFuw",
    "name": "Happynests cafe",
    "address": "Jl. Jawa No.18, RT.000/RW.00, Gubeng, Kec. Gubeng, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.2",
    "reviewCount": 358,
    "placeId": "ChIJDT1jyvX71y0RKc_IBMEBFuw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Happynests%20cafe&query_place_id=ChIJDT1jyvX71y0RKc_IBMEBFuw",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 896-0288-1177",
    "website": "https://www.bundatraveler.com/happynest-cafe-surabaya/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 to 9 AM, 11 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP4Hri1Kg2pQ33cyIWg-m5rE5sLwmaqp6GkrI33=w425-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598702",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJXzv4ZX_71y0R9qTOSV82VkE",
    "name": "Rolak Gunungsari Surabaya",
    "address": "MPR9+FQQ, Jl. Karah I, Karah, Kec. Jambangan, Surabaya, Jawa Timur 60232, Indonesia",
    "rating": "4.3",
    "reviewCount": 147,
    "placeId": "ChIJXzv4ZX_71y0R9qTOSV82VkE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rolak%20Gunungsari%20Surabaya&query_place_id=ChIJXzv4ZX_71y0R9qTOSV82VkE",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9:20 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "9:20 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "9:20 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "9:20 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "9:20 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "9:20 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "9:20 AM to 12 AM"
      }
    ],
    "neighborhood": "Karah, Jambangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNX47DG_de9ECSKMytNxu2YxHlBnTpfZot8UaEo=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598719",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJy5cPv2z51y0RElrtvhyBry0",
    "name": "TOBY'S ESTATE -Coffee Roasters-",
    "address": "Tunjungan Plaza 5 L.UG, Jl. Embong Malang No.4, Kedungdoro, Kec. Tegalsari, Surabaya, Jawa Timur 60261, Indonesia",
    "rating": "4.6",
    "reviewCount": 949,
    "placeId": "ChIJy5cPv2z51y0RElrtvhyBry0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=TOBY%27S%20ESTATE%20-Coffee%20Roasters-&query_place_id=ChIJy5cPv2z51y0RElrtvhyBry0",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 31 99244406",
    "website": "http://tobysestatecoffee.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Kedungdoro, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM-4GYktVBBz_h4nfX18t2iY5AffWAXIvqRPEHB=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598733",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJEy1GGsr71y0REtSM_u6GLoY",
    "name": "Cafe de'Lisa",
    "address": "Jl. Pucang Anom Timur III No.33, Kertajaya, Kec. Gubeng, Surabaya, Jawa Timur 60282, Indonesia",
    "rating": "4.3",
    "reviewCount": 77,
    "placeId": "ChIJEy1GGsr71y0REtSM_u6GLoY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20de%27Lisa&query_place_id=ChIJEy1GGsr71y0REtSM_u6GLoY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-1143-5895",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 5 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 5 PM"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 5 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 5 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 5 PM"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "Kertajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNqMctGQUbtWhJ19qhpKxDgXWuegkhSjtesfgpy=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598745",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJY7j0ng_71y0RugwFc8Tuv-8",
    "name": "Tanamera Coffee Trunojoyo",
    "address": "Jl. Trunojoyo No.75, DR. Soetomo, Kec. Tegalsari, Surabaya, Jawa Timur 60264, Indonesia",
    "rating": "4.6",
    "reviewCount": 679,
    "placeId": "ChIJY7j0ng_71y0RugwFc8Tuv-8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tanamera%20Coffee%20Trunojoyo&query_place_id=ChIJY7j0ng_71y0RugwFc8Tuv-8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-1361-4288",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "6 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "6 AM to 12 AM"
      }
    ],
    "neighborhood": "DR. Soetomo, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPIcuYwUorB2gJ33NrdFN8ussykddIMzB-WIw30=w437-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598758",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJp5eKo3T91y0Rm-hu7W7tAis",
    "name": "Djournal Coffee Pakuwon Mall",
    "address": "Pakuwon Mall, Jl. Puncak Indah Jl. Raya Lontar No.2 Lantai G Unit 28, Babatan, Kec. Wiyung, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.4",
    "reviewCount": 614,
    "placeId": "ChIJp5eKo3T91y0Rm-hu7W7tAis",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Djournal%20Coffee%20Pakuwon%20Mall&query_place_id=ChIJp5eKo3T91y0Rm-hu7W7tAis",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 31 7391081",
    "website": "https://www.ismaya.com/eat-drink/djournal",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Babatan, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNp2LEguz3S6oSGMFcsd7H4iI-NXC-1b93oHS9g=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598772",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJRx4du5r71y0R-rN46uR0Dyg",
    "name": "Angkringan Jancok",
    "address": "Jalan Hayam Wuruk No. 36, Sawunggaling, Wonokromo, Sawunggaling, Kec. Wonokromo, Surabaya, Jawa Timur 60242, Indonesia",
    "rating": "4.4",
    "reviewCount": 221,
    "placeId": "ChIJRx4du5r71y0R-rN46uR0Dyg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Angkringan%20Jancok&query_place_id=ChIJRx4du5r71y0R-rN46uR0Dyg",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Sawunggaling, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB9Sks-Fuguc7oNRqObMlAhKpTWg4wDw6evLrOoXhg_SKMkWuuOCc3La0m6mXePo6-XJWyglj0X9_GxrS6yILHCbvObRqx4lUToNtg1WnuaXWP9CfZYdyPREjHUL0mtYxmQvS_4=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598786",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJFQAAwP_41y0R2d_vGF71gpo",
    "name": "Starbucks Pakuwon SuperMall",
    "address": "Pakuwon Mall Level Ground, Jl. Mayjend. Jonosewojo No.2, Babatan, Kec. Wiyung, Surabaya, Jawa Timur 60227, Indonesia",
    "rating": "4.6",
    "reviewCount": 1635,
    "placeId": "ChIJFQAAwP_41y0R2d_vGF71gpo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Starbucks%20Pakuwon%20SuperMall&query_place_id=ChIJFQAAwP_41y0R2d_vGF71gpo",
    "categories": [
      "Coffee shop",
      "Breakfast restaurant",
      "Cafe"
    ],
    "phone": "+62 31 7390367",
    "website": "http://www.starbucks.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 9 PM"
      }
    ],
    "neighborhood": "Babatan, Wiyung",
    "city": "Surabaya",
    "description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNL7o1GJ1JNnrB_AZhnHwTQUebnQFLPaW6OsPvZ=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        },
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.298,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598798",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_verified": false,
    "coordinates_estimated": true
  },
  {
    "id": "ChIJSfWvpf_61y0RqBEhVq5GgP8",
    "name": "De'PANJI",
    "address": "Jalan golf No.1, Gn. Sari, Kec. Dukuhpakis, Jawa Timur, 60244, Indonesia",
    "rating": "4.2",
    "reviewCount": 3066,
    "placeId": "ChIJSfWvpf_61y0RqBEhVq5GgP8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=De%27PANJI&query_place_id=ChIJSfWvpf_61y0RqBEhVq5GgP8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3013-3095",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "3:30 to 11:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "3:30 to 11:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "3:30 to 11:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "3:30 to 11:30 PM"
      },
      {
        "day": "Friday",
        "hours": "3:30 to 11:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "3:30 to 11:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "3:30 to 11:30 PM"
      }
    ],
    "neighborhood": "Gunung Sari, Dukuhpakis",
    "city": "Jawa Timur",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM8L2LhfYiDOOeegBZX64R_jekzlnGi2pGVWRlD=w408-h508-k-no",
    "additionalInfo": {
      "From the business": [
        {
          "Identifies as women-owned": true
        }
      ],
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "Unknown",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598820",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJiVThEWD51y0Rx_-P4bH0riw",
    "name": "Le Cafe Gourmand",
    "address": "Jl. Pregolan No.2, Tegalsari, Kec. Tegalsari, Surabaya, Jawa Timur 60262, Indonesia",
    "rating": "4.6",
    "reviewCount": 75,
    "placeId": "ChIJiVThEWD51y0Rx_-P4bH0riw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Le%20Cafe%20Gourmand&query_place_id=ChIJiVThEWD51y0Rx_-P4bH0riw",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3221-1222",
    "website": "https://www.instagram.com/lecafegourmand.sby/?hl=en",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 10 PM"
      }
    ],
    "neighborhood": "Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOL0NDZIEzN8eZVus-E7_iP8Z81RaBobGWnytSb=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour food": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598833",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJQXPd5tf71y0RrZP3as0d_Hw",
    "name": "LOKO CAFE STASIUN GUBENG",
    "address": "Jl. Gubeng Masjid, Pacar Keling, Kec. Tambaksari, Surabaya, Jawa Timur 60131, Indonesia",
    "rating": "4.7",
    "reviewCount": 175,
    "placeId": "ChIJQXPd5tf71y0RrZP3as0d_Hw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=LOKO%20CAFE%20STASIUN%20GUBENG&query_place_id=ChIJQXPd5tf71y0RrZP3as0d_Hw",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": null,
    "website": "https://instagram.com/lokocafe?igshid=OTJlNzQ0NWM=",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 8 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 8 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 8 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 8 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 8 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 8 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 8 PM"
      }
    ],
    "neighborhood": "Pacar Keling, Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMvjgc6LxV82hoS-4e3O6xzO5LJRpr7D0PikokG=w425-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598846",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJn4-Eowj71y0R3_Xud9WHy4s",
    "name": "MADANI CAFE SURABAYA",
    "address": "Jl. Gubeng Kertajaya IX Raya C Raya No.23, Airlangga, Kec. Gubeng, Surabaya, Jawa Timur 60286, Indonesia",
    "rating": "4.6",
    "reviewCount": 222,
    "placeId": "ChIJn4-Eowj71y0R3_Xud9WHy4s",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=MADANI%20CAFE%20SURABAYA&query_place_id=ChIJn4-Eowj71y0R3_Xud9WHy4s",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 823-1207-7948",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Airlangga, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP9RUjoviEq4oy6spCjV88b0Lu6TLOwjSFzHZ8a=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598859",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ88pX6WL91y0RzD6GUUiJFCE",
    "name": "Ya Cha",
    "address": "PM6G+872, Babatan, Wiyung, Surabaya, East Java 60213, Indonesia",
    "rating": "4.6",
    "reviewCount": 2323,
    "placeId": "ChIJ88pX6WL91y0RzD6GUUiJFCE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Ya%20Cha&query_place_id=ChIJ88pX6WL91y0RzD6GUUiJFCE",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Babatan, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNM2YbA5WDLBQqxknrCI2yon473fDwLJ5zhc4eS=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598928",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJZ_vgg3v91y0RF3S1i6K1JtA",
    "name": "Tanamera Coffee Graha Famili",
    "address": "Area Komersial Graha Famili, Jl. Mayjend. Jonosewojo, Babatan, Wiyung, Surabaya, East Java 60226, Indonesia",
    "rating": "4.5",
    "reviewCount": 1558,
    "placeId": "ChIJZ_vgg3v91y0RF3S1i6K1JtA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tanamera%20Coffee%20Graha%20Famili&query_place_id=ChIJZ_vgg3v91y0RF3S1i6K1JtA",
    "categories": [
      "Cafe",
      "Coffee shop",
      "Restaurant"
    ],
    "phone": "+62 31 99144673",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 4 AM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 4 AM"
      }
    ],
    "neighborhood": "Babatan, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPzqgW317XVYMQ8iVVgecyNd4wn2tMYQRt6D4Ic=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Hard liquor": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598952",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ63WTSnv51y0RHoK2ntD0S40",
    "name": "Oh Gelato Cafe",
    "address": "Jl. Kusuma Bangsa No.1-3, Ketabang, Kec. Genteng, Surabaya, Jawa Timur 60272, Indonesia",
    "rating": "4.6",
    "reviewCount": 1074,
    "placeId": "ChIJ63WTSnv51y0RHoK2ntD0S40",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Oh%20Gelato%20Cafe&query_place_id=ChIJ63WTSnv51y0RHoK2ntD0S40",
    "categories": [
      "Ice cream shop",
      "Cafe"
    ],
    "phone": "+62 877-8088-8410",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 10 PM"
      }
    ],
    "neighborhood": "Ketabang, Genteng",
    "city": "Surabaya",
    "description": "Snug, inviting cafe with patio tables serving a selection of gelati & casual Indonesian fare.",
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMw6urpoodyENKbBgAt9_xw7Y_pump3WhlCsEvW=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "In-store pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598969",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJR4DE3PX71y0RAKuA0EWQmsY",
    "name": "MM CAFFE",
    "address": "Wonokromo, Surabaya, East Java 60243, Indonesia",
    "rating": "4.6",
    "reviewCount": 134,
    "placeId": "ChIJR4DE3PX71y0RAKuA0EWQmsY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=MM%20CAFFE&query_place_id=ChIJR4DE3PX71y0RAKuA0EWQmsY",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 1 AM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 1 AM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 1 AM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 1 AM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 1 AM"
      }
    ],
    "neighborhood": "Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMNP2L0RgVq40ln6p49dnp3sAVK8xpgkeSOtz5c=w408-h318-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598983",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJT06_oVb51y0R0iggaEOBV9I",
    "name": "OL and NU cafe eatery",
    "address": "Jl. Slamet No.31 A, Ketabang, Kec. Genteng, Surabaya, Jawa Timur 60272, Indonesia",
    "rating": "4.9",
    "reviewCount": 799,
    "placeId": "ChIJT06_oVb51y0R0iggaEOBV9I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=OL%20and%20NU%20cafe%20eatery&query_place_id=ChIJT06_oVb51y0R0iggaEOBV9I",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 852-8088-8579",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Ketabang, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB8LGnvTAOj2D4p4gnelo3pH-k3yBjLmeX2-t3LBTUATLxdzQQYn242QIrAJCXOri0nmzw8ldyJusIMs5ewylIYMrcb10RS01vKC4jtsE-PlG2oMFtGX7H3QI1kxQGNG=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.598998",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJsZOt82b51y0R6QeJEJKHlTY",
    "name": "Sambang Cafe & Eatery",
    "address": "PQV2+2R8, Jl. Ketabang Kali No.53, Ketabang, Kec. Genteng, Surabaya, Jawa Timur 60272, Indonesia",
    "rating": "4.8",
    "reviewCount": 974,
    "placeId": "ChIJsZOt82b51y0R6QeJEJKHlTY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Sambang%20Cafe%20%26%20Eatery&query_place_id=ChIJsZOt82b51y0R6QeJEJKHlTY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 817-328-080",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 11 PM"
      }
    ],
    "neighborhood": "Ketabang, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPB_zN2cA4vxsSZQPe_EgmBhZ37Jd2oZEY7uZ9Q=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Hard liquor": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599012",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJScwa_Bz71y0RhHU6aha6Tyw",
    "name": "Breve Cafe",
    "address": "Jl. Sambas No.20, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.8",
    "reviewCount": 167,
    "placeId": "ChIJScwa_Bz71y0RhHU6aha6Tyw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Breve%20Cafe&query_place_id=ChIJScwa_Bz71y0RhHU6aha6Tyw",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3068-844",
    "website": "http://instagram.com/breve.id",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 10 PM"
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN0FnkKsNtpwf1NL_5_cvNyVL0DBZP8VftSxEc_=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free street parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599026",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ7Q9M_JD71y0RgqAOEJlHCXc",
    "name": "Wdnsdy Cafe",
    "address": "Blok H No.40, Jl. Hayam Wuruk Dodik, Sawunggaling, Kec. Wonokromo, Surabaya, Jawa Timur 60242, Indonesia",
    "rating": "4.6",
    "reviewCount": 374,
    "placeId": "ChIJ7Q9M_JD71y0RgqAOEJlHCXc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Wdnsdy%20Cafe&query_place_id=ChIJ7Q9M_JD71y0RgqAOEJlHCXc",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 889-8978-5758",
    "website": "https://www.wdnsdy.cc/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "Closed"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 7 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 7 PM"
      },
      {
        "day": "Saturday",
        "hours": "Closed"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "Sawunggaling, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMo0NoIs9VWd6zilVQ6Pv7O71LQ-PHATAf0ib6l=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599040",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJVyuLjwX71y0Rp8--VvroUKY",
    "name": "Fifteenth Cafe by Mark Design",
    "address": "Jl. Lombok No.15, Ngagel, Kec. Wonokromo, Surabaya, Jawa Timur 60246, Indonesia",
    "rating": "4.8",
    "reviewCount": 853,
    "placeId": "ChIJVyuLjwX71y0Rp8--VvroUKY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Fifteenth%20Cafe%20by%20Mark%20Design&query_place_id=ChIJVyuLjwX71y0Rp8--VvroUKY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3415-3064",
    "website": "https://www.instagram.com/fifteenthcafe/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 12 AM"
      }
    ],
    "neighborhood": "Ngagel, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNPc89RKq65IJ2ANFfeqcqXr2fnlNXS-_vbOAZz=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Hard liquor": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599054",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJqdTuC5H71y0R29-9VPhH73o",
    "name": "My Kopi-O!",
    "address": "Jl. Adityawarman No.Town Square Plaza Level unit P 87 - 88, JL. Adityawarman, No. 55, Sawunggaling, Kec. Wonokromo, Surabaya, Jawa Timur 60242, Indonesia",
    "rating": "4.5",
    "reviewCount": 729,
    "placeId": "ChIJqdTuC5H71y0R29-9VPhH73o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=My%20Kopi-O%21&query_place_id=ChIJqdTuC5H71y0R29-9VPhH73o",
    "categories": [
      "Restaurant",
      "Coffee shop",
      "Restaurant or cafe"
    ],
    "phone": "+62 31 5625088",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Sawunggaling, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB84U-sUqsa8M03QlvmplMeggOh-kihGcO4L6LPzbsNKzw0gxSBkVCHr-hpx2vgiBLttHR7Bwb01w1rbPsQNtMeTH4pxU7zO33lzYYmkyMt-5mtypPKP7Unv0uzaZRlqcArbGGUo=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599073",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ0ZF7B5X91y0RwA4nVRMESXU",
    "name": "Baked By Rossa & Hana Roastery",
    "address": "Ruko Villa Bukit Mas, Jl. KH Abdul Wahab Siamin Surabaya Blok RO No.11, Dukuh Pakis, Kec. Dukuhpakis, Surabaya, Jawa Timur 60225, Indonesia",
    "rating": "4.9",
    "reviewCount": 644,
    "placeId": "ChIJ0ZF7B5X91y0RwA4nVRMESXU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Baked%20By%20Rossa%20%26%20Hana%20Roastery&query_place_id=ChIJ0ZF7B5X91y0RwA4nVRMESXU",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Dukuh Pakis, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMG6Wmfp-LqeWtYdXc7Bs5TiP0W2-2S-euqvwBP=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599093",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJZzse6Gv91y0RT3LvO-_LedM",
    "name": "Baccani Cafe",
    "address": "Jl. Raya Wiyung No.20, Kedurus, Kec. Karangpilang, Surabaya, Jawa Timur 60223, Indonesia",
    "rating": "4.6",
    "reviewCount": 223,
    "placeId": "ChIJZzse6Gv91y0RT3LvO-_LedM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Baccani%20Cafe&query_place_id=ChIJZzse6Gv91y0RT3LvO-_LedM",
    "categories": [
      "Art cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Kedurus, Karangpilang",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPKdWl6cHkCcsK-J62jrS3psdUoTMIbGYBefl_U=w408-h413-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599107",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJQWiz3s391y0RJiie_kqOWkY",
    "name": "COFFEE BREAK",
    "address": "Jl. Raya Lontar No.280A, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60217, Indonesia",
    "rating": "4.4",
    "reviewCount": 128,
    "placeId": "ChIJQWiz3s391y0RJiie_kqOWkY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=COFFEE%20BREAK&query_place_id=ChIJQWiz3s391y0RJiie_kqOWkY",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 857-9060-0791",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOI_LDMLgr_Lk315X8e9wS7MnZ1hw8Dc5yp5fgL=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dessert": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599143",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ4bXtVY_81y0RwO8yjHC9tj4",
    "name": "Unity Cafe & Roastery",
    "address": "Gn. Sari Indah BB No.63, Kedurus, Karangpilang, Surabaya, East Java 60223, Indonesia",
    "rating": "4.7",
    "reviewCount": 101,
    "placeId": "ChIJ4bXtVY_81y0RwO8yjHC9tj4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Unity%20Cafe%20%26%20Roastery&query_place_id=ChIJ4bXtVY_81y0RwO8yjHC9tj4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3388-7150",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 11:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 11:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 11:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 11:30 PM"
      },
      {
        "day": "Friday",
        "hours": "2 to 11:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 11:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 11:30 PM"
      }
    ],
    "neighborhood": "Kedurus, Karangpilang",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMUfTYgOFBOjwz4sv8LiaZBQ_93xRPHiYCfn7kz=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.295,
      112.695
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599162",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ0xOwEWD51y0RfJpzJbnymFo",
    "name": "Le Cafe Gourmand",
    "address": "Jl. Mayjend. Jonosewojo, Babatan, Kec. Wiyung, Surabaya, Jawa Timur 60227, Indonesia",
    "rating": "4.6",
    "reviewCount": 915,
    "placeId": "ChIJ0xOwEWD51y0RfJpzJbnymFo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Le%20Cafe%20Gourmand&query_place_id=ChIJ0xOwEWD51y0RfJpzJbnymFo",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 811-3221-2111",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 10 PM"
      }
    ],
    "neighborhood": "Babatan, Wiyung",
    "city": "Surabaya",
    "description": "Cheery cafe with outdoor seating & a relaxed vibe serving coffee drinks, pastries & desserts.",
    "imageUrl": "https://assets-pergikuliner.com/I3Oy_Zym8sRMSsU9MhzOX0HzczI=/fit-in/1366x768/smart/filters:watermark(https://assets-pergikuliner.com/uploads/image/picture/401604/picture-1481204608.png,-0,-3,20):no_upscale()/https://assets-pergikuliner.com/uploads/image/picture/590782/picture-1497595099.jpg",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599176",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ0bwXtan91y0Rrr8BEdJy6K4",
    "name": "Rustic Market",
    "address": "Jl. Golf 1 Surabaya No.159 A, Gn. Sari, Kec. Dukuhpakis, Surabaya, Jawa Timur 60224, Indonesia",
    "rating": "4.5",
    "reviewCount": 1810,
    "placeId": "ChIJ0bwXtan91y0Rrr8BEdJy6K4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rustic%20Market&query_place_id=ChIJ0bwXtan91y0Rrr8BEdJy6K4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 857-8553-6874",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Gunung Sari, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqtmSM11d4jVxmBZGPLlPB7OvZolqkcidohF7HQ0oLvGB46INc74Lg2HaLFbB8m5MpLruQiHPcmMvTnyxbdaqE_KagMoTS36oL2sklOQCjNL4WNJJxE_13PHtisRGl3vjJ5I5sb=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "apify_fresh",
    "region": "Unknown",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599194",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJOaBOfCX71y0RlIDtIQvjgDE",
    "name": "RVANG - Cafe",
    "address": "Jl. Gayung Kebonsari Timur No.202, Ketintang, Kec. Gayungan, Surabaya, Jawa Timur 60232, Indonesia",
    "rating": "4.5",
    "reviewCount": 850,
    "placeId": "ChIJOaBOfCX71y0RlIDtIQvjgDE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=RVANG%20-%20Cafe&query_place_id=ChIJOaBOfCX71y0RlIDtIQvjgDE",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 9 PM"
      }
    ],
    "neighborhood": "Ketintang, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipO00PAOXynLp7NGUH6cYBefM0SI7ixrrS3suFxC=w408-h305-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599211",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJOfCrNEH81y0R4J-kg72lHag",
    "name": "Redback Specialty Coffee",
    "address": "Jl. Raya Golf Graha Famili No.2 Blok K, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60227, Indonesia",
    "rating": "4.6",
    "reviewCount": 3032,
    "placeId": "ChIJOfCrNEH81y0R4J-kg72lHag",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Redback%20Specialty%20Coffee&query_place_id=ChIJOfCrNEH81y0R4J-kg72lHag",
    "categories": [
      "Coffee shop",
      "Breakfast restaurant",
      "Cafe"
    ],
    "phone": "+62 811-3088-8988",
    "website": "https://www.instagram.com/redbackcoffee_indo",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "6 AM to 10 PM"
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPo42J4hbagsLXgCUmnlBD1fiEo0YBNtNuRd1qC=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking garage": true
        },
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "On-site parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599230",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJAZpDj2T71y0RkflKxSpRF9o",
    "name": "Arung Senja",
    "address": "Blok AD No, Ketintang Selatan IX No.1, Karah, Kec. Jambangan, Surabaya, Jawa Timur 60232, Indonesia",
    "rating": "4.6",
    "reviewCount": 662,
    "placeId": "ChIJAZpDj2T71y0RkflKxSpRF9o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Arung%20Senja&query_place_id=ChIJAZpDj2T71y0RkflKxSpRF9o",
    "categories": [
      "Cafe",
      "Coffee shop",
      "Restaurant"
    ],
    "phone": "+62 851-7431-8183",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "Closed"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "12 to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "12 to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "Closed"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "Karah, Jambangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOF39YwY60maFRMqMpFM3rcJ7Bom_0Y31Uuq-OQ=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.3205933,
      112.7219245
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:17:09.386873",
    "coordinates_source": "google_maps_manual",
    "coordinates_verified": true
  },
  {
    "id": "ChIJ86ClFYX81y0R7UfIWKO4IDk",
    "name": "Panjoel Cafe GSI",
    "address": "Perumahan Jl. Gn. sari Indah No.1 Blok L, Kedurus, Kec. Wiyung, Surabaya, Jawa Timur 60233, Indonesia",
    "rating": "4.3",
    "reviewCount": 376,
    "placeId": "ChIJ86ClFYX81y0R7UfIWKO4IDk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Panjoel%20Cafe%20GSI&query_place_id=ChIJ86ClFYX81y0R7UfIWKO4IDk",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 823-3607-0482",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9:30 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9:30 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9:30 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9:30 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9:30 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9:30 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9:30 AM to 10 PM"
      }
    ],
    "neighborhood": "Kedurus, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNrxMy5Vev5hnGuwY4CRXvSTKMC4XwOEt2B90Y=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599244",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJOX0tdYr71y0R2Jhh2q4wJV8",
    "name": "The Cafe",
    "address": "Jl. Mayjen Sungkono No.101-103, Dukuh Pakis, Kec. Dukuhpakis, Surabaya, Jawa Timur 60224, Indonesia",
    "rating": "4.6",
    "reviewCount": 628,
    "placeId": "ChIJOX0tdYr71y0R2Jhh2q4wJV8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=The%20Cafe&query_place_id=ChIJOX0tdYr71y0R2Jhh2q4wJV8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5621234",
    "website": "http://www.javaparagon.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "6 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "6 AM to 10 PM"
      }
    ],
    "neighborhood": "Dukuh Pakis, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPJGZG6s6YQw-ZSQheq6D-fHlRwGshROKqrBqs8=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        },
        {
          "Assistive hearing loop": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        },
        {
          "Upscale": true
        }
      ],
      "Crowd": [
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599262",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJNbecapT71y0RTVLNvukWBnM",
    "name": "Desa Cafe",
    "address": "Jl. Kutai No.mor 29, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.5",
    "reviewCount": 628,
    "placeId": "ChIJNbecapT71y0RTVLNvukWBnM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Desa%20Cafe&query_place_id=ChIJNbecapT71y0RTVLNvukWBnM",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5664748",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 8 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 8 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOeb1uFX8XJch6b9qmMz4Z1X9DlzsT2qreW5EVo=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599284",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJr51wLj371y0RpstQgkVv1F0",
    "name": "CAFE PRAJURIT",
    "address": "Jl. Adityawarman No.48-56 Kav.12, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60242, Indonesia",
    "rating": "4.5",
    "reviewCount": 1400,
    "placeId": "ChIJr51wLj371y0RpstQgkVv1F0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=CAFE%20PRAJURIT&query_place_id=ChIJr51wLj371y0RpstQgkVv1F0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 877-8087-7788",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npoT9zqOwmC0gLgyrQ7qPMq0wZEPKI2ZpVnGoAKwtN2qsrQgER65c1JFF1hrMbFUzt0Wn3ZBXeOSj1Mj4ovXLb8VEYn5jqXhud8ohsBXIe9LMuU0a76BFjxbTioLtNmurHcVJIr=w408-h305-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599298",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ0RxQchb71y0RhsXiRsuQ3jE",
    "name": "Bangi Cafe",
    "address": "Jl. Ahmad Yani No.272, RT.002/RW.01, Menanggal, Kec. Gayungan, Surabaya, Jawa Timur 60234, Indonesia",
    "rating": "4.4",
    "reviewCount": 1009,
    "placeId": "ChIJ0RxQchb71y0RhsXiRsuQ3jE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Bangi%20Cafe&query_place_id=ChIJ0RxQchb71y0RhsXiRsuQ3jE",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 813-3574-4054",
    "website": "https://www.instagram.com/bangicafeahmadyani/?hl=en",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8:30 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8:30 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8:30 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "8:30 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "8:30 AM to 10:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "8:30 AM to 10:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "8:30 AM to 10 PM"
      }
    ],
    "neighborhood": "Menanggal, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMeOmIlsyz9qA-14oG66QXUXCC_phBN44yR89OL=w408-h288-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599314",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJjTrI3J_71y0RBL2L1EfEpBY",
    "name": "Spread Cafe by Tootoomoo",
    "address": "Jl. Opak No.10, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.6",
    "reviewCount": 341,
    "placeId": "ChIJjTrI3J_71y0RBL2L1EfEpBY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Spread%20Cafe%20by%20Tootoomoo&query_place_id=ChIJjTrI3J_71y0RBL2L1EfEpBY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3339-6880",
    "website": "https://www.instagram.com/spread_cafe/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrRX2VGPeZ1lnb23ci6y0Oi3NtQ0fafleoSMlwSWtrKqbvF0iV76JIhSIeO7MYYDlp-h19Q1LHusRzUePkLvKwj-xGWiFpsLhCOmu_loAnmzHiS4RWw8pSR1fVT-EqLQzGbxTaygg=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible seating": true
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible restroom": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Hard liquor": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        },
        {
          "Dogs allowed inside": true
        },
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599329",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ19MeFdn91y0RPu0RRuf5iwI",
    "name": "Han’s Coffee Surabaya",
    "address": "Jl. Griya Kebraon Sel. V No.1, Kebraon, Kec. Karangpilang, Surabaya, Jawa Timur 60222, Indonesia",
    "rating": "4.7",
    "reviewCount": 191,
    "placeId": "ChIJ19MeFdn91y0RPu0RRuf5iwI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Han%E2%80%99s%20Coffee%20Surabaya&query_place_id=ChIJ19MeFdn91y0RPu0RRuf5iwI",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 11 PM"
      }
    ],
    "neighborhood": "Kebraon, Karangpilang",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPq0RpoZdYqI7Nvx8aWNgSBCx5-52wHuibHdqYs=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Organic dishes": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.295,
      112.695
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599353",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJOaj_8PT71y0RRfDyz32WXHY",
    "name": "The Vinyl Chick Cafe",
    "address": "Jl. Gayungsari I No.79, Gayungan, Kec. Gayungan, Surabaya, Jawa Timur 60235, Indonesia",
    "rating": "4.8",
    "reviewCount": 215,
    "placeId": "ChIJOaj_8PT71y0RRfDyz32WXHY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=The%20Vinyl%20Chick%20Cafe&query_place_id=ChIJOaj_8PT71y0RRfDyz32WXHY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3415-7979",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 PM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "12 PM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "12 PM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "12 PM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "12 PM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "12 PM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "12 PM to 12 AM"
      }
    ],
    "neighborhood": "Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMvzrI6L_yjzpSMH_z47I4Iwp3TdWptVrG8pfkM=w408-h612-k-no",
    "additionalInfo": {
      "From the business": [
        {
          "Identifies as women-owned": true
        }
      ],
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599370",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJyY3HUIb71y0RfIwrF9EsUsA",
    "name": "Kaiteki Cafe",
    "address": "Jl. Raya Kendangsari No.64, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60292, Indonesia",
    "rating": "4.9",
    "reviewCount": 93,
    "placeId": "ChIJyY3HUIb71y0RfIwrF9EsUsA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kaiteki%20Cafe&query_place_id=ChIJyY3HUIb71y0RfIwrF9EsUsA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3336-2375",
    "website": "https://instagram.com/kaitekicafe.idn?utm_source=qr&igshid=ZDc4ODBmNjlmNQ%3D%3D",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 9 PM"
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOlounvLXzvBrkDzONS3UKYXRjV_AdsB91CuJUr=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599388",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJP4XDZqz71y0RPJtZWD4TAVM",
    "name": "Ngopibareng Baradjawa - Coffee Shop",
    "address": "Taman Jl. Gayungsari Bar. II No.12, Pagesangan, Kec. Jambangan, Surabaya, Jawa Timur 60233, Indonesia",
    "rating": "4.7",
    "reviewCount": 269,
    "placeId": "ChIJP4XDZqz71y0RPJtZWD4TAVM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Ngopibareng%20Baradjawa%20-%20Coffee%20Shop&query_place_id=ChIJP4XDZqz71y0RPJtZWD4TAVM",
    "categories": [
      "Coffee shop",
      "Cafe",
      "Espresso bar"
    ],
    "phone": "+62 813-6861-8510",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "1 to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "1 to 11 PM"
      }
    ],
    "neighborhood": "Pagesangan, Jambangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPdsPU4g_g5p-mY5MIHz_rvGCjRiXh5c5liFxNi=w408-h297-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599406",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJiXGwnqj91y0RoaOiVxu8BP8",
    "name": "Metro Cafe",
    "address": "Jl. Raya Pagesangan No.48, Pagesangan, Kec. Jambangan, Surabaya, Jawa Timur 60233, Indonesia",
    "rating": "4.3",
    "reviewCount": 302,
    "placeId": "ChIJiXGwnqj91y0RoaOiVxu8BP8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Metro%20Cafe&query_place_id=ChIJiXGwnqj91y0RoaOiVxu8BP8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3108-8997",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Pagesangan, Jambangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNpPuWxz6_lDP-myt4rUwnIE9KnJnySVGice0nS=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599423",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJocrizGT71y0Rog1M-TylmnA",
    "name": "Cafe B.ARU",
    "address": "Jl. Opak No.22, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.8",
    "reviewCount": 297,
    "placeId": "ChIJocrizGT71y0Rog1M-TylmnA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20B.ARU&query_place_id=ChIJocrizGT71y0Rog1M-TylmnA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 815-1508-3822",
    "website": "https://www.instagram.com/b.aru_cafe/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOyA1lO9l8IkGyyizBQPv0YhO25CBOYUa9-kH1S=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599437",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJgQDXVSf71y0RMjSRmah9PMw",
    "name": "SENEWEN TIME",
    "address": "Jl. Menanggal V No.78, Menanggal, Kec. Gayungan, Surabaya, Jawa Timur 60234, Indonesia",
    "rating": "4.4",
    "reviewCount": 3958,
    "placeId": "ChIJgQDXVSf71y0RMjSRmah9PMw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=SENEWEN%20TIME&query_place_id=ChIJgQDXVSf71y0RMjSRmah9PMw",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3450-1615",
    "website": "https://linktr.ee/Senewentime",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Menanggal, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNmTwiYYXGB-yx-gV08G2hcafC_ripTfah5pEfq=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599453",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJl_ykfj771y0RpX6RzbH4Z9Q",
    "name": "Babe Cafe",
    "address": "Jl. Kutisari No.32, Kutisari, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60291, Indonesia",
    "rating": "4.6",
    "reviewCount": 306,
    "placeId": "ChIJl_ykfj771y0RpX6RzbH4Z9Q",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Babe%20Cafe&query_place_id=ChIJl_ykfj771y0RpX6RzbH4Z9Q",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3100-778",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Kutisari, Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNUgU_rDXvex2HN2UXhUWWvGI9NRcakTU07bltN=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599467",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJmQ3Dm7761y0RlW1f8jOA2rg",
    "name": "Eleven Cafe",
    "address": "Jl. Medokan Ayu 2 blok M no.12, Medokan Ayu, Kec. Rungkut, Surabaya, Jawa Timur 60293, Indonesia",
    "rating": "4.3",
    "reviewCount": 354,
    "placeId": "ChIJmQ3Dm7761y0RlW1f8jOA2rg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Eleven%20Cafe&query_place_id=ChIJmQ3Dm7761y0RlW1f8jOA2rg",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-3463-2577",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 1:30 AM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 1:30 AM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 1:30 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 1:30 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 1:30 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 1:30 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 1:30 AM"
      }
    ],
    "neighborhood": "Medokan Ayu, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNj810y3smBwh31w1-PTloqB_ExwIayyQg4CMNm=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599482",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ5zngRmH71y0RGfh6g7B1I4k",
    "name": "Mandalika Cafe",
    "address": "Jl. Gayung Kebonsari No.36, Ketintang, Kec. Gayungan, Surabaya, Jawa Timur 60235, Indonesia",
    "rating": "4.4",
    "reviewCount": 960,
    "placeId": "ChIJ5zngRmH71y0RGfh6g7B1I4k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Mandalika%20Cafe&query_place_id=ChIJ5zngRmH71y0RGfh6g7B1I4k",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-1900-0136",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Ketintang, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nolsjbSRT9CjnMhGg5jp4antcG9VwaPhxwhzuH66qEZcjAWx0w-u-V3sX2er6YKZBaaeObovg7x7Cw4J-qTL6wIg1PjEtuaV18wrLfen5Hi-14XQ--X4Cx01T6Zi5NxGfFdaV2g=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.646Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599499",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJoVoE20n71y0Rw-1M2RJh0Qg",
    "name": "VERTE Café",
    "address": "Jl. Jambi No.47, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.7",
    "reviewCount": 737,
    "placeId": "ChIJoVoE20n71y0Rw-1M2RJh0Qg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=VERTE%20Caf%C3%A9&query_place_id=ChIJoVoE20n71y0Rw-1M2RJh0Qg",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-2112-345",
    "website": "https://linktr.ee/Vertecafe",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOUf4wU006Iuwqc9Tz1PRtS3FlEtYcmsXgSiOWv=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599513",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ1wDz7y371y0RuCeu5DlR40A",
    "name": "ASIX Café - Gayungsari Timur",
    "address": "Jl. Gayungsari Tim. No.35, Menanggal, Kec. Gayungan, Surabaya, Jawa Timur 60234, Indonesia",
    "rating": "4.3",
    "reviewCount": 314,
    "placeId": "ChIJ1wDz7y371y0RuCeu5DlR40A",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=ASIX%20Caf%C3%A9%20-%20Gayungsari%20Timur&query_place_id=ChIJ1wDz7y371y0RuCeu5DlR40A",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-5256-6081",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Menanggal, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPw5Rg6nBCBxDic1eta1gfYuZALusLdqszEhTc8=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599533",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJy8smEpT61y0RhICVUOMhIFQ",
    "name": "Adakopi",
    "address": "Jl. Pandugo Tim. X No.5, Wonorejo, Kec. Rungkut, Surabaya, Jawa Timur 60297, Indonesia",
    "rating": "4.7",
    "reviewCount": 129,
    "placeId": "ChIJy8smEpT61y0RhICVUOMhIFQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Adakopi&query_place_id=ChIJy8smEpT61y0RhICVUOMhIFQ",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 822-4535-5678",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 12 AM"
      }
    ],
    "neighborhood": "Wonorejo, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPHRt2j_b7pN_UTJJ9L91Egep1B5Dtsb5oj2YnU=w425-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599547",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJKdSIDhr61y0RqO5dqGe5lrk",
    "name": "Casa Coffee",
    "address": "Ruko 21 Klampis, Blok F7, Klampis Ngasem, Sukolilo, Surabaya, East Java 60117, Indonesia",
    "rating": "4.7",
    "reviewCount": 265,
    "placeId": "ChIJKdSIDhr61y0RqO5dqGe5lrk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Casa%20Coffee&query_place_id=ChIJKdSIDhr61y0RqO5dqGe5lrk",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 822-3382-6405",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 8 PM"
      },
      {
        "day": "Saturday",
        "hours": "3 to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "3 to 10 PM"
      }
    ],
    "neighborhood": "Klampis Ngasem, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPbeMGZjxX37owe4BKHr7rLtNRSLZSlCX5UyDPH=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599562",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJj84dcH771y0RrPjyBh6aYPc",
    "name": "Warung Kopi Gudang Arang",
    "address": "Jl. Wonocolo Pabrik Kulit No.84, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.5",
    "reviewCount": 140,
    "placeId": "ChIJj84dcH771y0RrPjyBh6aYPc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warung%20Kopi%20Gudang%20Arang&query_place_id=ChIJj84dcH771y0RrPjyBh6aYPc",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 853-3474-4802",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "1 PM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 12 AM"
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPGMQyB2lxh90BWPOzGG8DUk7P_YpYZ3wNZRMU6=w493-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599580",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJv2C9WoD-1y0R_rRJ1thvTPU",
    "name": "Baretta Coffee Shop",
    "address": "No.4 No.43L Lontar Sambikerep Kota Surabaya Jawa Timur ID 60216, Jl. Candi Lontar Kulon, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.5",
    "reviewCount": 142,
    "placeId": "ChIJv2C9WoD-1y0R_rRJ1thvTPU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Baretta%20Coffee%20Shop&query_place_id=ChIJv2C9WoD-1y0R_rRJ1thvTPU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-3451-3557",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPK8VCDldhw0ZHDXLfq6Q64QmCeQ9a9W7EDec-y=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599648",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJpQ5bdb3_1y0RyjHz4tFvQdM",
    "name": "HAUS! Manukan",
    "address": "Samping Kampoeng Roti, Jl. Manukan Tama Jl. Raya Manukan Kulon No.A3 No 27, Manukan Kulon, Kec. Tandes, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.2",
    "reviewCount": 246,
    "placeId": "ChIJpQ5bdb3_1y0RyjHz4tFvQdM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=HAUS%21%20Manukan&query_place_id=ChIJpQ5bdb3_1y0RyjHz4tFvQdM",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Manukan Kulon, Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB-j2yydu3bJuMD7Cz2ksggYZllPSkOG4sxCqiJ-qJfEkxeqmqfcDMHD2oow_4DjdDWscdhOLgH5drSNrmtjrdeDWfBb24JkiyTNX0VsS06q3GwCDYu3OpHqBcuriQp9NAsGEfx1=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.258,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599661",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJgeYC11X81y0RMAaXK_61cUY",
    "name": "Warkop Giras Senja Cak Gondrong",
    "address": "Jl. Raya Lidah Wetan No.23, Lidah Wetan, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.5",
    "reviewCount": 130,
    "placeId": "ChIJgeYC11X81y0RMAaXK_61cUY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Giras%20Senja%20Cak%20Gondrong&query_place_id=ChIJgeYC11X81y0RMAaXK_61cUY",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 857-8565-7347",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Lidah Wetan, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMsYoP9zRfzjoe-ws06eGFatZUG7nU1xdCGtEye=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.289,
      112.632
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599674",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJZ2rmL37-1y0ReMEHfFO5EPk",
    "name": "Jangkrik Vape Store Surabaya",
    "address": "Jl. Candi Lontar Kulon No.44 Blok L, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.1",
    "reviewCount": 211,
    "placeId": "ChIJZ2rmL37-1y0ReMEHfFO5EPk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Jangkrik%20Vape%20Store%20Surabaya&query_place_id=ChIJZ2rmL37-1y0ReMEHfFO5EPk",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-3379-3360",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "2 to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "2 to 11 PM"
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNLqGDZXgeGSFv1EIebgpKXodf6uW6Qq2V_xtDo=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599720",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJGYF9D2P51y0RsHYgHqaK6_A",
    "name": "Kafe Kata Kata",
    "address": "WTC TS 5-6, Jl. Pemuda No.27-31, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271, Indonesia",
    "rating": "4.3",
    "reviewCount": 82,
    "placeId": "ChIJGYF9D2P51y0RsHYgHqaK6_A",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kafe%20Kata%20Kata&query_place_id=ChIJGYF9D2P51y0RsHYgHqaK6_A",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 813-3986-6006",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 to 6 AM, 10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "12 to 6 AM, 10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "12 to 6 AM, 10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "12 to 6 AM, 10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "12 to 6 AM, 10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "12 to 6 AM, 10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "12 to 6 AM, 10 AM to 12 AM"
      }
    ],
    "neighborhood": "Embong Kaliasin, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOOiSXcZbiDYQmqE7GW8pqWMUB2665Db2JbyvyD=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599734",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJbwgHW-L_1y0REKBXZjOxON0",
    "name": "Nomcherrycafe 2",
    "address": "Jl. Manukan Tengah No.6J No. 16, Manukan Kulon, Kec. Tandes, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.7",
    "reviewCount": 326,
    "placeId": "ChIJbwgHW-L_1y0REKBXZjOxON0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Nomcherrycafe%202&query_place_id=ChIJbwgHW-L_1y0REKBXZjOxON0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 878-5323-7305",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Manukan Kulon, Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noxQIdqglE-UYtOnnGcq9su5tj5RdQbZ60rAiVSxvbNQnjLJUPD_wkRMdPOUOC9FFVN0sYs2H8AFW93AF-Jqb5v7DmIhL_cQEIgjx56MZ_IPmdQK_GOuNp1PZCYqaqmKs8W5VEewg=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.258,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599747",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ65imZUL71y0RT2Fgm7A8Pa0",
    "name": "Tan xiang Kopitiam",
    "address": "Jl. Dr. Ir. H. Soekarno No.8, Manyar Sabrangan, Kec. Mulyorejo, Surabaya, Jawa Timur 60115, Indonesia",
    "rating": "4.9",
    "reviewCount": 129,
    "placeId": "ChIJ65imZUL71y0RT2Fgm7A8Pa0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tan%20xiang%20Kopitiam&query_place_id=ChIJ65imZUL71y0RT2Fgm7A8Pa0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-4099-8807",
    "website": "https://instagram.com/tanxiang.kopitiam/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 3 PM"
      },
      {
        "day": "Saturday",
        "hours": "6:30 AM to 2 PM"
      },
      {
        "day": "Sunday",
        "hours": "6:30 AM to 2 PM"
      }
    ],
    "neighborhood": "Manyar Sabrangan, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN0w_CtvxNDXW8v_LG-Re6U-pTV_94GvWywWXoW=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Family-friendly": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599762",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJlZR0kyj71y0RNbwicD9WA1c",
    "name": "Avia's Kitchen San Antonio (Cafe)",
    "address": "Ruko San Antonio N1-86 dan 88 Pakuwon City, Kalisari, Kec. Mulyorejo, Surabaya, Jawa Timur 60112, Indonesia",
    "rating": "4.6",
    "reviewCount": 272,
    "placeId": "ChIJlZR0kyj71y0RNbwicD9WA1c",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Avia%27s%20Kitchen%20San%20Antonio%20%28Cafe%29&query_place_id=ChIJlZR0kyj71y0RNbwicD9WA1c",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3461-231",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "6:30 AM to 9:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "6:30 AM to 9:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "6:30 AM to 9:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "6:30 AM to 9:30 PM"
      },
      {
        "day": "Friday",
        "hours": "6:30 AM to 9:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "6:30 AM to 9:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "6:30 AM to 9:30 PM"
      }
    ],
    "neighborhood": "Kalisari, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM1B-0MA_7AXn9IWIhOZDPwqcovux0cc4JRB4IS=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599777",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJbUm9Enz-1y0REHXwevxrN2U",
    "name": "Warna Cafe",
    "address": "Jl. Manukan Tengah No.6 Blok 9 K, Manukan Kulon, Kec. Tandes, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.2",
    "reviewCount": 145,
    "placeId": "ChIJbUm9Enz-1y0REHXwevxrN2U",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warna%20Cafe&query_place_id=ChIJbUm9Enz-1y0REHXwevxrN2U",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 878-7142-9662",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Manukan Kulon, Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOnoFZ7IENeEwe6B-Lk2C-5F5dUEO3GO_dPRffy=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.258,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599790",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJzYfmvCn61y0RVTwr7jhZP_k",
    "name": "Bebini Gelati Café",
    "address": "Jl. Dharmahusada No.183-185, Mojo, Kec. Gubeng, Surabaya, Jawa Timur 60285, Indonesia",
    "rating": "4.6",
    "reviewCount": 1051,
    "placeId": "ChIJzYfmvCn61y0RVTwr7jhZP_k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Bebini%20Gelati%20Caf%C3%A9&query_place_id=ChIJzYfmvCn61y0RVTwr7jhZP_k",
    "categories": [
      "Cafe",
      "Ice cream shop"
    ],
    "phone": "+62 819-3309-9922",
    "website": "https://www.instagram.com/bebinigelati/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "12 to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "12 to 9 PM"
      }
    ],
    "neighborhood": "Mojo, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM5FJEUCPK-hJWIrKHPHkJ5VX8Z-rEb85WjJrUs=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599805",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJOQXUyXH71y0Rne4JXc3cUro",
    "name": "Kopi Konnichiwa Dharmahusada",
    "address": "Jl. Dharmahusada Indah Bar. No.I 3G, Mojo, Kec. Gubeng, Surabaya, Jawa Timur 60285, Indonesia",
    "rating": "4.7",
    "reviewCount": 159,
    "placeId": "ChIJOQXUyXH71y0Rne4JXc3cUro",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Konnichiwa%20Dharmahusada&query_place_id=ChIJOQXUyXH71y0Rne4JXc3cUro",
    "categories": [
      "Coffee shop",
      "Cafe",
      "Coffee roasters",
      "Dog cafe"
    ],
    "phone": "+62 816-530-574",
    "website": "https://r.grab.com/g/6-20240615_184425_305BC65673364CA186595026DD741740_MEXMPS-6-C2MALBTALPNDVT",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 9 PM"
      }
    ],
    "neighborhood": "Mojo, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN-i0g8_ezNV-VsXbIH-e8MzTYh0HZsN2GiImPL=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599819",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ2fSFnRf61y0RPTigOOmQ9_A",
    "name": "Warung Permai 91",
    "address": "PQGQ+5W4, Jl. Wisma Permai Tengah, Mulyorejo, Kec. Mulyorejo, Surabaya, Jawa Timur 60115, Indonesia",
    "rating": "4.5",
    "reviewCount": 108,
    "placeId": "ChIJ2fSFnRf61y0RPTigOOmQ9_A",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warung%20Permai%2091&query_place_id=ChIJ2fSFnRf61y0RPTigOOmQ9_A",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 11 PM"
      }
    ],
    "neighborhood": "Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPa07aeWvVuczLpWt7bAAfjxWQ7kzHmgrvrQT91=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599834",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJJ3FJ0Rf71y0RYYqpBfia59A",
    "name": "Hao Peng You Kopitiam",
    "address": "San Diego Mainstreet, MR, Jl. Kalisari Permai I No.127, Kalisari, Mulyorejo, Surabaya, East Java 60112, Indonesia",
    "rating": "4.4",
    "reviewCount": 122,
    "placeId": "ChIJJ3FJ0Rf71y0RYYqpBfia59A",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Hao%20Peng%20You%20Kopitiam&query_place_id=ChIJJ3FJ0Rf71y0RYYqpBfia59A",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 851-5932-8411",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "6:30 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "6:30 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "6:30 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "6:30 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "6:30 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "6:30 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "6:30 AM to 9 PM"
      }
    ],
    "neighborhood": "Kalisari, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNg8PdTnSxkTmQr-9ICoT8wbYIrmbHTTvC8qp7y=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599849",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJdV7LcQn71y0R30Pw96R1_tE",
    "name": "Djournal Coffee - Galaxy Mall 3",
    "address": "Galaxy Mall 3. Ground Floor. Lobby North West. Pintu 11, Jl. Dr. Ir. H. Soekarno No.178, Mulyorejo, Kec. Mulyorejo, Surabaya, Jawa Timur 60115, Indonesia",
    "rating": "4.6",
    "reviewCount": 191,
    "placeId": "ChIJdV7LcQn71y0R30Pw96R1_tE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Djournal%20Coffee%20-%20Galaxy%20Mall%203&query_place_id=ChIJdV7LcQn71y0R30Pw96R1_tE",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 31 5980280",
    "website": "https://www.ismaya.com/eat-drink/djournal",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNbqenNhIFIwkLbT4NbAifKb6WPIcmXIJVVQQdW=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599866",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJA-iQ-QL71y0RRvDRWWVjpQw",
    "name": "CO.CHOC Pakuwon City",
    "address": "Jl. Kalisari Permai I No.101, Kalisari, Kec. Mulyorejo, Surabaya, Jawa Timur 60112, Indonesia",
    "rating": "4.7",
    "reviewCount": 87,
    "placeId": "ChIJA-iQ-QL71y0RRvDRWWVjpQw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=CO.CHOC%20Pakuwon%20City&query_place_id=ChIJA-iQ-QL71y0RRvDRWWVjpQw",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-3145-7732",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Kalisari, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB-DmhiZ2m6NUQgZc41LXh_diR8gTj3N3CWrPQd6QyKzhiSppQKu6wQMmlw9cFU4wTpaDwfnYkqkUmscAAVV1drxlLifIhEglfz4rHYAnZ3P5Wo55KfFXPwnEzJMkuNPKy23YnM=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599881",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJBQDQvzz61y0R9WxULwqkhgk",
    "name": "Tous les Jours Cafe - Galaxy Mall 1",
    "address": "Level 2, Galaxy Mall 1, Jl. Dr. Ir. H. Soekarno No.35-39, Mulyorejo, Kec. Mulyorejo, Surabaya, Jawa Timur 60115, Indonesia",
    "rating": "4.5",
    "reviewCount": 279,
    "placeId": "ChIJBQDQvzz61y0R9WxULwqkhgk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tous%20les%20Jours%20Cafe%20-%20Galaxy%20Mall%201&query_place_id=ChIJBQDQvzz61y0R9WxULwqkhgk",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5967773",
    "website": "https://tlj.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqhbTOYxhVs8mMoteyHLow_9KblOzvulKhniA7Wf_L-rJKCJ_9r1Z6yjV-F-x7_0CR-aDw26yBYliKgiBtWAmF2m31-BQUgA5uzv7MJFGXeLdQ8cK9q4NCXqPi0Tmf_rtDBsD88=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "In-store pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        }
      ],
      "Planning": [
        {
          "Quick visit": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599897",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ45N8Ds791y0RdViowW4jeS4",
    "name": "Warkop Sandang Pangan sp",
    "address": "Gg. VII Utara No.74, Lidah Wetan, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.6",
    "reviewCount": 71,
    "placeId": "ChIJ45N8Ds791y0RdViowW4jeS4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Sandang%20Pangan%20sp&query_place_id=ChIJ45N8Ds791y0RdViowW4jeS4",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": "http://instagram.com/sandangpangan_sp",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Lidah Wetan, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOThV-toNlMVtt47BN4MzVSUqUM-OYUPS-uYYaO=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.289,
      112.632
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599909",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ04GoZNL51y0RnVPPHp4TAF8",
    "name": "Dexter Cafe",
    "address": "Ruko Biz Home Blok RL-6 No.36, Jl. Kalisari Timur XVI, Jawa Timur, Indonesia",
    "rating": "4.5",
    "reviewCount": 105,
    "placeId": "ChIJ04GoZNL51y0RnVPPHp4TAF8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Dexter%20Cafe&query_place_id=ChIJ04GoZNL51y0RnVPPHp4TAF8",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "2 PM to 12 AM"
      }
    ],
    "neighborhood": null,
    "city": null,
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNBMwrvk9yjNxkwk2k4lrKfTkj1sd6la_DgNC36=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Hard liquor": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "Unknown",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599946",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJg3AAmeL91y0RczNl0NO9ZRA",
    "name": "Rustic Market by The Lake - Graha Natura",
    "address": "Cafe Rustic Market Graha Natura, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur, Indonesia",
    "rating": "4.3",
    "reviewCount": 961,
    "placeId": "ChIJg3AAmeL91y0RczNl0NO9ZRA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Rustic%20Market%20by%20The%20Lake%20-%20Graha%20Natura&query_place_id=ChIJg3AAmeL91y0RczNl0NO9ZRA",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 857-9156-2236",
    "website": "https://instagram.com/rusticmarket.id?igshid=YmMyMTA2M2Y=",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 9 PM"
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPkdd_8arINh9zoJqhaM-gig4oOFjwJDV3zO8D1=w408-h612-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.599998",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ97mGC7P61y0REPMwwk2h0-U",
    "name": "Warkop Menol",
    "address": "Jl. Gn. Anyar Jaya No.1, Gn. Anyar, Kec. Gn. Anyar, Surabaya, Jawa Timur 60294, Indonesia",
    "rating": "4.4",
    "reviewCount": 176,
    "placeId": "ChIJ97mGC7P61y0REPMwwk2h0-U",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Menol&query_place_id=ChIJ97mGC7P61y0REPMwwk2h0-U",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 838-6686-4484",
    "website": null,
    "openingHours": [],
    "neighborhood": "Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM0Ptb2TuxIjvpJEED25A2V0wVZDZSWiiQDGwie=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600029",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJNV0_PAb61y0Rt7D_ZPvP0xY",
    "name": "Fruto",
    "address": "Ruko San Diego MR1-9,, Kejawaan Putih Tamba, Kec. Mulyorejo, Surabaya, Jawa Timur 60112, Indonesia",
    "rating": "4.5",
    "reviewCount": 423,
    "placeId": "ChIJNV0_PAb61y0Rt7D_ZPvP0xY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Fruto&query_place_id=ChIJNV0_PAb61y0Rt7D_ZPvP0xY",
    "categories": [
      "Ice cream shop",
      "Cafe"
    ],
    "phone": "+62 31 5923866",
    "website": "https://www.instagram.com/frutogelato/?hl=en",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Kejawaan Putih Tamba, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNgDCesJE7VqvZu4U2ZQTK113mRdA5fjtOXyi-Y=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "In-store pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Same-day delivery": false
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Quick visit": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600044",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ3URes_v71y0Re2MDP6YUc-k",
    "name": "Excelso Dharmahusada",
    "address": "Jl. Dr. Ir. H. Soekarno No.28 Blok L-179, Mulyorejo, Kec. Mulyorejo, Surabaya, Jawa Timur 60115, Indonesia",
    "rating": "4.6",
    "reviewCount": 485,
    "placeId": "ChIJ3URes_v71y0Re2MDP6YUc-k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Excelso%20Dharmahusada&query_place_id=ChIJ3URes_v71y0Re2MDP6YUc-k",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-2338-3383",
    "website": "https://excelso-coffee.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 12 AM"
      }
    ],
    "neighborhood": "Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOFpMz9hD1VZTv2yBbJkYznf8Ikf8nfFURNxOkq=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.267,
      112.86
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600056",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ9xWWokP41y0RuSwsiWGhX1w",
    "name": "Cafe Bawah Jembatan Suramadu",
    "address": "QQRH+M9G, Tambak Wedi, Kenjeran, Surabaya, East Java 60126, Indonesia",
    "rating": "4.3",
    "reviewCount": 1327,
    "placeId": "ChIJ9xWWokP41y0RuSwsiWGhX1w",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20Bawah%20Jembatan%20Suramadu&query_place_id=ChIJ9xWWokP41y0RuSwsiWGhX1w",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Tambak Wedi, Kenjeran",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOwZaIFMOPMnP1uAuwRjzptpl0oFZ-jIl0_v-XN=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": false
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.78
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600073",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ6SWtCXL51y0RC6W0TxjFHoA",
    "name": "Savory Pasticceria",
    "address": "Jl. Dr. Ir. H. Soekarno No.87, Mulyorejo, Kec. Mulyorejo, Surabaya, Jawa Timur 60115, Indonesia",
    "rating": "4.8",
    "reviewCount": 122,
    "placeId": "ChIJ6SWtCXL51y0RC6W0TxjFHoA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Savory%20Pasticceria&query_place_id=ChIJ6SWtCXL51y0RC6W0TxjFHoA",
    "categories": [
      "Dessert shop",
      "Cafe"
    ],
    "phone": "+62 822-2887-7515",
    "website": "http://www.savorypasticceria.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "Closed"
      },
      {
        "day": "Wednesday",
        "hours": "Closed"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 8 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 8 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 8 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 7 PM"
      }
    ],
    "neighborhood": "Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipO-O0U2XeEnOGORGJeFi5yNpNVkDtvwgLvPSPMo=w408-h757-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "In-store pickup": true
        },
        {
          "In-store shopping": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Same-day delivery": true
        }
      ],
      "Planning": [
        {
          "Quick visit": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600088",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJgRjyGOj71y0RybPBNcwk7Xo",
    "name": "Kedai Ori San Antonio",
    "address": "Pakuwon City, Ruko San Antonio Blok N 1 No.136-138, Kalisari, Kec. Mulyorejo, Surabaya, Jawa Timur 60112, Indonesia",
    "rating": "4.5",
    "reviewCount": 544,
    "placeId": "ChIJgRjyGOj71y0RybPBNcwk7Xo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Ori%20San%20Antonio&query_place_id=ChIJgRjyGOj71y0RybPBNcwk7Xo",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 815-1505-5136",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 10 PM"
      }
    ],
    "neighborhood": "Kalisari, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMoDTiF4hQ7p13Hlb3wUoPIiUbSV4YxMDPKmzbW=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600103",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJSz89zmL-1y0RKJzSLG_Cx_0",
    "name": "nomcherycafe 1",
    "address": "Jl. Manukan Tengah IV No.6b/7, Manukan Kulon, Kec. Tandes, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.5",
    "reviewCount": 1028,
    "placeId": "ChIJSz89zmL-1y0RKJzSLG_Cx_0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=nomcherycafe%201&query_place_id=ChIJSz89zmL-1y0RKJzSLG_Cx_0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 878-5521-0770",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Manukan Kulon, Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npRdEXrzBwgLLBp4YO3AIXxnce4NYUWT1T02KujktFmK11AEb02882ubyvqHrO0cEcu7_4qD5HEtKyy31ocCfbn8T-1b8A6pmRfio4CsgrJhNxfN2hmNPislmvp5hts6dzIdTK9=w506-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.2648109,
      112.6583045
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T19:52:39.811573",
    "coordinates_source": "google_maps_manual",
    "coordinates_estimated": true,
    "coordinates_verified": true
  },
  {
    "id": "ChIJx1h7B-D71y0RBiZKPjjPiJI",
    "name": "Lincafe - Galaxy Mall 3",
    "address": "Galaxy Mall, Jl. Dr. Ir. H. Soekarno No.3 3rd Floor, Mulyorejo, Surabaya, East Java 60115, Indonesia",
    "rating": "4.7",
    "reviewCount": 363,
    "placeId": "ChIJx1h7B-D71y0RBiZKPjjPiJI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Lincafe%20-%20Galaxy%20Mall%203&query_place_id=ChIJx1h7B-D71y0RBiZKPjjPiJI",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 821-2482-8090",
    "website": "https://www.instagram.com/lincaferesto",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPb-3ZhpW6Ka5YLc9r4kH5DlItGPWKlh3HLjUro=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600132",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJo-qPSm7_1y0Rxid8vp6TTRI",
    "name": "JUN COFFEE 27",
    "address": "Junior High School State 26 of Surabaya, Banjar Sugihan, Tandes, Surabaya, East Java 60185, Indonesia",
    "rating": "4.4",
    "reviewCount": 162,
    "placeId": "ChIJo-qPSm7_1y0Rxid8vp6TTRI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=JUN%20COFFEE%2027&query_place_id=ChIJo-qPSm7_1y0Rxid8vp6TTRI",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3177-7517",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Banjar Sugihan, Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNVCXjRhiGdiFY73Qj9dvXRlRFzPmwq8YwjkzR_=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.258,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600145",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJOxSJmrj61y0RDQT-sdzYEek",
    "name": "Warkop Rojak",
    "address": "MQ9P+8XH, Rungkut Kidul, Rungkut, Surabaya, East Java 60293, Indonesia",
    "rating": "4.7",
    "reviewCount": 75,
    "placeId": "ChIJOxSJmrj61y0RDQT-sdzYEek",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Rojak&query_place_id=ChIJOxSJmrj61y0RDQT-sdzYEek",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Rungkut Kidul, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMeiW5JbZ5vyvoE4eOTa_4VfNiqty2z4FJ3Y5-O=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600159",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJcdXBAbr_1y0Rltft_zOIJa4",
    "name": "Loka Coffee and Eatery Manukan Surabaya",
    "address": "Jl. Manukan Tama No.17, Manukan Kulon, Kec. Tandes, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.3",
    "reviewCount": 252,
    "placeId": "ChIJcdXBAbr_1y0Rltft_zOIJa4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Loka%20Coffee%20and%20Eatery%20Manukan%20Surabaya&query_place_id=ChIJcdXBAbr_1y0Rltft_zOIJa4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 897-0447-788",
    "website": "https://instagram.com/lokasurabaya",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 12 AM"
      }
    ],
    "neighborhood": "Manukan Kulon, Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipO8PECW1fYxHLHy41iEQidzKoHb8axzpNVhxyMW=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.258,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600172",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJyQhQOXz-1y0RodUXruObAFo",
    "name": "PANJOEL cafe",
    "address": "Jl. Manukan Tengah No.14 Blok 6J, Manukan Kulon, Kec. Tandes, Surabaya, Jawa Timur 60185, Indonesia",
    "rating": "4.5",
    "reviewCount": 868,
    "placeId": "ChIJyQhQOXz-1y0RodUXruObAFo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=PANJOEL%20cafe&query_place_id=ChIJyQhQOXz-1y0RodUXruObAFo",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3599-9499",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Friday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "9:30 AM to 9:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "9:30 AM to 9:30 PM"
      }
    ],
    "neighborhood": "Manukan Kulon, Tandes",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOmhL9OCV6J8os6pEUuEWHA7hRJtVvwrJug67UF=w480-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.258,
      112.678
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600184",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ4wvLXkb71y0RKoKmpDTTfmM",
    "name": "Ektar Coffee",
    "address": "Jl. Pucang Adi No.145, Kertajaya, Kec. Gubeng, Surabaya, Jawa Timur 60282, Indonesia",
    "rating": "4.8",
    "reviewCount": 131,
    "placeId": "ChIJ4wvLXkb71y0RKoKmpDTTfmM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Ektar%20Coffee&query_place_id=ChIJ4wvLXkb71y0RKoKmpDTTfmM",
    "categories": [
      "Espresso bar",
      "Cafe"
    ],
    "phone": "+62 858-1286-1106",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Kertajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipO9h0Ervj-vc0f6t_d7WAl2WRcgruD8g_nYPmJJ=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Appointment required": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600197",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJczw9GdP71y0RzToYbEpTbI8",
    "name": "Borre Cafe",
    "address": "Jl. Raya Dharma Husada Indah No.4 (A-8, Mojo, Kec. Gubeng, Surabaya, Jawa Timur 60285, Indonesia",
    "rating": "4.6",
    "reviewCount": 802,
    "placeId": "ChIJczw9GdP71y0RzToYbEpTbI8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Borre%20Cafe&query_place_id=ChIJczw9GdP71y0RzToYbEpTbI8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 859-5485-9984",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Mojo, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN-sGNKS8etWYg0CVN6Hpmeem9pbELQWqLtR3Bu=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great tea selection": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600210",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJs-biDh361y0Rs5fuTMRrqzg",
    "name": "Kafetien 88",
    "address": "Jl. Raya Mulyosari Blok AA No. 06, Kalisari, Kec. Mulyorejo, Surabaya, Jawa Timur 60112, Indonesia",
    "rating": "4.5",
    "reviewCount": 894,
    "placeId": "ChIJs-biDh361y0Rs5fuTMRrqzg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kafetien%2088&query_place_id=ChIJs-biDh361y0Rs5fuTMRrqzg",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 31 5965100",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 2 PM, 5 to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 2 PM, 5 to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 2 PM, 5 to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 2 PM, 5 to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 2 PM, 5 to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 2 PM, 5 to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 2 PM, 5 to 9 PM"
      }
    ],
    "neighborhood": "Kalisari, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMzW3yFpXa_mIaDbX4te0gJzhD1WabEqibZowS6=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600225",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJgykKK4b71y0RKxdN4ZPMu8c",
    "name": "Warkop REVO MERR",
    "address": "MQ6P+42M, Gunung Anyar, Surabaya, East Java 60294, Indonesia",
    "rating": "4.4",
    "reviewCount": 357,
    "placeId": "ChIJgykKK4b71y0RKxdN4ZPMu8c",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20REVO%20MERR&query_place_id=ChIJgykKK4b71y0RKxdN4ZPMu8c",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNByJmnOluJ3qPF0BOYEqM9ly6v3-YoKPyV9Rjg=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.289,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600242",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ7cBB0BP71y0RYSuK7Jn4FQw",
    "name": "MOMOE WarKop",
    "address": "PS I, Jl. Penjaringan Asri No.41-42 blok A, Penjaringan Sari, Rungkut, Surabaya, East Java 60295, Indonesia",
    "rating": "4.5",
    "reviewCount": 141,
    "placeId": "ChIJ7cBB0BP71y0RYSuK7Jn4FQw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=MOMOE%20WarKop&query_place_id=ChIJ7cBB0BP71y0RYSuK7Jn4FQw",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 896-1817-9034",
    "website": "http://www.facebook.com/jenenge.jenenge.90",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 1 AM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 1 AM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 1 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 1 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 1 AM"
      }
    ],
    "neighborhood": "Penjaringan Sari, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOYbO_CAWpkQ64hF6MynJBXgd7UlP_TCLJTq2Sa=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600256",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJfdL42S751y0RmW4j_1tWtgg",
    "name": "Artap Cafe & Art Gallery",
    "address": "Jl. Dr. Ir. H. Soekarno No.34 3rd floor, Kalijudan, Mulyorejo, Surabaya, East Java 60114, Indonesia",
    "rating": "4.4",
    "reviewCount": 603,
    "placeId": "ChIJfdL42S751y0RmW4j_1tWtgg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Artap%20Cafe%20%26%20Art%20Gallery&query_place_id=ChIJfdL42S751y0RmW4j_1tWtgg",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 819-1330-4555",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "11 AM to 10 PM"
      }
    ],
    "neighborhood": "Kalijudan, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOINxNdTJeQwyp-fbeu74dK8luGq8HEl1AqIptD=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Hard liquor": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600271",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJsQCFK6z61y0R957wGoGNatM",
    "name": "Raya Kopi",
    "address": "MR62+4PP, Jl. Raya Wiguna Timur No.68, Gn. Anyar Tambak, Kec. Gn. Anyar, Surabaya, Jawa Timur 60294, Indonesia",
    "rating": "4.5",
    "reviewCount": 464,
    "placeId": "ChIJsQCFK6z61y0R957wGoGNatM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Raya%20Kopi&query_place_id=ChIJsQCFK6z61y0R957wGoGNatM",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 878-2498-9888",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Tuesday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Wednesday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Thursday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Friday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "6 AM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "6 AM to 1 AM"
      }
    ],
    "neighborhood": "Gunung Anyar Tambak, Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNGD92VHKvEkewSLdDBV6iTbfrQaFADP19g7agE=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600302",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ03UOL9f51y0RQT7KnwSacRo",
    "name": "Ost Coffee MERR",
    "address": "Kompleks Ruko Este Square Blok D2-D3, Mulyorejo, Kec. Mulyorejo, Surabaya, Jawa Timur 60115, Indonesia",
    "rating": "4.6",
    "reviewCount": 636,
    "placeId": "ChIJ03UOL9f51y0RQT7KnwSacRo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Ost%20Coffee%20MERR&query_place_id=ChIJ03UOL9f51y0RQT7KnwSacRo",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 821-4089-5393",
    "website": "https://instagram.com/ostcoffee_sby",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipM0JaO4fbczBlPg7Tjmc4s2l735oUHf9w86GQqA=w408-h510-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600317",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJnfoj5wP71y0R7WHaUCyfttU",
    "name": "KedaiMaian",
    "address": "Jl. Nusa Indah No.16, Medokan Ayu, Kec. Rungkut, Surabaya, Jawa Timur 60295, Indonesia",
    "rating": "4.5",
    "reviewCount": 214,
    "placeId": "ChIJnfoj5wP71y0R7WHaUCyfttU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KedaiMaian&query_place_id=ChIJnfoj5wP71y0R7WHaUCyfttU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 819-3813-9139",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 11 PM"
      }
    ],
    "neighborhood": "Medokan Ayu, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMAQFsADT0_fSd4z882bPdYF0HCC8KyWL0LSrzm=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600330",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJgYB-AQD71y0RLqJ0cOFNG4M",
    "name": "Lot#1 coffee Bar",
    "address": "Mapan, @Clubhouse Grand Peninsula, Jl. Sutorejo Barat, Mulyorejo, Kec. Mulyorejo, Surabaya, Jawa Timur 60112, Indonesia",
    "rating": "4.8",
    "reviewCount": 385,
    "placeId": "ChIJgYB-AQD71y0RLqJ0cOFNG4M",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Lot%231%20coffee%20Bar&query_place_id=ChIJgYB-AQD71y0RLqJ0cOFNG4M",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 823-3256-8086",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 9 PM"
      }
    ],
    "neighborhood": "Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMZj0ufawQqLz6VD8JSN7hA9pho3weowecC-oQm=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.647Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600345",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJk4as1wn91y0RSAPs6CuTvO0",
    "name": "Yoman Kafe",
    "address": "Portal UNESA, Lidah Wetan Gg. VII, Lidah Wetan, Lakarsantri, Surabaya, East Java 60213, Indonesia",
    "rating": "4.6",
    "reviewCount": 302,
    "placeId": "ChIJk4as1wn91y0RSAPs6CuTvO0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Yoman%20Kafe&query_place_id=ChIJk4as1wn91y0RSAPs6CuTvO0",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Sunday",
        "hours": "12 PM to 2 AM"
      }
    ],
    "neighborhood": "Lidah Wetan, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPbLbAzA0qCfikmGvNc3tWU0OU2MCQ3OjH58Qvw=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.289,
      112.632
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600357",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJLyBq-Q371y0RFA4kgt_nqNQ",
    "name": "Kopi Serbu",
    "address": "Blk. H - I No.P-23, Medokan Ayu, Kec. Rungkut, Surabaya, Jawa Timur 60293, Indonesia",
    "rating": "4.6",
    "reviewCount": 123,
    "placeId": "ChIJLyBq-Q371y0RFA4kgt_nqNQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Serbu&query_place_id=ChIJLyBq-Q371y0RFA4kgt_nqNQ",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Medokan Ayu, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOBiUPsK6MkTyBzIuGf-AByS_LEQ5BcJzEIjp9q=w408-h284-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600371",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJtVre6LL71y0RYOjjKaAgTlg",
    "name": "Giras Satu Satu",
    "address": "Jl. Medokan Asri Tengah No.I, No. 18, Kali Rungkut, Kec. Rungkut, Surabaya, Jawa Timur 60297, Indonesia",
    "rating": "4.5",
    "reviewCount": 390,
    "placeId": "ChIJtVre6LL71y0RYOjjKaAgTlg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Giras%20Satu%20Satu&query_place_id=ChIJtVre6LL71y0RYOjjKaAgTlg",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 858-5546-4533",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Kali Rungkut, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMHrfcJlaWwH2E5ne0EmV_JipHxhmbmNd0hNCvL=w408-h275-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600385",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJKVIj4OL_1y0ROUi-9Zffuy8",
    "name": "Kofibrik Sememi",
    "address": "Jl. Raya Sememi Jaya No.33, Sememi, Kec. Benowo, Surabaya, Jawa Timur 60198, Indonesia",
    "rating": "3.5",
    "reviewCount": 71,
    "placeId": "ChIJKVIj4OL_1y0ROUi-9Zffuy8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kofibrik%20Sememi&query_place_id=ChIJKVIj4OL_1y0ROUi-9Zffuy8",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [],
    "neighborhood": "Sememi, Benowo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPQXn6SuaCH3La8yDpvHg4vbgrSnYUXIVubq-0q=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.24,
      112.64
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600398",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ2Q1hyNP71y0R3OpqFoRWxl0",
    "name": "Tjancrukan",
    "address": "MQ6M+RC3, Jl. Dr. Ir. H. Soekarno, Gn. Anyar, Kec. Gn. Anyar, Surabaya, Jawa Timur 60294, Indonesia",
    "rating": "4.6",
    "reviewCount": 145,
    "placeId": "ChIJ2Q1hyNP71y0R3OpqFoRWxl0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tjancrukan&query_place_id=ChIJ2Q1hyNP71y0R3OpqFoRWxl0",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 3 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 3 AM"
      }
    ],
    "neighborhood": "Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP6h2tGRVgxcRwbRdqwdKZnJ5E9_cIMYXAZk4g=w459-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600427",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJnymyTSz71y0R2GKcVpyXkmA",
    "name": "Bincang Cafe & Creative Space",
    "address": "Jl. Medokan Asri Tengah No.20-22, Kali Rungkut, Kec. Rungkut, Surabaya, Jawa Timur 60239, Indonesia",
    "rating": "4.6",
    "reviewCount": 78,
    "placeId": "ChIJnymyTSz71y0R2GKcVpyXkmA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Bincang%20Cafe%20%26%20Creative%20Space&query_place_id=ChIJnymyTSz71y0R2GKcVpyXkmA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-3413-6322",
    "website": "https://instagram.com/bincang_space?igshid=YmM0MjE2YWMzOA==",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Kali Rungkut, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMCDqJ54huMnrfAmdoDBsDSoXFTRCImBY40QEgL=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600443",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJx6sCr3X71y0RbqDFRMTsR4k",
    "name": "Warung Segala Penjuru",
    "address": "000, Jl. Siwalankerto No.22, RW.00, Dukuh Menanggal, Gayungan, Surabaya, East Java 60234, Indonesia",
    "rating": "4.5",
    "reviewCount": 144,
    "placeId": "ChIJx6sCr3X71y0RbqDFRMTsR4k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warung%20Segala%20Penjuru&query_place_id=ChIJx6sCr3X71y0RbqDFRMTsR4k",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Dukuh Menanggal, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPsoo7LTmozs97gNhy9_aG-pQchna0Fd5n6xMdc=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Dinner": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600460",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJdaLtdq791y0Rfiuqv53sw-Q",
    "name": "Lavender Cafe",
    "address": "Unesa, Jl. Pakuwon Indah No.66, Lidah Wetan, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.9",
    "reviewCount": 206,
    "placeId": "ChIJdaLtdq791y0Rfiuqv53sw-Q",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Lavender%20Cafe&query_place_id=ChIJdaLtdq791y0Rfiuqv53sw-Q",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-9432-6418",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "12 to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "12 to 11 PM"
      }
    ],
    "neighborhood": "Lidah Wetan, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNcZVoCrULauj7Vs8tWDdR9VqqJR_Is1xuq6o3-=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.289,
      112.632
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600472",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJLX00KPb71y0RpsAVuf9GvpI",
    "name": "FAS Cafe",
    "address": "Jl. Dr. Ir. H. Soekarno No.46, Gn. Anyar, Kec. Gn. Anyar, Surabaya, Jawa Timur 60294, Indonesia",
    "rating": "4.6",
    "reviewCount": 234,
    "placeId": "ChIJLX00KPb71y0RpsAVuf9GvpI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=FAS%20Cafe&query_place_id=ChIJLX00KPb71y0RpsAVuf9GvpI",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-9990-1707",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipObkqAIqna3-CeDhQe5jJxPcq1M_X-eVMnObpyg=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600503",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJWQnvqOP71y0R7zv_lX3i3as",
    "name": "EJJI Coffee Corner District 11 Purimas Rungkut",
    "address": "Jl. I Gusti Ngurah Rai, Gn. Anyar, Kec. Gn. Anyar, Surabaya, Jawa Timur 60249, Indonesia",
    "rating": "4.7",
    "reviewCount": 101,
    "placeId": "ChIJWQnvqOP71y0R7zv_lX3i3as",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=EJJI%20Coffee%20Corner%20District%2011%20Purimas%20Rungkut&query_place_id=ChIJWQnvqOP71y0R7zv_lX3i3as",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3289-895",
    "website": "https://www.instagram.com/ejji.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 9:30 PM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 9:30 PM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 9:30 PM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 9:30 PM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 9:30 PM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 9:30 PM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 9:30 PM"
      }
    ],
    "neighborhood": "Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOWCt4vwVIn-tSu0z-Jiw3fu2yx4DE23vkMmaiP=w408-h427-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600518",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJjbFQuOr61y0RyRUyKx3PpBA",
    "name": "Himec Coffee & Eatery",
    "address": "Jl. Penjaringan Asri XII No.30, Penjaringan Sari, Kec. Rungkut, Surabaya, Jawa Timur 60297, Indonesia",
    "rating": "4.5",
    "reviewCount": 745,
    "placeId": "ChIJjbFQuOr61y0RyRUyKx3PpBA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Himec%20Coffee%20%26%20Eatery&query_place_id=ChIJjbFQuOr61y0RyRUyKx3PpBA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 51907525",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 8:45 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 8:45 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 8:45 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 8:45 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 8:45 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 8:45 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 8:45 PM"
      }
    ],
    "neighborhood": "Penjaringan Sari, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNb-cLcNqBSD9KG_MkVS05CZuEYiO4YWUeEH8BQ=w408-h906-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600532",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJr9dgjVH71y0RF2JOP3qRbe0",
    "name": "RIZQUNA 4",
    "address": "Jl. Dukuh Menanggal, Menanggal, Kec. Gayungan, Surabaya, Jawa Timur 60234, Indonesia",
    "rating": "4.5",
    "reviewCount": 70,
    "placeId": "ChIJr9dgjVH71y0RF2JOP3qRbe0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=RIZQUNA%204&query_place_id=ChIJr9dgjVH71y0RF2JOP3qRbe0",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-3359-4577",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Menanggal, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOWPmhqaAhupkzdT0uiuGQQHwN-fbVFUOmpCChf=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600549",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJXeBdpsr51y0RRcs_Jk5xvM0",
    "name": "Coffee Barata 73",
    "address": "Jl. Wonokusumo Jaya I Jl. Sidotopo Wetan No.1, Sidotopo Wetan, Kec. Kenjeran, Surabaya, Jawa Timur 60128, Indonesia",
    "rating": "4.5",
    "reviewCount": 169,
    "placeId": "ChIJXeBdpsr51y0RRcs_Jk5xvM0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Coffee%20Barata%2073&query_place_id=ChIJXeBdpsr51y0RRcs_Jk5xvM0",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Sidotopo Wetan, Kenjeran",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPVpa48OXB_XV_33nrSqb9F7ul3fmQYFygMei8E=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.78
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600566",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJF6DGWyX-1y0RLiKsMHH1kB0",
    "name": "Warkop Cangkir 99",
    "address": "Jl. DK Jerawat No.3, Babat Jerawat, Kec. Pakal, Surabaya, Jawa Timur 60197, Indonesia",
    "rating": "4.4",
    "reviewCount": 470,
    "placeId": "ChIJF6DGWyX-1y0RLiKsMHH1kB0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Cangkir%2099&query_place_id=ChIJF6DGWyX-1y0RLiKsMHH1kB0",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 858-5565-3628",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Babat Jerawat, Pakal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNPyhGBiMWPQgWZ32c-qWmmOkvvKk6TA7PtUjF3=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.255,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600582",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJSXouQy7-1y0ROzQG2om5grQ",
    "name": "Warung Revolusi",
    "address": "Jl. Pd. Benowo Indah No.3 Blok A, Benowo, Kec. Pakal, Surabaya, Jawa Timur 60197, Indonesia",
    "rating": "4.6",
    "reviewCount": 169,
    "placeId": "ChIJSXouQy7-1y0ROzQG2om5grQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warung%20Revolusi&query_place_id=ChIJSXouQy7-1y0ROzQG2om5grQ",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 852-3601-2172",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 4 AM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 4 AM"
      }
    ],
    "neighborhood": "Benowo, Pakal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOIT4gVJk9_NgZlF33cozZ17r-kOYzhhQ5pxJ8q=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.24,
      112.64
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600595",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ77sguNn_1y0RxwPjUhPySL8",
    "name": "Happy Resto & Coffee",
    "address": "Ruko Green Junction GN-01, Babat Jerawat, Kec. Pakal, Surabaya, Jawa Timur 60197, Indonesia",
    "rating": "3.5",
    "reviewCount": 80,
    "placeId": "ChIJ77sguNn_1y0RxwPjUhPySL8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Happy%20Resto%20%26%20Coffee&query_place_id=ChIJ77sguNn_1y0RxwPjUhPySL8",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 9 PM"
      }
    ],
    "neighborhood": "Babat Jerawat, Pakal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNM_MvAuu7u8LUUI4p9PYs5gQZloRClwKURq0A0=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.255,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600612",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJzYifTav51y0RjT6H2XAv_so",
    "name": "Wedang Kraton Cafe",
    "address": "Jl. Platuk Donomulyo I No.92, Sidotopo Wetan, Kec. Kenjeran, Surabaya, Jawa Timur 60128, Indonesia",
    "rating": "4.2",
    "reviewCount": 114,
    "placeId": "ChIJzYifTav51y0RjT6H2XAv_so",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Wedang%20Kraton%20Cafe&query_place_id=ChIJzYifTav51y0RjT6H2XAv_so",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-3388-2947",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Closed"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12 AM"
      }
    ],
    "neighborhood": "Sidotopo Wetan, Kenjeran",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB8dZfhoS4XsuuAvPquwJQAyM3FEF0xTW4nQHsq6UAcdffX98-KaCFdG91jca_2ymzFebXPxWnltKOgsFQ5djlcUaV6zfC40f5i_02xz6DvtjVe2ptNQqTcIRKIhikZ6WpAYY4vv=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.78
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600628",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ4a81alv_1y0R415mOuyN8Sw",
    "name": "Jun Coffee",
    "address": "PJXW+P7W, Jl. Bandarejo I, Sememi, Kec. Benowo, Surabaya, Jawa Timur 60198, Indonesia",
    "rating": "4.4",
    "reviewCount": 268,
    "placeId": "ChIJ4a81alv_1y0R415mOuyN8Sw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Jun%20Coffee&query_place_id=ChIJ4a81alv_1y0R415mOuyN8Sw",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Sememi, Benowo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMl_QDpGYQ_EeeE3LnpNqrZxLdTZKks8SBHMGJ9=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.24,
      112.64
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600641",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ0fLbAav_1y0RbD_l39hk8Dc",
    "name": "CAFE\"ZUKA-ZUKA\"",
    "address": "PMW3+RVJ, Jl. Raya Kandangan, Kandangan, Kec. Benowo, Surabaya, Jawa Timur 60199, Indonesia",
    "rating": "4.6",
    "reviewCount": 77,
    "placeId": "ChIJ0fLbAav_1y0RbD_l39hk8Dc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=CAFE%22ZUKA-ZUKA%22&query_place_id=ChIJ0fLbAav_1y0RbD_l39hk8Dc",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-2438-4036",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Kandangan, Benowo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP0aPPMJnIZV0mff_-PeFw3LmVT4kM9xVtTUNyo=w408-h276-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.24,
      112.64
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600653",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJK5nH2EH-1y0Re_UpM6CPEvs",
    "name": "FAVORIT CAFE",
    "address": "Jl. Bandarejo I No.2, Sememi, Kec. BenPJXW+7X Sememi, Surabaya, Jawa Timurowo, Surabaya, Jawa Timur 60199, Indonesia",
    "rating": "4.7",
    "reviewCount": 90,
    "placeId": "ChIJK5nH2EH-1y0Re_UpM6CPEvs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=FAVORIT%20CAFE&query_place_id=ChIJK5nH2EH-1y0Re_UpM6CPEvs",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 812-3573-3339",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "11:30 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "11:30 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "11:30 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "11:30 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "11:30 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "11:30 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "11:30 AM to 10 PM"
      }
    ],
    "neighborhood": "Sememi, Benowo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPuGuV9EcXvpOQdXYhUfm8LkUlowyQLNfYnBeKW=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600683",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJz_wRi3r61y0RVhZZCDR8Ju8",
    "name": "Cengengesan Coffee Shop",
    "address": "Jl. Keputih Tegal I No.1 A, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.4",
    "reviewCount": 578,
    "placeId": "ChIJz_wRi3r61y0RVhZZCDR8Ju8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cengengesan%20Coffee%20Shop&query_place_id=ChIJz_wRi3r61y0RVhZZCDR8Ju8",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": "+62 822-3387-7745",
    "website": "https://instagram.com/kedaicengengesan?igshid=MzRlODBiNWFlZA==",
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 2 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 2 AM"
      }
    ],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNY9D579Qb3H0On3qpebnUlOW52xT9kskG2q8y9=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600704",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJMTcGjIz51y0R4QZ-N33qk-4",
    "name": "BARE Coffee Grand Kenjeran",
    "address": "Jl. Babatan Pantai Ut. No.2, Kalijudan, Kec. Mulyorejo, Surabaya, Jawa Timur 60114, Indonesia",
    "rating": "4.5",
    "reviewCount": 132,
    "placeId": "ChIJMTcGjIz51y0R4QZ-N33qk-4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=BARE%20Coffee%20Grand%20Kenjeran&query_place_id=ChIJMTcGjIz51y0R4QZ-N33qk-4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 822-2932-0727",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "7 AM to 10 PM"
      }
    ],
    "neighborhood": "Kalijudan, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB9IQdEybtbdlme8kcp_gnED2OA3Vt0aUDFd5xGpWjI_RnTVpoU30Chx8b9HRtO-yjwN5AbqRfi0EQ-jAWfNmLyHM2G4BYVu91_5zRmGLHU3CsIVdc7bYvsWS7a66SUOp9qoaQPGrQ=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600721",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJLfncXqP51y0RY0aA6IQoQAo",
    "name": "SETRO (Spesial Tongkrongan Suroboyo)",
    "address": "Jl. Dukuh Setro 3 No.2, Gading, Kec. Tambaksari, Surabaya, Jawa Timur 60134, Indonesia",
    "rating": "4.1",
    "reviewCount": 304,
    "placeId": "ChIJLfncXqP51y0RY0aA6IQoQAo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=SETRO%20%28Spesial%20Tongkrongan%20Suroboyo%29&query_place_id=ChIJLfncXqP51y0RY0aA6IQoQAo",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 812-2988-8816",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "3 to 11 PM"
      }
    ],
    "neighborhood": "Gading, Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOREUySeQdJFIZ9f5Y_4TSpyD_vnxPGk-WRPpNk=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.252,
      112.765
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600746",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJkZwxV-z51y0RLCHKb7-eVaU",
    "name": "Kafe 27 Kenjeran",
    "address": "Jl. Kenjeran No.546, Kalijudan, Kec. Mulyorejo, Surabaya, Jawa Timur 60114, Indonesia",
    "rating": "4.7",
    "reviewCount": 912,
    "placeId": "ChIJkZwxV-z51y0RLCHKb7-eVaU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kafe%2027%20Kenjeran&query_place_id=ChIJkZwxV-z51y0RLCHKb7-eVaU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 878-5554-6387",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 10 PM"
      }
    ],
    "neighborhood": "Kalijudan, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipO3D5P0mtZ7UGjpq7-XzxN72vfLUgLwRujfQSw-=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Assistive hearing loop": false
        },
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600760",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJLePh8GT51y0RjokLChCisbY",
    "name": "Be waffle",
    "address": "Jl. Bkr Pelajar No.34, Ketabang, Kec. Genteng, Surabaya, Jawa Timur 60272, Indonesia",
    "rating": "4.3",
    "reviewCount": 2053,
    "placeId": "ChIJLePh8GT51y0RjokLChCisbY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Be%20waffle&query_place_id=ChIJLePh8GT51y0RjokLChCisbY",
    "categories": [
      "Cafe",
      "Restaurant"
    ],
    "phone": "+62 811-3545-474",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 11 PM"
      }
    ],
    "neighborhood": "Ketabang, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNvuvq0bb1Fyc9sTKgPNRX59vN_e4HVSMnM52yT=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600773",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJoSWiiYz_1y0RBSO68CMsMq8",
    "name": "Warkop Halte",
    "address": "Jl. Tambak Osowilangun No.19, Tenggulunan, Tambak Osowilangun, Kec. Benowo, Kabupaten Gresik, Jawa Timur 60192, Indonesia",
    "rating": "4.4",
    "reviewCount": 123,
    "placeId": "ChIJoSWiiYz_1y0RBSO68CMsMq8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Halte&query_place_id=ChIJoSWiiYz_1y0RBSO68CMsMq8",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 857-3391-7895",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Tenggulunan, Tambak Osowilangun, Benowo",
    "city": "Gresik Regency",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNP3oEA9IoBi1t_2TpliVNhBLCNqoyQV9wJ9_P4=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free street parking": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Barat",
    "coordinates": [
      -7.24,
      112.64
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600786",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJibBnaa_71y0RS2cayySJ0sA",
    "name": "Start Base Cafe",
    "address": "Cafe Prajurit, jln.Adityawarman no.48-56 kav.B-12, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60242, Indonesia",
    "rating": "4.6",
    "reviewCount": 75,
    "placeId": "ChIJibBnaa_71y0RS2cayySJ0sA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Start%20Base%20Cafe&query_place_id=ChIJibBnaa_71y0RS2cayySJ0sA",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 811-3395-988",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Tuesday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Wednesday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Thursday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Friday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Saturday",
        "hours": "4 PM to 2 AM"
      },
      {
        "day": "Sunday",
        "hours": "4 PM to 2 AM"
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMZ-XregHNwTcCD1FpO_mF8Q8NMe4oLHxV1Fm57=w408-h543-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600851",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJp822Mmz61y0RnxH5cFUemio",
    "name": "Brum Stove and Pan",
    "address": "Perum ITS, Jl. Ilmu Pasti Alam No.F-12, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.6",
    "reviewCount": 141,
    "placeId": "ChIJp822Mmz61y0RnxH5cFUemio",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Brum%20Stove%20and%20Pan&query_place_id=ChIJp822Mmz61y0RnxH5cFUemio",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "3 to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "3 to 11 PM"
      }
    ],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPhxrnaNVYUtURZD_hblENurvcjnBTCGknhy87Q=w508-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600870",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ5b9bqGv71y0RRCHv20ckk3M",
    "name": "Warkop ABABIL",
    "address": "Jl. Jemursari Utara III No.3, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.3",
    "reviewCount": 100,
    "placeId": "ChIJ5b9bqGv71y0RRCHv20ckk3M",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20ABABIL&query_place_id=ChIJ5b9bqGv71y0RRCHv20ckk3M",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPqfsLnpGQHznpWOCuRvw0WcIikrkq2bkRVDR69=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.294,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600886",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJG44BhhP71y0ReNCEiYHmKCg",
    "name": "Warkop Injoko",
    "address": "Jl. Gayung Kebonsari Tengah No.2, Gayungan, Kec. Gayungan, Surabaya, Jawa Timur 60235, Indonesia",
    "rating": "4.5",
    "reviewCount": 100,
    "placeId": "ChIJG44BhhP71y0ReNCEiYHmKCg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Injoko&query_place_id=ChIJG44BhhP71y0ReNCEiYHmKCg",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN7Q5Cgnqsl5ZvV7C1BZIwr3NEVb0ThJ0ccMCn9=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free street parking": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600903",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJxeTpZqz71y0RS4FJQepJ4_o",
    "name": "Cafe PTJ",
    "address": "Jl. Margorejo Indah No.203, Margorejo, Kec. Wonocolo, Surabaya, Jawa Timur 60238, Indonesia",
    "rating": "3.7",
    "reviewCount": 227,
    "placeId": "ChIJxeTpZqz71y0RS4FJQepJ4_o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20PTJ&query_place_id=ChIJxeTpZqz71y0RS4FJQepJ4_o",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Tuesday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Wednesday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Thursday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Friday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "8 AM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "8 AM to 1 AM"
      }
    ],
    "neighborhood": "Margorejo, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOVl2cJU1gFY3BdryBQuTMf8L7rf9AmobQ86cG2=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600921",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJG6Y4n2z71y0RPZ5kuqsjf7k",
    "name": "Waroeng Bamboe",
    "address": "Wonocolo VIII Blok BLK No.37, Wonocolo, Jemur Wonosari, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.5",
    "reviewCount": 126,
    "placeId": "ChIJG6Y4n2z71y0RPZ5kuqsjf7k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Waroeng%20Bamboe&query_place_id=ChIJG6Y4n2z71y0RPZ5kuqsjf7k",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 857-3214-6660",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 5 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 5 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 5 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 5 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 5 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 5 PM"
      },
      {
        "day": "Sunday",
        "hours": "Closed"
      }
    ],
    "neighborhood": "Jemur Wonosari, Surabaya",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipPlmlHFPafvbi0wNH6-M2RVVDVUzDLgF9z9CPQV=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600939",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJX1v5EWD71y0RHV_cf4g-8ak",
    "name": "ELVEKA coffee n' juice",
    "address": "1, Jl. Kebonsari Lvk Barat No.2A, Kebonsari, Kec. Jambangan, Surabaya, Jawa Timur 60233, Indonesia",
    "rating": "4.5",
    "reviewCount": 485,
    "placeId": "ChIJX1v5EWD71y0RHV_cf4g-8ak",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=ELVEKA%20coffee%20n%27%20juice&query_place_id=ChIJX1v5EWD71y0RHV_cf4g-8ak",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 821-4046-3030",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "4 PM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "4 PM to 12 AM"
      }
    ],
    "neighborhood": "Kebonsari, Jambangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMOiiIJfjvAoQVaqM_mx-wmzu0Qwn0R3vCEtIoo=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600957",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJyS7cyu771y0R1TMWFsXxIE8",
    "name": "KOPI JUANG",
    "address": "Jl. Raya Jemursari No.39, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.1",
    "reviewCount": 589,
    "placeId": "ChIJyS7cyu771y0R1TMWFsXxIE8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KOPI%20JUANG&query_place_id=ChIJyS7cyu771y0R1TMWFsXxIE8",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 12:30 AM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 12:30 AM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 12:30 AM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 12:30 AM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 1 AM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 1 AM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 12:30 AM"
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOI9O6mj-WZbsL42dAD1JSWmLRYqAlvrrW6cufP=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.294,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600973",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJH7ivxXX91y0RdkKHKNWhxdo",
    "name": "Kopi Anak Monopole Grand Harvest",
    "address": "SOHO Grand Harvest HO-52, Balas Klumprik, Kec. Wiyung, Surabaya, Jawa Timur 60222, Indonesia",
    "rating": "4.9",
    "reviewCount": 142,
    "placeId": "ChIJH7ivxXX91y0RdkKHKNWhxdo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Anak%20Monopole%20Grand%20Harvest&query_place_id=ChIJH7ivxXX91y0RdkKHKNWhxdo",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 851-7996-4409",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "7 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "6 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "6 AM to 10 PM"
      }
    ],
    "neighborhood": "Balas Klumprik, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNXVP4SU9zVtYvy9j0pD4HpT8bZBcwI5YuL_T11=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.600987",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJxW1ekXX71y0RzVZdvsjrqyA",
    "name": "Loosen Cafe",
    "address": "Royal Plaza Lantai 3 Blok O1 Nomor 09-10, Jalan Ahmad Yani No. 16-18 Wonokromo, Wonokromo, Kec. Wonokromo, Surabaya, Jawa Timur 60243, Indonesia",
    "rating": "3.8",
    "reviewCount": 86,
    "placeId": "ChIJxW1ekXX71y0RzVZdvsjrqyA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Loosen%20Cafe&query_place_id=ChIJxW1ekXX71y0RzVZdvsjrqyA",
    "categories": [
      "Cafe",
      "Coffee shop"
    ],
    "phone": "+62 31 8271583",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Tuesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Wednesday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Thursday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Friday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Saturday",
        "hours": "9 AM to 9 PM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 9 PM"
      }
    ],
    "neighborhood": "Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipOPHhxyFjp4AXztMJAoE6lJyOgHGZIvaENq2--k=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601002",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ8TjG63n91y0RmuqQCIG8dGw",
    "name": "Warkop Lariso Surabaya",
    "address": "Jl. Balas Klumprik No.145, Balas Klumprik, Kec. Wiyung, Surabaya, Jawa Timur 60222, Indonesia",
    "rating": "4.6",
    "reviewCount": 88,
    "placeId": "ChIJ8TjG63n91y0RmuqQCIG8dGw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Lariso%20Surabaya&query_place_id=ChIJ8TjG63n91y0RmuqQCIG8dGw",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 857-4570-6500",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Balas Klumprik, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipNnt86Rl2WiyibfcppVPsDPLP4aDAC8ENQRYfQa=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601016",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ3ceJlbL71y0ReqK--bsNWAs",
    "name": "Cangkir Coffee",
    "address": "Jl. Siwalankerto No.180, Siwalankerto, Kec. Wonocolo, Surabaya, Jawa Timur 60236, Indonesia",
    "rating": "4.5",
    "reviewCount": 1321,
    "placeId": "ChIJ3ceJlbL71y0ReqK--bsNWAs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cangkir%20Coffee&query_place_id=ChIJ3ceJlbL71y0ReqK--bsNWAs",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3077-5999",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 11 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 11 PM"
      }
    ],
    "neighborhood": "Siwalankerto, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipP8L23l8TMPVwgJQL_G8qca0OLq86IBvCgAbBSR=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601033",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJXwE65xb71y0R9X5htYMZmLQ",
    "name": "Urban 18 Cafe",
    "address": "Jl. Raya Kendangsari Industri No.41, Kendangsari, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60292, Indonesia",
    "rating": "4.2",
    "reviewCount": 207,
    "placeId": "ChIJXwE65xb71y0R9X5htYMZmLQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Urban%2018%20Cafe&query_place_id=ChIJXwE65xb71y0R9X5htYMZmLQ",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Tuesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Wednesday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Thursday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Friday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Saturday",
        "hours": "10 AM to 10 PM"
      },
      {
        "day": "Sunday",
        "hours": "10 AM to 10 PM"
      }
    ],
    "neighborhood": "Kendangsari, Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipN1nE1mS-qdIYDGHIXAQI2-eUG5xIaQ6EPR7jbd=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601048",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJqSFcyxr71y0R_OGSeRTdfFI",
    "name": "HISTORY Surabaya",
    "address": "006, Jl. Joyoboyo No.23, RW.06, Sawunggaling, Kec. Wonokromo, Surabaya, Jawa Timur 60242, Indonesia",
    "rating": "4.4",
    "reviewCount": 119,
    "placeId": "ChIJqSFcyxr71y0R_OGSeRTdfFI",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=HISTORY%20Surabaya&query_place_id=ChIJqSFcyxr71y0R_OGSeRTdfFI",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 882-1480-2412",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Sawunggaling, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AB5caB8VC6JAs9sSOoEaCkIotEKEO0UYssJEhLQpVbdMuvyVZO7umcXdTrKLVhKzqJeRDREkFBFp9PGfK5DtZ0YvvX9M-VY143LN5SeMsN77_MqG2zBP1tVo2cAcc68o_Y3DjdOkpYQ=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601072",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJo_YVjTn71y0R4vMoDx5PbeA",
    "name": "Cafe Shop 129",
    "address": "Jl. Kutisari Sel. No.129, Kutisari, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60291, Indonesia",
    "rating": "4.3",
    "reviewCount": 137,
    "placeId": "ChIJo_YVjTn71y0R4vMoDx5PbeA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Cafe%20Shop%20129&query_place_id=ChIJo_YVjTn71y0R4vMoDx5PbeA",
    "categories": [
      "Coffee shop",
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Tuesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Wednesday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Thursday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Friday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Saturday",
        "hours": "Open 24 hours"
      },
      {
        "day": "Sunday",
        "hours": "Open 24 hours"
      }
    ],
    "neighborhood": "Kutisari, Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipO2ymo7a39RmVaT0bRBvQpitQaH3Ccgk03JgSwp=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.648Z",
    "dataSource": "original_fixed",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601087",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJOcFyEb_71y0RKZmvH_uaoMU",
    "name": "D'S Cafe",
    "address": "Jl. Siwalankerto Sel. II No.2, Siwalankerto, Kec. Wonocolo, Surabaya, Jawa Timur 60236, Indonesia",
    "rating": "4.4",
    "reviewCount": 155,
    "placeId": "ChIJOcFyEb_71y0RKZmvH_uaoMU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=D%27S%20Cafe&query_place_id=ChIJOcFyEb_71y0RKZmvH_uaoMU",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 896-1188-7811",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Tuesday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Wednesday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Thursday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Friday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Saturday",
        "hours": "9:30 AM to 12 AM"
      },
      {
        "day": "Sunday",
        "hours": "9 AM to 11 PM"
      }
    ],
    "neighborhood": "Siwalankerto, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh5.googleusercontent.com/p/AF1QipMIdTk4BuKpEROVGzXgr9DOOg3szLMz6W7WpkRN=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "original_fixed",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601104",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJPbj4Mkb61y0RjOMEdXaSRlo",
    "name": "Demandailing Cafe & Eatery",
    "address": "Jl. Klampis Jaya No.144, Klampis Ngasem, Kec. Sukolilo, Surabaya, Jawa Timur 60117, Indonesia",
    "rating": "4.5",
    "reviewCount": 2492,
    "placeId": "ChIJPbj4Mkb61y0RjOMEdXaSRlo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Demandailing%20Cafe%20%26%20Eatery&query_place_id=ChIJPbj4Mkb61y0RjOMEdXaSRlo",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 31 5995500",
    "website": "https://www.instagram.com/demandailingcafe",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Klampis Ngasem, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npi_gAox3QUkEiRQUze5B4TplS9L6ftTdnGPxY6LzPaP_Pf-jHFM78eIm0FwOyzMsUU3fickVkEMpwvZim4KwyvJ_fGuHfI3doojeNlq5i013nt-ZAA4k0LxB-K5VRuYz4x2dZP=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601120",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJG2_G3lv91y0Rv1CFKF9gxE0",
    "name": "Teras Kopi 96",
    "address": "Jl. Dukuh Kupang Utara I No.96, Putat Jaya, Kec. Sawahan, Surabaya, Jawa Timur 60255, Indonesia",
    "rating": "4.7",
    "reviewCount": 77,
    "placeId": "ChIJG2_G3lv91y0Rv1CFKF9gxE0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Teras%20Kopi%2096&query_place_id=ChIJG2_G3lv91y0Rv1CFKF9gxE0",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-3310-330",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Closed"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Putat Jaya, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrXTnVSTBbEUg19fdNdzLWka0Cr6MiaVAlP8v0f6EnPP4Djkonw-ofcTmJ_fwg3mi5buoh2zhMI6KckviN-qujyWPD_NwwT88UvPaQLiGdNWfKF2Li9rFlx-lMIAeIfoTvLVUow=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601133",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJHYwHdUv71y0Rxayb5G-NF1M",
    "name": "Tera Coffee Society",
    "address": "Jl. Darmokali No.3, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.9",
    "reviewCount": 117,
    "placeId": "ChIJHYwHdUv71y0Rxayb5G-NF1M",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Tera%20Coffee%20Society&query_place_id=ChIJHYwHdUv71y0Rxayb5G-NF1M",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": "https://www.instagram.com/tera.society?igsh=MW9mY25tMG1wb2o1aA==",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipM2wVc8h8vaVkPwyONbNuO313_AE5bW6DK3pqSo=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601148",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJIdkvH4r71y0RYjZByeAYC4o",
    "name": "TERAS 28",
    "address": "Jl. Tenggilis Bar. I No.109, Kendangsari, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60292, Indonesia",
    "rating": "4.7",
    "reviewCount": 178,
    "placeId": "ChIJIdkvH4r71y0RYjZByeAYC4o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=TERAS%2028&query_place_id=ChIJIdkvH4r71y0RYjZByeAYC4o",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": "http://teras28.com/?utm_source=gmb&utm_medium=referral",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "Kendangsari, Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMlM2lEP2LPoCq9inmqTebgrIbo3IcN7T4qbr6t=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601162",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJL8mT3Yf71y0Rt4-3kvy8M00",
    "name": "Howie Coffee & Eatery",
    "address": "Jl. Gayungsari Bar. X No.43, RT.07/RW.05, Gayungan, Kec. Gayungan, Surabaya, Jawa Timur 60235, Indonesia",
    "rating": "4.5",
    "reviewCount": 349,
    "placeId": "ChIJL8mT3Yf71y0Rt4-3kvy8M00",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Howie%20Coffee%20%26%20Eatery&query_place_id=ChIJL8mT3Yf71y0Rt4-3kvy8M00",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 812-8772-2525",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqX7AcoqYzIZJYjRPIod5tfwW1BiDvPXBaWMOyst8QySO8f-yaE_BmC04Z4oCed6P6DfwvkFHlzRIbbStXHDzp2WdYeNCEJxbh78whWab1_c6XTgz9LuO4YHe2mBXjuVk8PdGc=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601180",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJzyXZxiL71y0RrnBOIo3mhEc",
    "name": "Haus!",
    "address": "Jl. Raya Mulyosari No.284, Kalisari, Kec. Mulyorejo, Surabaya, Jawa Timur 60113, Indonesia",
    "rating": "4.1",
    "reviewCount": 346,
    "placeId": "ChIJzyXZxiL71y0RrnBOIo3mhEc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Haus%21&query_place_id=ChIJzyXZxiL71y0RrnBOIo3mhEc",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": "https://haus.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8:30 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8:30 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8:30 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8:30 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8:30 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8:30 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Kalisari, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqheLzPNYGsMqKZ5M6EKZTatgpeMyy0IufqfwD3JtMFB13m81t80PFp3uHFKLf1_phBf0qLALDyDhZZ4DjtAj7W0ZLfQD-cRhV-nFCNByM0rsFOCRIyF0Y9vGe3UhoqtNAy2NVHSg=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601195",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJtQKEssP71y0RJpaYvwkyemY",
    "name": "HOPS Kitchen & Bar",
    "address": "Jl. Sriwijaya No.25, Keputran, Kec. Tegalsari, Surabaya, Jawa Timur 60264, Indonesia",
    "rating": "4.7",
    "reviewCount": 1065,
    "placeId": "ChIJtQKEssP71y0RJpaYvwkyemY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=HOPS%20Kitchen%20%26%20Bar&query_place_id=ChIJtQKEssP71y0RJpaYvwkyemY",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 821-2093-9988",
    "website": "http://hops-beers.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Keputran, Tegalsari",
    "city": "Surabaya",
    "description": "Hip, late-night venue with outdoor seating serving creative cocktails, beer & classic pub grub.",
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPfCl7OXQ0D_hPZUuo49X-42-LkXsDHTiQ-RjgN=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great cocktails": true
        },
        {
          "Great wine list": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Food": true
        },
        {
          "Food at bar": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Hard liquor": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601208",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJyYbVDtj71y0RBpxdmGTKo6U",
    "name": "Kafe Tenda Biru (Kampung Bambu)",
    "address": "Kayoon St C No.9, Embong Kaliasin, Genteng, Surabaya, East Java 60271, Indonesia",
    "rating": "4.3",
    "reviewCount": 144,
    "placeId": "ChIJyYbVDtj71y0RBpxdmGTKo6U",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kafe%20Tenda%20Biru%20%28Kampung%20Bambu%29&query_place_id=ChIJyYbVDtj71y0RBpxdmGTKo6U",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 to 11:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 to 11:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 to 11:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 to 11:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 to 11:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 to 11:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 to 11:30 PM"
        }
      }
    ],
    "neighborhood": "Embong Kaliasin, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrqOo93T8ISTQwx-GKmlo5TqjVy1Vm6KY9S8KcBs0P7kewoC3UdytVrKV7qk0mifb3UiUBZPMeCmjyPoEmWqB_l_u3xKNpnnqvKa_o6VTx2KaasM8yZqQuivJgEshHeQZubwdww=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601223",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJAcqnF8L91y0RVF8K5ZulRd4",
    "name": "Kedai Sudut Kota",
    "address": "Jl. Raya Jeruk No.87, Jeruk, Kec. Lakarsantri, Surabaya, Jawa Timur 60212, Indonesia",
    "rating": "4.6",
    "reviewCount": 137,
    "placeId": "ChIJAcqnF8L91y0RVF8K5ZulRd4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Sudut%20Kota&query_place_id=ChIJAcqnF8L91y0RVF8K5ZulRd4",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 853-3623-2626",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "3 to 11 PM"
        }
      }
    ],
    "neighborhood": "Jeruk, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4np2jixsA38CTFe-MiuKjxBI0zwlQqkwrp_NVlpaBMQAraa6j6k8mx6K81oX5yHmd61n73lvwnjUJZ1QBvKaHP1PIg8FngNyS0adyAHdiN6dGoXm19KSY9O1iViJPM-W8tE0gZxiAw=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.289,
      112.632
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601235",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ2cqaREf81y0Rg8324UION-Q",
    "name": "Warkop 48 Surabaya",
    "address": "Jl. Golf 1 Surabaya No.48, Gn. Sari, Kec. Dukuhpakis, Surabaya, Jawa Timur 60225, Indonesia",
    "rating": "4.6",
    "reviewCount": 124,
    "placeId": "ChIJ2cqaREf81y0Rg8324UION-Q",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%2048%20Surabaya&query_place_id=ChIJ2cqaREf81y0Rg8324UION-Q",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Gunung Sari, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noByZf87Rv1atcrRDd2wPcsvti1xou2gj7I0R_wTc0yuC3e9gATxxM1kxWDAc8kAxuQWWPp4uH16EtDhuzfbUpg7oofxF5V-ImY_3XJJSiojKOUJrRfsn8C2xmLaoffPu14B8HNFA=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "Unknown",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601252",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJQTKvBAb51y0ReROBu37xCZ8",
    "name": "Warkop HORE",
    "address": "Granting Bar. No.136, Simokerto, Kec. Simokerto, Surabaya, Jawa Timur 60143, Indonesia",
    "rating": "4.3",
    "reviewCount": 229,
    "placeId": "ChIJQTKvBAb51y0ReROBu37xCZ8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20HORE&query_place_id=ChIJQTKvBAb51y0ReROBu37xCZ8",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 858-9545-4189",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Simokerto",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npywcP-IdJsCIBuyVp3xWjrcxGZycufOTVIIb7sjOVwj0u7IhYLVzjNcIkGdqRLCAkkbD6tnDppGU6tmloHbaRVc43bdG9sINwbEeC0lo7cG7PsghqvxPDee_0Yftg8b4mpoNhG=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.242,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601269",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJoR5LnDT51y0RlRpAWTkcOFs",
    "name": "Kopitiam Sejuta Harapan",
    "address": "Jl. Kusuma Bangsa No.59, Kapasari, Kec. Genteng, Surabaya, Jawa Timur 60272, Indonesia",
    "rating": "4.7",
    "reviewCount": 71,
    "placeId": "ChIJoR5LnDT51y0RlRpAWTkcOFs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopitiam%20Sejuta%20Harapan&query_place_id=ChIJoR5LnDT51y0RlRpAWTkcOFs",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-1745-6122",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "12 PM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "12 PM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "12 PM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 12 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Kapasari, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPUOjywnZcozyxrH1fNMRhI50BiSHX5zad7dHYo=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601284",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ-_MogCP71y0Rb1bK8XNLlVM",
    "name": "Kopi-In Kedai Rakjat Soerobojo",
    "address": "Gg. Modin No.28, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.5",
    "reviewCount": 347,
    "placeId": "ChIJ-_MogCP71y0Rb1bK8XNLlVM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi-In%20Kedai%20Rakjat%20Soerobojo&query_place_id=ChIJ-_MogCP71y0Rb1bK8XNLlVM",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-633-466",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipP7VgwdQAG0BKk9h25Ood0m92qiLie2TkBIR3Vp=w408-h271-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy-hour drinks": true
        },
        {
          "Happy-hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Paid Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601302",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ1-DjVY371y0RE862xdWmzNE",
    "name": "Warung Salire",
    "address": "Jl. Ngagel Jaya Barat No.37, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "4.6",
    "reviewCount": 153,
    "placeId": "ChIJ1-DjVY371y0RE862xdWmzNE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warung%20Salire&query_place_id=ChIJ1-DjVY371y0RE862xdWmzNE",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 823-3099-6303",
    "website": "https://www.instagram.com/warungsalire/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipP77U6cHlTvaPqwGPipTo1cAxdEmiP5H7zAlbC0=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601315",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJf8cXz4j71y0RBZ5f-vfPc_k",
    "name": "KEDAI PULO",
    "address": "Jl. Pulo Wonokromo No.251, Wonokromo, Kec. Wonokromo, Surabaya, Jawa Timur 60243, Indonesia",
    "rating": "4.6",
    "reviewCount": 165,
    "placeId": "ChIJf8cXz4j71y0RBZ5f-vfPc_k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KEDAI%20PULO&query_place_id=ChIJf8cXz4j71y0RBZ5f-vfPc_k",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 857-4555-4610",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "9 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npmZSYflkIshvh1MR4VI7-rUno-yJf50O4CdX9WQR-WorQh0h8nOz3lx75IE1_x26LP0XOlJMEchg4oU9S_HQE_kh0UtHOo6K3pyDJGFvr3PwgUSCcMoyFi3IGfh0dSnwwoJp3FDA=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601329",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJVxFnAAD71y0RyULUcNQyctk",
    "name": "Sedjagad 36",
    "address": "Jl. Ngagel Tim. No.36, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60283, Indonesia",
    "rating": "4.6",
    "reviewCount": 312,
    "placeId": "ChIJVxFnAAD71y0RyULUcNQyctk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Sedjagad%2036&query_place_id=ChIJVxFnAAD71y0RyULUcNQyctk",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nopLByU_EJRLkMs0kioF9OpQ4xVsw5aUZaTh_S3Na8f5QYRX26_UhQhRT06jdcwal56xBWhFZeI6rlX_oOFwVI5ByoXBU7Bii4IA_GKkemEXc1PW3sA4AhBcWyguejaa1gtfuow=w519-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601343",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJlT-rnE_71y0ReptqnAv1bro",
    "name": "Kedai Berada",
    "address": "Jl. Bratang Gede III B No.21, Ngagelrejo, Kec. Wonokromo, Surabaya, Jawa Timur 60245, Indonesia",
    "rating": "4.3",
    "reviewCount": 124,
    "placeId": "ChIJlT-rnE_71y0ReptqnAv1bro",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Berada&query_place_id=ChIJlT-rnE_71y0ReptqnAv1bro",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 856-0246-6411",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Ngagelrejo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOTn9aIWJjz9wLv-Myma0_ImcQEOKGGVyFXMdhP=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601359",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJj353pZP71y0RxZUsQm01LTA",
    "name": "THE SOCIALITE SURABAYA",
    "address": "Jl. Indragiri No.36, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.5",
    "reviewCount": 1022,
    "placeId": "ChIJj353pZP71y0RxZUsQm01LTA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=THE%20SOCIALITE%20SURABAYA&query_place_id=ChIJj353pZP71y0RxZUsQm01LTA",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 31 99531308",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMCDBfBKf3450Fpc0diqmltD1LShDQNNe-S9NO0=w408-h271-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great cocktails": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Great wine list": true
        },
        {
          "Live music": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Happy-hour food": true
        },
        {
          "Spirits": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        },
        {
          "Upmarket": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Lunch reservations recommended": true
        },
        {
          "Reservations required": true
        },
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null,
        {
          "Valet parking": true
        }
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601372",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ86lMMqr-1y0R59kJ5McwZZU",
    "name": "Warkop Sahabat Gea",
    "address": "Jl. Simo Mulyo No.153 Nomer B, Simomulyo, Kec. Sukomanunggal, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.7",
    "reviewCount": 146,
    "placeId": "ChIJ86lMMqr-1y0R59kJ5McwZZU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Sahabat%20Gea&query_place_id=ChIJ86lMMqr-1y0R59kJ5McwZZU",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 896-2241-6179",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Simomulyo, Sukomanunggal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npBk14y_lMPJkmXs4MQnxhKrTaqitnHl9EDf-22b1g0uH66YWN0Y62HGo2oV4eLT3Y-fw7zgJQJi5i6ADDl-TkQnTNHlD9i6HGuPlEWtFNNkZ4tOyqGz427rcU189giGEYu4AKR=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.27,
      112.685
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601385",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJeXfqirj71y0RRbdu7wIbW0k",
    "name": "Mazaya Coffee and Roastery",
    "address": "Jl. Gayungsari Bar. X No.32, RT.003/RW.007, Gayungan, Kec. Gayungan, Surabaya, Jawa Timur 60235, Indonesia",
    "rating": "4.6",
    "reviewCount": 391,
    "placeId": "ChIJeXfqirj71y0RRbdu7wIbW0k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Mazaya%20Coffee%20and%20Roastery&query_place_id=ChIJeXfqirj71y0RRbdu7wIbW0k",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 813-2212-7878",
    "website": "https://heylink.me/mazayacoffeeandroastery",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6:30 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6:30 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6:30 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6:30 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6:30 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6:30 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6:30 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOo1g5EYFMmLuXU0WvCUH6m2O9g1kFH4bI2nWns=w408-h324-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Crowd": [
        {
          "Family-friendly": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601403",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJN0lHJvb61y0Ru9xHgeKPSHo",
    "name": "Kedai Semampir",
    "address": "No 37 Kav 6 E Sukolilo Timur, Jl. Raya Semampir Barat, Medokan Semampir, Kec. Sukolilo, Surabaya, Jawa Timur 60119, Indonesia",
    "rating": "4.4",
    "reviewCount": 94,
    "placeId": "ChIJN0lHJvb61y0Ru9xHgeKPSHo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Semampir&query_place_id=ChIJN0lHJvb61y0Ru9xHgeKPSHo",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 856-0685-1927",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Closed"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "3 to 11 PM"
        }
      }
    ],
    "neighborhood": "Medokan Semampir, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nouVnkQXNG4KieF8gYD7ZYsbYXgbBlXYRQtqLGZmF7vOGMklZ_33r9dvvYEPGW7O9sTErg2kRu1d_H_boh_1ACr4ziwsTGr1mTapXSY-9h1BtSS2ZETqZ0HjHGir0VHjLQhhrNN=w408-h279-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601417",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJe8WjkcH71y0RY9wCWvNBxu0",
    "name": "Warkop Bukan Hanya Kopi",
    "address": "Jl. Flores No.31, Ngagel, Kec. Wonokromo, Surabaya, Jawa Timur 60246, Indonesia",
    "rating": "4.4",
    "reviewCount": 665,
    "placeId": "ChIJe8WjkcH71y0RY9wCWvNBxu0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Bukan%20Hanya%20Kopi&query_place_id=ChIJe8WjkcH71y0RY9wCWvNBxu0",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 878-0909-2757",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7:30 AM to 12:30 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7:30 AM to 12:30 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7:30 AM to 12:30 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7:30 AM to 12:30 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7:30 AM to 3 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7:30 AM to 3 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7:30 AM to 12:30 AM"
        }
      }
    ],
    "neighborhood": "Ngagel, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipN3QNK1rrWBxNwbAtx9j5WGh3TO0k-f1009qgOk=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601431",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ283JBxX61y0RKQdSOWpyq5E",
    "name": "Warkop GW27 (Cak Tik)",
    "address": "Jl. Gebang Wetan No.27, Gebang Putih, Kec. Sukolilo, Surabaya, Jawa Timur 60117, Indonesia",
    "rating": "4.4",
    "reviewCount": 230,
    "placeId": "ChIJ283JBxX61y0RKQdSOWpyq5E",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20GW27%20%28Cak%20Tik%29&query_place_id=ChIJ283JBxX61y0RKQdSOWpyq5E",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 856-3094-336",
    "website": null,
    "openingHours": [],
    "neighborhood": "Gebang Putih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipObaNYosR-dY6Y_C4NjEAO5k2gFWo0MOU-hTQM7=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": false
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601445",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJi_TlH1H71y0RzNybZ7EDA4o",
    "name": "The Gade Coffee & Gold Surabaya",
    "address": "Jl. Dinoyo No.81, Keputran, Kec. Tegalsari, Surabaya Pusat, Jawa Timur 60265, Indonesia",
    "rating": "4.8",
    "reviewCount": 617,
    "placeId": "ChIJi_TlH1H71y0RzNybZ7EDA4o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=The%20Gade%20Coffee%20%26%20Gold%20Surabaya&query_place_id=ChIJi_TlH1H71y0RzNybZ7EDA4o",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-1966-6634",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Keputran, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrCt1wiFzsl0gxUMt4dQvL6SuxwD2_nWSCRvNEEpQCE-Y5-ANx9y1atBk7Sw_BeoYJSS3MucKGI1lPQiNUlIvqPGy3Ww5zvBv2O7KhQ6iC-ju4uC2PvVzG-pUxxiK-33I5Vywgc=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601459",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJj4zxJhL71y0RYUJVXunqsZo",
    "name": "Kedai Kita",
    "address": "Jl. Pucang Anom No.87, Kertajaya, Kec. Gubeng, Surabaya, Jawa Timur 60282, Indonesia",
    "rating": "4.6",
    "reviewCount": 168,
    "placeId": "ChIJj4zxJhL71y0RYUJVXunqsZo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Kita&query_place_id=ChIJj4zxJhL71y0RYUJVXunqsZo",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 878-5255-1625",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Kertajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noHLv90RhG1gMAjyP8-awTOmCmyBjxWC7RwGoiq4LjgS5MOEHZTXZPXEx5gh2jHvRhfe_T13ZIJ9P8OkwGou3Z8bgjDkRpUqA2aB7hl9VOy48BCEXbIydVBxmBibhuZOqOgp4s=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601472",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJV9TQQAD71y0RXqRruN9bRQ8",
    "name": "KEDAI DO'A IBU",
    "address": "Jl. Kaliwaron No.60, Mojo, Kec. Gubeng, Surabaya, Jawa Timur 60285, Indonesia",
    "rating": "4.5",
    "reviewCount": 251,
    "placeId": "ChIJV9TQQAD71y0RXqRruN9bRQ8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KEDAI%20DO%27A%20IBU&query_place_id=ChIJV9TQQAD71y0RXqRruN9bRQ8",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 882-3592-6990",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Mojo, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMtzSHmYHD2DdDoTOiS8pRZUqv9o34VaZ-1vBBP=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601485",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJIVsQfdn71y0Ru2gt6e2Qu_U",
    "name": "de Soematra",
    "address": "Jl. Sumatera No.75, Gubeng, Kec. Gubeng, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.7",
    "reviewCount": 787,
    "placeId": "ChIJIVsQfdn71y0Ru2gt6e2Qu_U",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=de%20Soematra&query_place_id=ChIJIVsQfdn71y0Ru2gt6e2Qu_U",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 31 5010666",
    "website": "http://www.de-soematra.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11:30 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11:30 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11:30 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11:30 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11:30 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11:30 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11:30 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNqfi-c0gURU_BoM5_oC0AgmSF4bv7Sc7pu-LxB=w482-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great cocktails": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Great wine list": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible restroom": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Hard liquor": true
        },
        {
          "Late-night food": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Historic": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        },
        {
          "Upscale": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Brunch reservations recommended": true
        },
        {
          "Lunch reservations recommended": true
        },
        {
          "Reservations required": true
        },
        {
          "Dinner reservations recommended": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Good for kids birthday": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601498",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJB5LtCMb71y0RVfDjH2lsUk0",
    "name": "Sontoloyo Gubeng",
    "address": "Jl. Nias No.60, Gubeng, Kec. Gubeng, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.3",
    "reviewCount": 255,
    "placeId": "ChIJB5LtCMb71y0RVfDjH2lsUk0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Sontoloyo%20Gubeng&query_place_id=ChIJB5LtCMb71y0RVfDjH2lsUk0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 823-2080-8881",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nouq-KdlRZWstcVdpX7EhfQGc7GssOSKUgSRMcGYVx_V2PTFHDlF_FsH1ac8C2aIo8iNA-zBwhrlp9wLAanCxu0CgCb9p2CawLWiEv9RxDRBHM4-jVCjCvpadv8qpJxoJGmFZP0=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "On-site parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601511",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJXxjrZZX71y0RNC9KElu3FU8",
    "name": "Kannely Cafe & Dining",
    "address": "Papaya Fresh Gallery, Jl. Laguna Raya KJW Putih Barat No.4 Lt. 2, Mulyorejo, Surabaya, East Java 60112, Indonesia",
    "rating": "4.9",
    "reviewCount": 183,
    "placeId": "ChIJXxjrZZX71y0RNC9KElu3FU8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kannely%20Cafe%20%26%20Dining&query_place_id=ChIJXxjrZZX71y0RNC9KElu3FU8",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 812-2288-7892",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Kejawaan Putih Tamba, Mulyorejo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrzcDuNg__qIhs3yW-FsdebU4k1cXizmhswwvT6c7hEl-pZB_PJZ4f61zbtGaULIiJG9ulxTST3gQy045vmassYN-CkwJKQz3XPuS8QpDW9b6D321r0J-kiZZ5rDUg3nY87jpT7=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy-hour drinks": true
        },
        {
          "Happy-hour food": true
        },
        {
          "Private dining room": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Counter service": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free of charge street parking": true
        },
        {
          "Free parking lot": true
        },
        {
          "On-site parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.272,
      112.805
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601548",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJSdLYCTj71y0R5T8YzHTk4E0",
    "name": "TENTWO Coffee & Kindness",
    "address": "Jl. Jawa No.41, Gubeng, Kec. Gubeng, Surabaya, Jawa Timur 60281, Indonesia",
    "rating": "4.4",
    "reviewCount": 355,
    "placeId": "ChIJSdLYCTj71y0R5T8YzHTk4E0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=TENTWO%20Coffee%20%26%20Kindness&query_place_id=ChIJSdLYCTj71y0R5T8YzHTk4E0",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 817-0311-2860",
    "website": "https://instagram.com/tentwocoffee?igshid=1us3vfcjn4hnw",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipM5VZ2r_k2wfIrH6aiDjwgUtT0lWF8vE6CwrONB=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601567",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJJ-QBQJj51y0RfUeLbYUJcyc",
    "name": "\" STK \" Sedulur Tunggal Kopi (STK KENJERAN)",
    "address": "Jl. Kenjeran No.329, Gading, Kec. Tambaksari, Surabaya, Jawa Timur 60134, Indonesia",
    "rating": "4.5",
    "reviewCount": 207,
    "placeId": "ChIJJ-QBQJj51y0RfUeLbYUJcyc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=%22%20STK%20%22%20Sedulur%20Tunggal%20Kopi%20%28STK%20KENJERAN%29&query_place_id=ChIJJ-QBQJj51y0RfUeLbYUJcyc",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Gading, Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqFQmG06omtoH6MqB2ctV92UufKl5Ke7zv-GPpl9N4JooHv9sACVIArgfpa9NDjQbmaMc8KvVTxEWMOUPbWbjemIvwf1XKh7xelNhjgd2I29_JzURCD8QGYClQbf8d5ucnIqiI8=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.252,
      112.765
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601584",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ39RvdQD71y0RlqqGocTrayA",
    "name": "Warkop Bening Plus",
    "address": "Jl. Gn. Anyar Indah No.A-23, Gn. Anyar, Kec. Gn. Anyar, Surabaya, Jawa Timur 60294, Indonesia",
    "rating": "4.1",
    "reviewCount": 150,
    "placeId": "ChIJ39RvdQD71y0RlqqGocTrayA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Bening%20Plus&query_place_id=ChIJ39RvdQD71y0RlqqGocTrayA",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nocNrtVU5_PJPiNDWSQ2KeJWTl_accZrpbJ7l4uTbrTMxT7DBB6bXbOD4XEEKz31fq1V0BC1Ke76CM13Am6BUJd7yHUa1aQOQoXQaF2jgEOUEJsVBkiT7M7XO3qvpAP_nxVwTwSPw=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601621",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJO4SgQbf81y0RGHF2MwSxAJ8",
    "name": "Warkop Akas",
    "address": "No Jl. Ksatria No.2-4, Karang Pilang, Kec. Karangpilang, Surabaya, Jawa Timur 60222, Indonesia",
    "rating": "4.4",
    "reviewCount": 153,
    "placeId": "ChIJO4SgQbf81y0RGHF2MwSxAJ8",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Akas&query_place_id=ChIJO4SgQbf81y0RGHF2MwSxAJ8",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 857-4877-6607",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "12 AM to 11:59 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Karang Pilang, Karangpilang",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4np4m_Eywtpl34DJk2S8XPzm0ZGPoTTHGQsfhkJf1PrIXxEa4z5blWeuZZuisgE9VnLErUGCELL57XHPl6zZpzY4w_amSPPn-kNdfpHIuxlXJg9Rk8NAAujBfEJjm655BorcqdIuLg=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.295,
      112.695
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601640",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJtz8kf8D81y0RaEOVPYwm1-I",
    "name": "Kedai Ku",
    "address": "Jl. Balas Klumprik No.48, Balas Klumprik, Kec. Wiyung, Surabaya, Jawa Timur 60222, Indonesia",
    "rating": "4.5",
    "reviewCount": 129,
    "placeId": "ChIJtz8kf8D81y0RaEOVPYwm1-I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Ku&query_place_id=ChIJtz8kf8D81y0RaEOVPYwm1-I",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-3238-8816",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 11:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 11:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 11:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 11:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 11:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 11:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 11:30 PM"
        }
      }
    ],
    "neighborhood": "Balas Klumprik, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOUSQ0Yzteg4jWzlWJslSHbF4DiAZds5_Ju6DxF=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601653",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJR5pTED371y0R1M1T4DG7x50",
    "name": "Warkop Cak Mad",
    "address": "Gg. Lebar No.1, Kendangsari, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60292, Indonesia",
    "rating": "4.3",
    "reviewCount": 348,
    "placeId": "ChIJR5pTED371y0R1M1T4DG7x50",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warkop%20Cak%20Mad&query_place_id=ChIJR5pTED371y0R1M1T4DG7x50",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 856-3209-927",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Kendangsari, Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noosBKvtVnku8FToCHXdmBohFsVOemaWnIx4mbTgf9c-NQDFguh2r_MPW1d7H6GwXWCiXRdn7pmkebMQlPfVhDIDeA011VV8ke3lkHctXZ5n2mLTzUyQuLOIqLdCroMvXa0emcUyw=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.651Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601667",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJt75-drv71y0RHlUX-CixZNM",
    "name": "STMJ Bu Nunuk",
    "address": "Jl. Ngagel Dadi II No.2, RT.001/RW.10, Ngagelrejo, Kec. Wonokromo, Surabaya, Jawa Timur 60245, Indonesia",
    "rating": "4.4",
    "reviewCount": 1448,
    "placeId": "ChIJt75-drv71y0RHlUX-CixZNM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=STMJ%20Bu%20Nunuk&query_place_id=ChIJt75-drv71y0RHlUX-CixZNM",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 857-8502-6773",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "5 PM to 2:30 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "5 PM to 2:30 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "5 PM to 2:30 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "5 PM to 2:30 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "5 PM to 2:30 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "5 PM to 2:30 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "5 PM to 2:30 AM"
        }
      }
    ],
    "neighborhood": "Ngagelrejo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqe3t43nxGBcXMNqilbUZrE3kLYDLGu6srbX0zLTO2JhN3v_kbaDoqQvJM7L9F1IymD2lNTFs17MfOUqycOStnB8Ys0mam6Ek-Of-64AFh7LP10XNAGAdqgu48RS6uROwH4JS_tZg=w408-h545-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601682",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJh6uRD0L51y0RPU09ZKVlrV4",
    "name": "Nusantara, Warunk Kopi Premium",
    "address": "Jl. Bronggalan II No.42, Ploso, Kec. Tambaksari, Surabaya, Jawa Timur 60133, Indonesia",
    "rating": "4.5",
    "reviewCount": 276,
    "placeId": "ChIJh6uRD0L51y0RPU09ZKVlrV4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Nusantara%2C%20Warunk%20Kopi%20Premium&query_place_id=ChIJh6uRD0L51y0RPU09ZKVlrV4",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 813-3221-9223",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Ploso, Tambaksari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqUngtKKsvdl8TD29-5eho7PmnWG2Z1LoMEP7AKb5tnEfDXdm7k-xzGETjmnlGYI0DZ1peGOjEJdR0PZnjdvWAndmFWcA-KGmcQlFLMxB-yBkRbniL8gPFIB64rWVjE-olHgVI=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.252,
      112.765
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601699",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJFXj1Plj81y0Ra3F_5diue6c",
    "name": "WARKOP BEJO",
    "address": "Gg. I No.32, Babatan, Kec. Wiyung, Surabaya, Jawa Timur 60227, Indonesia",
    "rating": "4.5",
    "reviewCount": 106,
    "placeId": "ChIJFXj1Plj81y0Ra3F_5diue6c",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=WARKOP%20BEJO&query_place_id=ChIJFXj1Plj81y0Ra3F_5diue6c",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 822-3031-4608",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 3 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 3 AM"
        }
      }
    ],
    "neighborhood": "Babatan, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipO6AGUuzzcMphGgYTQjvp-yD2vCnFtFYAAvGzWj=w408-h408-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601711",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJN3s-KVj71y0Rm4vZxFYIXfo",
    "name": "Kopi Kakak Surabaya",
    "address": "Jl. Pucang Anom Tim. No.48, Pucang Sewu, Kec. Gubeng, Surabaya, Jawa Timur 60282, Indonesia",
    "rating": "4.5",
    "reviewCount": 549,
    "placeId": "ChIJN3s-KVj71y0Rm4vZxFYIXfo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Kakak%20Surabaya&query_place_id=ChIJN3s-KVj71y0Rm4vZxFYIXfo",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-3374-6745",
    "website": "https://instagram.com/kopikakak.sub?igshid=1mdvwhyrtak7u",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Pucang Sewu, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNCal0eNk3waAzT496BXQ07xRp2WlL1VCCObriD=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601724",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJaStuhrr71y0R1pXqkRYfu8I",
    "name": "Kroesel House Of Coffee",
    "address": "Jl. Krukah Selatan No.52, Ngagelrejo, Kec. Wonokromo, Surabaya, Jawa Timur 60245, Indonesia",
    "rating": "4.6",
    "reviewCount": 177,
    "placeId": "ChIJaStuhrr71y0R1pXqkRYfu8I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kroesel%20House%20Of%20Coffee&query_place_id=ChIJaStuhrr71y0R1pXqkRYfu8I",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 857-3572-2485",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "Ngagelrejo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNFUTRs9Ct2cs26Qg_bedhbqMAK4ptBRGG7hhBU=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601738",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJJ4QTt6T61y0R3BQ02YIMP10",
    "name": "Moengkopi JiwARTspace",
    "address": "Medokan Ayu Medokan Ayu MA III D-35, Medokan Ayu, Kec. Rungkut, Surabaya, Jawa Timur 60295, Indonesia",
    "rating": "4.7",
    "reviewCount": 950,
    "placeId": "ChIJJ4QTt6T61y0R3BQ02YIMP10",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Moengkopi%20JiwARTspace&query_place_id=ChIJJ4QTt6T61y0R3BQ02YIMP10",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 877-0478-0693",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Medokan Ayu, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPSxM7OgcflCPVjAr64w2So-ShL4xK5TOI38HMR=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible toilet": true
        },
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral toilets": true
        },
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Appointment required": true
        },
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601753",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ2Te3suT71y0RMOqa4h9Ruo0",
    "name": "Warung Kopi CS reborn telah hadir di kota pahlawan, mari ajak temen2 kalian untuk menikmati bermacam minuman",
    "address": "Jl. Pasar Kembang No.112A, Kupang Krajan, Kec. Sawahan, Surabaya, Jawa Timur 60253, Indonesia",
    "rating": "4.5",
    "reviewCount": 90,
    "placeId": "ChIJ2Te3suT71y0RMOqa4h9Ruo0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warung%20Kopi%20CS%20reborn%20telah%20hadir%20di%20kota%20pahlawan%2C%20mari%20ajak%20temen2%20kalian%20untuk%20menikmati%20bermacam%20minuman&query_place_id=ChIJ2Te3suT71y0RMOqa4h9Ruo0",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 813-3415-8930",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Kupang Krajan, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npkOzux77t7N6oKSEF_prhfrzpIZU6jiJtut_6pM6ESxf_VSLsAmh8zNTaYORAiZHBmudwd44xyyJ4PWPPVF3XzZ4uVWippWPJIlvyyFMRBQj1k3dfCkkfutE-hR33sr8SrVsf2=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Sport": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        },
        {
          "Wheelchair-accessible entrance": false
        },
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601770",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJL-m5d3D71y0RCPPS99DAi0A",
    "name": "Kopi Jiku",
    "address": "Located in: Tempat - The Surabaya Creative Compound, Tenant F3, Tempat - The Surabaya Creative Compound, Jl. Cipunegara No.48-A, RT.016/RW.06, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.5",
    "reviewCount": 105,
    "placeId": "ChIJL-m5d3D71y0RCPPS99DAi0A",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Jiku&query_place_id=ChIJL-m5d3D71y0RCPPS99DAi0A",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 822-2899-8004",
    "website": "https://www.instagram.com/kopijiku/",
    "openingHours": [],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noxqtA1p6FZzeWX3nlalAG2zNStipZmRQKmFS9KeHXzDhUaMcxOFMAOVzambySuvJyC7GWHkuVs-MFiiKUBEBdlvXpk_Ib3NiRA2eNMIgCly2XiN2yLkv9JfO6yeKjzZW-WlsNqIA=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601785",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJte7X3dv91y0RTxqsHrqQC1Q",
    "name": "KAE KOPI SURABAYA",
    "address": "Jl. Dukuh Kupang Utara I No.18, Putat Jaya, Kec. Sawahan, Surabaya, Jawa Timur 60255, Indonesia",
    "rating": "4.7",
    "reviewCount": 126,
    "placeId": "ChIJte7X3dv91y0RTxqsHrqQC1Q",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KAE%20KOPI%20SURABAYA&query_place_id=ChIJte7X3dv91y0RTxqsHrqQC1Q",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": "https://instagram.com/kaekopi2.0official?igshid=MzRlODBiNWFlZA==",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Putat Jaya, Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npRqANVM9pNX7hCC9M98GkKR3U80ZUNFfIoFudigQ_by8qSpsE8KDdLKQrd5OLjxbJtbSEDm3WjbIFazpWAyIYNS4CDRNjVBzutkCrPW-HdPmxhejy3ejZkLKxIRYfOEvfy2Ojq=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible toilet": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar on site": true
        },
        {
          "Toilet": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601798",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJfeQQ13n71y0RmgCbGOKbwcA",
    "name": "VOC (Vereenigde Opak Coffee)",
    "address": "Jl. Opak No.30, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.7",
    "reviewCount": 136,
    "placeId": "ChIJfeQQ13n71y0RmgCbGOKbwcA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=VOC%20%28Vereenigde%20Opak%20Coffee%29&query_place_id=ChIJfeQQ13n71y0RmgCbGOKbwcA",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 11:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 11:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 11:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 11:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 11:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 11:30 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nppjCJFJgj9sx4FnZnzyenagKhSPb13pK6ozSUrI_kG_HBQLFGDYaD4YO5ls83Q1QwD7F63cSYJBF1Q8Ghr5mmrGyp-RWJWcnY8lJUBErPvQHNVvWILIUMJASOJ12a1TAFT7Ec5hw=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601812",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJm8jFjHP61y0RmqS-N0T8aWM",
    "name": "Kopiganes",
    "address": "Jl. Keputih Tegal Tim. II No.116, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur 60111, Indonesia",
    "rating": "4.6",
    "reviewCount": 350,
    "placeId": "ChIJm8jFjHP61y0RmqS-N0T8aWM",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopiganes&query_place_id=ChIJm8jFjHP61y0RmqS-N0T8aWM",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-2952-612",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "5 to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "5 to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "5 to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "5 to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "5 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "5 to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "5 to 10 PM"
        }
      }
    ],
    "neighborhood": "Keputih, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4no0XI_PS8xnrHrNwhDoDJO0uzZam07E-OB61uwz_QZOYjx-_JNj0GH2BH-0Kc8Wuz9ML0_r-aKYsuH7ri58DMzmFSPj0B8Mt3HEiVqtH6il3GNYFwSm4f9LRK1QSbJArJPE_Hkg=w408-h300-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        },
        {
          "Usually a wait": true
        }
      ],
      "Payments": [
        {
          "Cash only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601839",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJDYFwq3371y0RRzuISF3uuyw",
    "name": "Coloni Coffee Shop",
    "address": "Ruko RMI, Jl. Ngagel Jaya Sel. No.A1 - 2, Baratajaya, Gubeng, Surabaya, East Java 60283, Indonesia",
    "rating": "4.6",
    "reviewCount": 88,
    "placeId": "ChIJDYFwq3371y0RRzuISF3uuyw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Coloni%20Coffee%20Shop&query_place_id=ChIJDYFwq3371y0RRzuISF3uuyw",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 822-2994-2395",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Baratajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npuQQgCJJ_NW2rANYVGICL39y5-J6TdtifIAhmBpW1Md8_p6DTtJHjjisv_9wYVG8V_ntMZSIwgJAsFGR-nUNO_bDHvthAAz-1_PkmvbGLp6SEucEdfZ7BmwVu5wcNkeEV1mHebX4k_hI0=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Fireplace": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601852",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJMXtyHRj71y0R0ek3twXdjSQ",
    "name": "KOPINUKU",
    "address": "Jl. Ketintang Baru IV No.14, Ketintang, Kec. Gayungan, Surabaya, Jawa Timur 60231, Indonesia",
    "rating": "4.9",
    "reviewCount": 83,
    "placeId": "ChIJMXtyHRj71y0R0ek3twXdjSQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=KOPINUKU&query_place_id=ChIJMXtyHRj71y0R0ek3twXdjSQ",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-1654-3929",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "2 to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "2 to 10 PM"
        }
      }
    ],
    "neighborhood": "Ketintang, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nr7MCEjWr49xmG_RJA3ewZuIojQK7nnVbP6ZZHdzAn_CmdcwTtRymroJSPjr8SOULZkSfX9453BRIAZXLlN34E6YNxvd67uLFhLG1XjH-gEluk1SLJ3f0VkVcAZ8-Bux6DZKxyQ=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601867",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJL_3RxIv71y0RUsjBrYf3fb4",
    "name": "My Kopi-O! - Ciputra World",
    "address": "Lantai 3 No.8, Ciputra World surabaya, jalan mayjen sungkono no.89, Gunungsari, dukuh pakis, Gn. Sari, Surabaya, Jawa Timur 60224, Indonesia",
    "rating": "4.8",
    "reviewCount": 2385,
    "placeId": "ChIJL_3RxIv71y0RUsjBrYf3fb4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=My%20Kopi-O%21%20-%20Ciputra%20World&query_place_id=ChIJL_3RxIv71y0RUsjBrYf3fb4",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 31 51200203",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Gunung Sari, Surabaya",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNSleGwK1Dsp-uNGaeR_NW2GzoRBwqTMa4SYQaS=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601901",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJcQZ8TUb91y0RKflusb3DqsU",
    "name": "Kedai Kopi Uncle Fu",
    "address": "Jl. Kutai Jl. Opak No.10, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur 60241, Indonesia",
    "rating": "4.3",
    "reviewCount": 172,
    "placeId": "ChIJcQZ8TUb91y0RKflusb3DqsU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Kopi%20Uncle%20Fu&query_place_id=ChIJcQZ8TUb91y0RKflusb3DqsU",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 822-2981-1077",
    "website": "http://kedaikopiunclefu.store/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Darmo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipO1dYDaehbxkaNCEJnjT8huEpWYrOlXNKxJitQS=w408-h454-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Late-night food": true
        },
        {
          "Private dining room": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601915",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJKWuIkrH91y0RJFn-Q53VO78",
    "name": "Omah Bobo",
    "address": "Jl. Raya Darmo Permai Utara No.20, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60187, Indonesia",
    "rating": "4.8",
    "reviewCount": 590,
    "placeId": "ChIJKWuIkrH91y0RJFn-Q53VO78",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Omah%20Bobo&query_place_id=ChIJKWuIkrH91y0RJFn-Q53VO78",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 821-6188-7575",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqvU2KFlgHXO0LhZiIRgafzjbZdK2JyGKulVK09CcynCvNd69IlVeiRPscHqVXcDLyFepMuakrpdbxBdVNmHw5YxX65zATTC1tUFjq3hSBKNxSYCsQMWhd76aL9eCDbLANELdM=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Private dining room": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601932",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJD_u3diL91y0RVlxgqyYKcOo",
    "name": "TIMUR KOPI",
    "address": "Jl. Raya Simo Gunung No.108, Putat Jaya, Kec. Sukomanunggal, Surabaya, Jawa Timur 60255, Indonesia",
    "rating": "4.6",
    "reviewCount": 130,
    "placeId": "ChIJD_u3diL91y0RVlxgqyYKcOo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=TIMUR%20KOPI&query_place_id=ChIJD_u3diL91y0RVlxgqyYKcOo",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Putat Jaya, Sukomanunggal",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nogri1600QwA3Ew1bLn1bFZ7KxTLhx1wwp_25EBfmEoO-QrA7yunwXqrH66F3f5MFrF2KGb7T5NVcEOyRj0qf9-rtcIR3yD8J-nCcY0Inhiw-WmvW1GHqYk_YOxxzycoxeVFP7e=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.27,
      112.685
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601945",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJVby7gQv81y0RGM-esL3d7j4",
    "name": "Kedai Kopi Rempah",
    "address": "No 231 Sawahan, Jl. Dukuh Kupang Barat I, Dukuh Pakis, Kec. Dukuhpakis, Surabaya, Jawa Timur 60255, Indonesia",
    "rating": "4.4",
    "reviewCount": 237,
    "placeId": "ChIJVby7gQv81y0RGM-esL3d7j4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Kopi%20Rempah&query_place_id=ChIJVby7gQv81y0RGM-esL3d7j4",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-3086-3386",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Dukuh Pakis, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMgm8Mhp3fpNO2-nqQcSUBMZTAZ49W7FFRQJEvD=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601959",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJmb8yPWr91y0RsxRSjfMTtic",
    "name": "Michuu Coffee House 미츄 커피 하우스",
    "address": "Ruko Taman Gapura Jalan Puri Widya Kencana No.K6/11, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "4.6",
    "reviewCount": 239,
    "placeId": "ChIJmb8yPWr91y0RsxRSjfMTtic",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Michuu%20Coffee%20House%20%EB%AF%B8%EC%B8%84%20%EC%BB%A4%ED%94%BC%20%ED%95%98%EC%9A%B0%EC%8A%A4&query_place_id=ChIJmb8yPWr91y0RsxRSjfMTtic",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-3321-388",
    "website": "https://linktr.ee/michuu.coffee",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrtEtB-nZPeVDe2uAuxHNNcHgXLrcjWqoJa8mFjbReh08dHEG21PvDJCnPXWhQqZJfZ9VMB57gc-0Oe_dxEwY30tkpgY5kwRnUmdwsO_0OtQJT6zXVUIv9quq_ikadrErWFmh8LIw=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.289,
      112.632
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601976",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJiVrUIm_91y0RWzGkk0-4Wm4",
    "name": "Xiang Jia Kopitiam GWalk",
    "address": "GWalk, Citraland, Ruko Taman Gapura, B-18, Lontar, Kec. Sambikerep, Surabaya, Jawa Timur 60216, Indonesia",
    "rating": "4.7",
    "reviewCount": 793,
    "placeId": "ChIJiVrUIm_91y0RWzGkk0-4Wm4",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Xiang%20Jia%20Kopitiam%20GWalk&query_place_id=ChIJiVrUIm_91y0RWzGkk0-4Wm4",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 817-0640-007",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 AM to 2 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 AM to 2 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Closed"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 AM to 2 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 AM to 2 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 AM to 2 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 AM to 2 PM"
        }
      }
    ],
    "neighborhood": "Lontar, Sambikerep",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrX-laTjHmP0TehBYoQ5CMK484gJ2kLL2_EBDiC8nhvF_CmEzcMP8ad4RJ58u7IO0UxvUsT-ixIpmyfCznyltG7uk162xUP_IYZZEwfr10Y7OQadeJQp-M2-xt7wB-5C0U6JekNuw=w408-h510-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Usually a wait": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.282,
      112.667
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.601989",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJaV9z8zn81y0Rp3w6dqkMfd0",
    "name": "Starbucks Lenmarc Mall",
    "address": "Level G, Olen Marc, Jalan Mayjen Yono Suwoyo No.9, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60226, Indonesia",
    "rating": "4.4",
    "reviewCount": 420,
    "placeId": "ChIJaV9z8zn81y0Rp3w6dqkMfd0",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Starbucks%20Lenmarc%20Mall&query_place_id=ChIJaV9z8zn81y0Rp3w6dqkMfd0",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 821-9838-4007",
    "website": "http://www.starbucks.co.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMWGL8CTGOaJK9bQcxZKkGbRHF-uLniZrLbOvkS=w408-h280-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Dessert": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "Unknown",
    "coordinates": [
      -7.256,
      112.753
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602002",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_verified": false,
    "coordinates_estimated": true
  },
  {
    "id": "ChIJHwFN0Fr51y0RUaL_mcjCeQo",
    "name": "Caturra Espresso",
    "address": "Jl. Anjasmoro No.32, Sawahan, Kec. Sawahan, Surabaya, Jawa Timur 60251, Indonesia",
    "rating": "4.5",
    "reviewCount": 1679,
    "placeId": "ChIJHwFN0Fr51y0RUaL_mcjCeQo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Caturra%20Espresso&query_place_id=ChIJHwFN0Fr51y0RUaL_mcjCeQo",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 813-5825-6664",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Sawahan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipO9ApqoiZMAEUX75-dOaexTY80kDinYmkkBGNAV=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible seating": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Organic dishes": true
        },
        {
          "Quick bite": true
        },
        {
          "Vegan options": true
        },
        {
          "Vegetarian options": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.255,
      112.743
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602015",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJsaODD9n41y0RRDiEkqBVHUU",
    "name": "Gila Kopi",
    "address": "Jl. Ikan Duyung No.6, Perak Bar., Kec. Krembangan, Surabaya, Jawa Timur 60177, Indonesia",
    "rating": "4.6",
    "reviewCount": 95,
    "placeId": "ChIJsaODD9n41y0RRDiEkqBVHUU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Gila%20Kopi&query_place_id=ChIJsaODD9n41y0RRDiEkqBVHUU",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-3080-410",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "West Perak, Krembangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMKOsiEKWbdQeZt4re-00MyA-l2R7LvqmT4InpV=w408-h684-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Utara",
    "coordinates": [
      -7.248,
      112.725
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602030",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJIzf39Lr91y0RGcFbti3xi7k",
    "name": "Common Grounds - Graha Famili",
    "address": "Jl. Raya Golf Graha Famili Bundaran Blok I, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60226, Indonesia",
    "rating": "4.6",
    "reviewCount": 864,
    "placeId": "ChIJIzf39Lr91y0RGcFbti3xi7k",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Common%20Grounds%20-%20Graha%20Famili&query_place_id=ChIJIzf39Lr91y0RGcFbti3xi7k",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-384-729",
    "website": "http://wa.me/+62811384729",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nooneAmfFil53aWqHzkxlw_OZEgrz689GFt5jTBFGRFJCdMFBriYOGDhoCmVz_o4x8NjX-MbNo-Fd9aSfJZxlm84nLPiHXrvshoIs7zX7ZltJXgqtEysNQRJhX1TDDkm9CDuI3x=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible restroom": true
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602049",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJSS1Gk4791y0RgXbTMHuelRY",
    "name": "Es Teh Indonesia - Babatan UNESA",
    "address": "Jl. Babatan UNESA No.90, Babatan, Kec. Wiyung, Surabaya, Jawa Timur 60227, Indonesia",
    "rating": "4.6",
    "reviewCount": 141,
    "placeId": "ChIJSS1Gk4791y0RgXbTMHuelRY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Es%20Teh%20Indonesia%20-%20Babatan%20UNESA&query_place_id=ChIJSS1Gk4791y0RgXbTMHuelRY",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 813-3650-8702",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Babatan, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nokfSWBwVvarVlAAOg54I6aDcRLz3uej063zaUFixyaJyf1cRmgW9nFqWCGUXkpSCesD_KpkqIclPDLwpGEJjwFjuxfpzxvMIRdJhSvw1yLALdgvvgtqAEgqn2P47l5252bAnIpFg=w408-h725-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602063",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJSfQQ9gr91y0RdA0dCBiWh18",
    "name": "Expat. Roasters Graha Famili Surabaya",
    "address": "Soho Graha Famili, Jl. Raya Graha Famili Tim. No.15 PS 15, Pradahkalikendal, Kec. Dukuhpakis, Surabaya, Jawa Timur 60225, Indonesia",
    "rating": "4.4",
    "reviewCount": 497,
    "placeId": "ChIJSfQQ9gr91y0RdA0dCBiWh18",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Expat.%20Roasters%20Graha%20Famili%20Surabaya&query_place_id=ChIJSfQQ9gr91y0RdA0dCBiWh18",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 821-3161-8995",
    "website": "http://www.expatroasters.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Pradahkalikendal, Dukuhpakis",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipOVP4z1MsdOxzPaznHSBaRGL2enamScNEzjBicm=w408-h643-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.285,
      112.705
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602083",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ-7JzA5T91y0R-bx4VHNcJcA",
    "name": "Nordic By The Founders",
    "address": "Jl. Puri Widya Kencana No.JT1/28, Lidah Kulon, Kec. Lakarsantri, Surabaya, Jawa Timur 60213, Indonesia",
    "rating": "5",
    "reviewCount": 163,
    "placeId": "ChIJ-7JzA5T91y0R-bx4VHNcJcA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Nordic%20By%20The%20Founders&query_place_id=ChIJ-7JzA5T91y0R-bx4VHNcJcA",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 822-8998-2737",
    "website": "https://www.instagram.com/p/C3hCHzIRwEj/?igsh=N21mcGtkcm90bDd3",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Closed"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 7 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 7 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 7 PM"
        }
      }
    ],
    "neighborhood": "Lidah Kulon, Lakarsantri",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrPv6Eefc4ivvj6js-BYvDYI0CF6PaNhjLj_SZ5AYYJv0EPBcey4RzRxLC1wEt7bKPOK4pRSBf2Lpe7s1gKd0uHe1CPK5fgHtPxR6hBJLPy8s-xiQRQl1coMNVfQl8g20iVws4=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Pluxee": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking garage": true
        },
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        },
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Barat",
    "coordinates": [
      -7.289,
      112.632
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602094",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJW2Xr5Yz71y0RXBzRD8Ogjwg",
    "name": "Kedai Pulang Kantor",
    "address": "Jl. Jemur Andayani No.17 A, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.7",
    "reviewCount": 103,
    "placeId": "ChIJW2Xr5Yz71y0RXBzRD8Ogjwg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Pulang%20Kantor&query_place_id=ChIJW2Xr5Yz71y0RXBzRD8Ogjwg",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 856-4838-9270",
    "website": "https://instagram.com/kedaipulangkantor",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "3 PM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "3 PM to 12 AM"
        }
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipP5WmnWWZMp3i5ccheufxa4EvItHaEuFUjTb_aB=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602112",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJbyFPTgD71y0RWNxIP4NtSRc",
    "name": "\" STK \" Sedulur Tunggal Kopi (STK SIWALANGEDE)",
    "address": "Jl. Siwalankerto Timur No.232-234, Siwalankerto, Kec. Wonocolo, Surabaya, Jawa Timur 60236, Indonesia",
    "rating": "4.7",
    "reviewCount": 103,
    "placeId": "ChIJbyFPTgD71y0RWNxIP4NtSRc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=%22%20STK%20%22%20Sedulur%20Tunggal%20Kopi%20%28STK%20SIWALANGEDE%29&query_place_id=ChIJbyFPTgD71y0RWNxIP4NtSRc",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Siwalankerto, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrYfqHDEJ5mrvKF6tm7HFkbXqmBnZ1GwKLGrMBVXXjaKQat_76S54EWEgxEYEQEqp9JhZ9F4QCI99mDCSBRBg0szv-3k6aMXhxM5VvgG14LGwnRwYHonZaNnnhl_U5wW7lEEu-VGg=w408-h541-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602130",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJoexCLAX71y0RMYV1ASLDe3I",
    "name": "EKNOR COFFEE & EATERY",
    "address": "Blok MGN, Taman, Jl. Gayungsari Tim. No.09, Menanggal, Gayungan, Surabaya, East Java 60234, Indonesia",
    "rating": "4.7",
    "reviewCount": 111,
    "placeId": "ChIJoexCLAX71y0RMYV1ASLDe3I",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=EKNOR%20COFFEE%20%26%20EATERY&query_place_id=ChIJoexCLAX71y0RMYV1ASLDe3I",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-8433-3228",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Menanggal, Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMJfVKrmi2lprGNxeX179F3hrA5X5_MRFS8VnHS=w431-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602148",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ4ThvYAD71y0RLY89LHrhLXY",
    "name": "Kedai Ciamso Jemursari",
    "address": "Jl. Jemur Wonosari Gg. Sekolahan No.1 B, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.6",
    "reviewCount": 1678,
    "placeId": "ChIJ4ThvYAD71y0RLY89LHrhLXY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Ciamso%20Jemursari&query_place_id=ChIJ4ThvYAD71y0RLY89LHrhLXY",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 821-4206-9116",
    "website": "https://www.instagram.com/kedaiciamso/?hl=en",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqcVbt9_kJoL0urto25-fR0UXS_zWgX4LOXmA3HJAe41KdBRPCaK50nPvDSG-cazl0OTO1UWwjZZXYlkvdi-pVdW9sUFtR4SPHMV1SVpLaqpbtQai6OKR7h7m78wbmeb61QLAzg=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.294,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602162",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ9bakqRP71y0Rs1nr_UOljZU",
    "name": "Crema Coffee - Jemursari VI",
    "address": "Jl. Jemursari VI No.2, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.7",
    "reviewCount": 296,
    "placeId": "ChIJ9bakqRP71y0Rs1nr_UOljZU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Crema%20Coffee%20-%20Jemursari%20VI&query_place_id=ChIJ9bakqRP71y0Rs1nr_UOljZU",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7:30 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipN-P66KD20gYMwujebBP_o74QLz8v75riZ4uboQ=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.294,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602178",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJw1OV60n71y0RELhFs78dN6Q",
    "name": "Keos Territory",
    "address": "Jl. Tenggilis Mejoyo Utara III No.1, Tenggilis Mejoyo, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60292, Indonesia",
    "rating": "4.7",
    "reviewCount": 266,
    "placeId": "ChIJw1OV60n71y0RELhFs78dN6Q",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Keos%20Territory&query_place_id=ChIJw1OV60n71y0RELhFs78dN6Q",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "Open 24 hours"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Open 24 hours"
        }
      }
    ],
    "neighborhood": "Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrZ6DtbwJmnkKs8Yw6fIx1ve6v-XyzmyIIpFjj2u9Cm40ggq98xjcXHit54I1uKrfus12SKee0DmEdOwK3EifRhogUkhV4mDfvEKK7kv1PitTFUZ-Wu3GFGsH2YXyuQt1U9474l=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Parking": [
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602192",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJHfD7Mxz71y0RqP4WU5tDUCg",
    "name": "Roasterrich Coffee House & Eatery",
    "address": "Jl. Raya Tenggilis Mejoyo No.152 B, Tenggilis Mejoyo, Kec. Tenggilis Mejoyo, Surabaya, Jawa Timur 60292, Indonesia",
    "rating": "4.5",
    "reviewCount": 356,
    "placeId": "ChIJHfD7Mxz71y0RqP4WU5tDUCg",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Roasterrich%20Coffee%20House%20%26%20Eatery&query_place_id=ChIJHfD7Mxz71y0RqP4WU5tDUCg",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-305-441",
    "website": "http://roasterrich.com/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 11:30 PM"
        }
      }
    ],
    "neighborhood": "Tenggilis Mejoyo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nq-2hzvDjOt6vydrvU0MB5tmmlJl-zB9Vjs4NLFjaY96B5PvX6dpu-FQay-5bg1GN044b7MgJczZ7jA389AFuJjuhVriiT8132tWo2zY5NRmCejNvDLrhP_ZjFOrlAKrTxfp3dlMg=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Organic dishes": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Catering": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.652Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.291,
      112.81
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602207",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJv7zfKcL71y0Rz-pYNzoMOUk",
    "name": "Threelogy Coffee",
    "address": "Jl. Mojopahit No.46, Keputran, Kec. Tegalsari, Surabaya, Jawa Timur 60265, Indonesia",
    "rating": "4.6",
    "reviewCount": 1355,
    "placeId": "ChIJv7zfKcL71y0Rz-pYNzoMOUk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Threelogy%20Coffee&query_place_id=ChIJv7zfKcL71y0Rz-pYNzoMOUk",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Keputran, Tegalsari",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nruJTnupgZC4eL1qOcFCvQYnx1FeHING9-0E820DR-3zkDh3W-FzVvHisqm3VCu_whr0ALzTw7ns3awkOgngchySoq_U1f53tvCPBlQxQrAMdAqb5TPudkyrBT0p28X15bc3-9NtQ=w427-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Gender-neutral restroom": true
        },
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.272,
      112.738
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602221",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJWWG6Fq771y0RABBAGdy2BrE",
    "name": "Coste Coffee",
    "address": "Jl. Pucang Anom Tim. No.35, RT.004/RW.03, Kertajaya, Kec. Gubeng, Surabaya, Jawa Timur 60282, Indonesia",
    "rating": "4.6",
    "reviewCount": 279,
    "placeId": "ChIJWWG6Fq771y0RABBAGdy2BrE",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Coste%20Coffee&query_place_id=ChIJWWG6Fq771y0RABBAGdy2BrE",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 813-3190-3331",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 12 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 11:30 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 11:30 PM"
        }
      }
    ],
    "neighborhood": "Kertajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nod6wy2Nx2yGjjIhDtGuXj9ymewcoCm6gvtfeJTMn7q-oHZpsMZJRCg_ZSlJEJQ0Uk4DVL66ATbNluztjhuI5rgenj0pyZXiCsCLYxFhoypj_KhPA0YOvBVnlXq3rZMo9-d90pl=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602234",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJW7oSJDT71y0RWsmbjnG772U",
    "name": "kirei",
    "address": "Jl. Pucang Anom Tim. No.7 9, Kertajaya, Kec. Gubeng, Surabaya, Jawa Timur 60282, Indonesia",
    "rating": "4.6",
    "reviewCount": 340,
    "placeId": "ChIJW7oSJDT71y0RWsmbjnG772U",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=kirei&query_place_id=ChIJW7oSJDT71y0RWsmbjnG772U",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 811-3112-774",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Kertajaya, Gubeng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNJm0Hz6LZp2uyV_fv-hKVgm4iS2_wOjMTjo6eu=w408-h612-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.265,
      112.752
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602247",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJR0DKwjT71y0R4EVjzrnvNBQ",
    "name": "Kopi Calf Signature Tunjungan Surabaya",
    "address": "Jl. Embong Tanjung No.14, RT.001/RW.01, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271, Indonesia",
    "rating": "4.3",
    "reviewCount": 733,
    "placeId": "ChIJR0DKwjT71y0R4EVjzrnvNBQ",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Calf%20Signature%20Tunjungan%20Surabaya&query_place_id=ChIJR0DKwjT71y0R4EVjzrnvNBQ",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 851-4348-8771",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Embong Kaliasin, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npMcU1JV4pOceek5uOzc8XS2EGIjfSndyqXKOW2_t7Ii8kA3sn3DNVsdPr4TwKmKAvQ9c31zUPo7Hc6zQqu_Pphp3LUac57Atk7ZAhDyiWuZZlDowXvwEahUurXtJ5yeTjxzsTg=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602260",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJMxaDya371y0RaGNteif4C0o",
    "name": "Kedai Kopi Ama",
    "address": "Jl. Bratang Gede III No.68, Ngagelrejo, Kec. Wonokromo, Surabaya, Jawa Timur 60245, Indonesia",
    "rating": "4.8",
    "reviewCount": 96,
    "placeId": "ChIJMxaDya371y0RaGNteif4C0o",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Kopi%20Ama&query_place_id=ChIJMxaDya371y0RaGNteif4C0o",
    "categories": [
      "Cafe"
    ],
    "phone": null,
    "website": "https://www.instagram.com/kedaikopiama.sub?igsh=aTNtbmV0ZHZ2aG03",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 12 AM"
        }
      }
    ],
    "neighborhood": "Ngagelrejo, Wonokromo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMjPxko8nFWqYTdkz2qavV6ImHmh1EG4zvN97jz=w408-h272-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.315,
      112.728
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602274",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ461Mw3L71y0Rq46fcG0qbIc",
    "name": "Kedai Yumna",
    "address": "Jl. Margorejo Masjid No.35D, Margorejo, Kec. Wonocolo, Surabaya, Jawa Timur 60238, Indonesia",
    "rating": "4.6",
    "reviewCount": 95,
    "placeId": "ChIJ461Mw3L71y0Rq46fcG0qbIc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Yumna&query_place_id=ChIJ461Mw3L71y0Rq46fcG0qbIc",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-1071-7210",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "Closed"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "3 to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "3 to 11 PM"
        }
      }
    ],
    "neighborhood": "Margorejo, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMUjKgzwT_NfykIXmzcRYiGl41tt89BfoGl1WTZ=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602296",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJL5YlJbL71y0R6obEWir-r4w",
    "name": "Kanopi - Makan Nongkrong Ngopi",
    "address": "Jl. Raya Kendangsari No.89, Jemur Wonosari, Kec. Wonocolo, Surabaya, Jawa Timur 60237, Indonesia",
    "rating": "4.5",
    "reviewCount": 449,
    "placeId": "ChIJL5YlJbL71y0R6obEWir-r4w",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kanopi%20-%20Makan%20Nongkrong%20Ngopi&query_place_id=ChIJL5YlJbL71y0R6obEWir-r4w",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 812-5204-1794",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Jemur Wonosari, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipMALCHJ21F59UpC-ZLFC_zJObq33xdFawU2ftac=w428-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Romantic": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602314",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJoZ7bEjv71y0RnITVWZlhqts",
    "name": "Point Coffee",
    "address": "Blk. F No.109, Sidosermo, Kec. Wonocolo, Surabaya, Jawa Timur 60239, Indonesia",
    "rating": "4.5",
    "reviewCount": 202,
    "placeId": "ChIJoZ7bEjv71y0RnITVWZlhqts",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Point%20Coffee&query_place_id=ChIJoZ7bEjv71y0RnITVWZlhqts",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 21 1500280",
    "website": "https://pointcoffee.id/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Sidosermo, Wonocolo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNh492R5xTgBY7MbYcnQsSz_SvHbL9QA6WDNIfB=w408-h284-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Happy hour drinks": true
        },
        {
          "Happy hour food": true
        },
        {
          "Late-night food": true
        },
        {
          "Prepared foods": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": false
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.31,
      112.775
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602330",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJkx1Z2Nj71y0RvNezOJ6Sxko",
    "name": "PSI Patisserie",
    "address": "Jl. Embong Kemiri No.15, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271, Indonesia",
    "rating": "4.4",
    "reviewCount": 435,
    "placeId": "ChIJkx1Z2Nj71y0RvNezOJ6Sxko",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=PSI%20Patisserie&query_place_id=ChIJkx1Z2Nj71y0RvNezOJ6Sxko",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 878-0878-2068",
    "website": "https://www.instagram.com/psicoffeespiku",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Embong Kaliasin, Genteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nr4j1d7JNSi3ymSj-DKV2KxBuqA0H_6VouZeda598OZLIFq4kaSorqtznj2PC3mdMp7yICHOVxJUfqzFzVDQYv1B95GhOUqYdVR4rPYqKRJYepNXl7Jf5C1V1wXKdXmInWM3wiK=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Delivery": true
        },
        {
          "In-store pick-up": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        },
        {
          "Same-day delivery": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair-accessible car park": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        }
      ],
      "Amenities": [
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Planning": [
        {
          "Quick visit": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Pusat",
    "coordinates": [
      -7.258,
      112.75
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602344",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJX1p-1Df71y0R5DLkXh52Xko",
    "name": "Noia Coffee & Co",
    "address": "Jl. Nginden Semolo No.40, Nginden Jangkungan, Kec. Sukolilo, Surabaya, Jawa Timur 60118, Indonesia",
    "rating": "4.9",
    "reviewCount": 128,
    "placeId": "ChIJX1p-1Df71y0R5DLkXh52Xko",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Noia%20Coffee%20%26%20Co&query_place_id=ChIJX1p-1Df71y0R5DLkXh52Xko",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "11 AM to 12 am"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "11 AM to 12 am"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "11 AM to 12 am"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "11 AM to 12 am"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "11 AM to 12 am"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "11 AM to 12 am"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "11 AM to 12 am"
        }
      }
    ],
    "neighborhood": "Ngenden Jangkungan, Sukolilo",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npymvXRiRSy5OmkePDgnb2rrw1sVXyY1LMOYW-PBKHiVlV92mfk9ln7g5ahEBrJ2ibSHx_KPeWFrq0GMJHU6IFU1yL0pJJHicRcYTQC3f0-bg-Js3ZUTEDd3ozPRNt-1XI8MyiCDw=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Kerbside pickup": true
        },
        {
          "Drive-through": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dessert": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "University students": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.269,
      112.801
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602357",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJkWtia1771y0RYjT_-PmDpqo",
    "name": "𝐅𝐨𝐮𝐫𝐛𝐮𝐧𝐜𝐡 𝐂𝐨𝐟𝐟𝐞𝐞",
    "address": "Jl. Wonorejo Permai No.73, Wonorejo, Kec. Rungkut, Surabaya, Jawa Timur 60297, Indonesia",
    "rating": "4.8",
    "reviewCount": 80,
    "placeId": "ChIJkWtia1771y0RYjT_-PmDpqo",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=%F0%9D%90%85%F0%9D%90%A8%F0%9D%90%AE%F0%9D%90%AB%F0%9D%90%9B%F0%9D%90%AE%F0%9D%90%A7%F0%9D%90%9C%F0%9D%90%A1%20%F0%9D%90%82%F0%9D%90%A8%F0%9D%90%9F%F0%9D%90%9F%F0%9D%90%9E%F0%9D%90%9E&query_place_id=ChIJkWtia1771y0RYjT_-PmDpqo",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 831-2242-4319",
    "website": "https://instagram.com/fourbunch.co?utm_medium=copy_link",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "3 to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "3 to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "Wonorejo, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrJ99GXeFXaIBuAgzmfRyqxUoNI_kAKpyFNfqlb6O6JSK5386JUOwrCzzDtrGeuNCHHN8jvmUXzbmpe-P6Wb-DPnGO-jfID5r1FoxbJW9PcMAEiKYQxVT2wBBK1ICh1Fa3Rj2MQ=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602600",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJw9mKF9791y0RYvA9Sgj1qSU",
    "name": "Eskopi Indonesia - Grand Harvest",
    "address": "Grand Harvest, Taman Harvestory No.H-01, Balas Klumprik, Kec. Wiyung, Surabaya, Jawa Timur 60222, Indonesia",
    "rating": "3.8",
    "reviewCount": 83,
    "placeId": "ChIJw9mKF9791y0RYvA9Sgj1qSU",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Eskopi%20Indonesia%20-%20Grand%20Harvest&query_place_id=ChIJw9mKF9791y0RYvA9Sgj1qSU",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "8 AM to 10 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "8 AM to 10 PM"
        }
      }
    ],
    "neighborhood": "Balas Klumprik, Wiyung",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipNEcDx5p8xsK1CqD_L3dTkF-PvZSPmLhP-FTlQD=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.31,
      112.665
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602633",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJrZ6sM9v41y0RCkcc2lRi2Cw",
    "name": "Warung Amurang 16",
    "address": "Jl. Tlk. Amurang No.16, Perak Utara, Kec. Pabean Cantikan, Surabaya, Jawa Timur 60165, Indonesia",
    "rating": "4.4",
    "reviewCount": 184,
    "placeId": "ChIJrZ6sM9v41y0RCkcc2lRi2Cw",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Warung%20Amurang%2016&query_place_id=ChIJrZ6sM9v41y0RCkcc2lRi2Cw",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 822-3319-6947",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7 AM to 4 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7 AM to 4 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7 AM to 4 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7 AM to 4 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7 AM to 4 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7 AM to 4 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "Closed"
        }
      }
    ],
    "neighborhood": "North Perak, Pabean Cantikan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nr5j2NsS5mziNU5Va_bxDaO_JfDmctYLLcH_UGZ0KmYgGBd6SRW91lXyZvWMWTbeHwVCw_MPw8vvMVAmsy2lDTVSFwtYxFvFLFyVmnMxSFwOmCL5q1CdvrIkjLNbyXcI3G8W1QQ=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        },
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Lunch": true
        },
        {
          "Seating": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Quiet": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        {
          "Free street parking": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Utara",
    "coordinates": [
      -7.22,
      112.735
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602649",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJaeTz1yn71y0RUlVPgEu2n08",
    "name": "Yoi Kona MERR",
    "address": "Jl. Dr. Ir. H. Soekarno M 20, Rungkut Kidul, Rungkut, Surabaya, East Java 60293, Indonesia",
    "rating": "4.6",
    "reviewCount": 1702,
    "placeId": "ChIJaeTz1yn71y0RUlVPgEu2n08",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Yoi%20Kona%20MERR&query_place_id=ChIJaeTz1yn71y0RUlVPgEu2n08",
    "categories": [
      "Coffee shop"
    ],
    "phone": "+62 819-3732-3700",
    "website": "https://instagram.com/yoikona.id",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "7:30 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "7:30 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "7:30 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "7:30 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "7:30 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "7:30 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7:30 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Rungkut Kidul, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/p/AF1QipPSy3jsZaNvN2eVc4jOKOIGCw1Q1n0XRdVEktAW=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Rooftop seating": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": true
        },
        {
          "Assistive hearing loop": false
        },
        {
          "Wheelchair accessible entrance": false
        },
        {
          "Wheelchair accessible parking lot": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Cash-only": true
        },
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Meal coupons": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602663",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJSc8qTwD71y0RMAKxzVbYBrs",
    "name": "Kedai Kipas 58",
    "address": "Jl. Rungkut Asri Tengah No.38, Rungkut Kidul, Kec. Rungkut, Surabaya, Jawa Timur 60293, Indonesia",
    "rating": "4.5",
    "reviewCount": 300,
    "placeId": "ChIJSc8qTwD71y0RMAKxzVbYBrs",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kedai%20Kipas%2058&query_place_id=ChIJSc8qTwD71y0RMAKxzVbYBrs",
    "categories": [
      "Coffee shop"
    ],
    "phone": null,
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "6 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "6 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "6 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "6 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "6 AM to 11 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "6 AM to 11 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "6 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Rungkut Kidul, Rungkut",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqyfvuqyq2jKk4nNymhdj8wDbDwS4dlJ5zWiz4wM_ALOrRaoqq7IpBN3Ylt55TRdKDpMK7e4yx2qrrtM1dn_TvyN10LBzYklRTfOTXqFU1rJFsx-w7tmUDSgpPoceRbC8p_tmry=w408-h542-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        },
        {
          "Delivery": false
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live music": true
        },
        {
          "Live performances": true
        },
        {
          "Sports": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible entrance": true
        },
        {
          "Wheelchair accessible parking lot": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Late-night food": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        },
        {
          "Wi-Fi": true
        },
        {
          "Free Wi-Fi": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Family-friendly": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "High chairs": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        null
      ],
      "Pets": [
        {
          "Dogs allowed outside": true
        }
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.288,
      112.808
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602677",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJGU958NT71y0Rdh97G6rh1Uc",
    "name": "Avatar Drink & Chill",
    "address": "Jl. Dr. Ir. H. Soekarno, Gn. Anyar, Kec. Gn. Anyar, Surabaya, Jawa Timur 60294, Indonesia",
    "rating": "4.2",
    "reviewCount": 536,
    "placeId": "ChIJGU958NT71y0Rdh97G6rh1Uc",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Avatar%20Drink%20%26%20Chill&query_place_id=ChIJGU958NT71y0Rdh97G6rh1Uc",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 812-3232-8118",
    "website": null,
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "4 PM to 2 AM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "4 PM to 3 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "4 PM to 3 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "4 PM to 2 AM"
        }
      }
    ],
    "neighborhood": "Gunung Anyar",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4np4wdT5nxrJem-S_J7Fn0KgpFZh0wqE3VxPUfLDVCHj_dTCYt9i6TpVXJn_GAdLsvl3VAs39J112xbogxw-VhXO_2Vg8HFJJyI3Wz7HC0JqEn2tnbGkl8RpRwX9RxMD0MorR_bc=w408-h306-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Curbside pickup": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great beer selection": true
        },
        {
          "Great cocktails": true
        },
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Alcohol": true
        },
        {
          "Beer": true
        },
        {
          "Cocktails": true
        },
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Hard liquor": true
        },
        {
          "Late-night food": true
        },
        {
          "Quick bite": true
        },
        {
          "Wine": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Bar onsite": true
        },
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Timur",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602712",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJp2WVbOf91y0RgqG1TdnHesk",
    "name": "Kopi Djagongan",
    "address": "Jl. Raya Wisma Pagesangan No.197, Pagesangan, Kec. Jambangan, Surabaya, Jawa Timur 60233, Indonesia",
    "rating": "4.4",
    "reviewCount": 1071,
    "placeId": "ChIJp2WVbOf91y0RgqG1TdnHesk",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=Kopi%20Djagongan&query_place_id=ChIJp2WVbOf91y0RgqG1TdnHesk",
    "categories": [
      "Art cafe"
    ],
    "phone": "+62 812-2222-7460",
    "website": "https://instagram.com/kopi.djagongan",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "9 AM to 11 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "9 to 11 AM, 1 PM to 12 AM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "9 AM to 12 AM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "7 AM to 11 PM"
        }
      }
    ],
    "neighborhood": "Pagesangan, Jambangan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqrLEFtKuqt4PSeOsNAWKUTkiwjEPZ386C0n5TR1N9vz4EReJ8j5CNuLWJ_XIbzafnP5ujSN06Zy84ZdcpzDBSbTpe1Wh48H1DjH7fNOSznaSfiaRChq5VXxqcpZ7iH1GI_jLAP=w408-h510-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Onsite services": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        },
        {
          "Live performances": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        },
        {
          "Good for working on laptop": true
        }
      ],
      "Accessibility": [
        {
          "Wheelchair accessible seating": false
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Brunch": true
        },
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Restroom": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cozy": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "College students": true
        },
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        },
        {
          "Kids' menu": true
        }
      ],
      "Parking": [
        {
          "Paid parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.32,
      112.722
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602729",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJWV-5baX71y0RYnGFeXF5IdY",
    "name": "ONNO KITCHEN & GELATO",
    "address": "Jl. Gayungsari Barat No.29, RT.012/RW.04, Gayungan, Kec. Gayungan, Surabaya, Jawa Timur 60235, Indonesia",
    "rating": "4.5",
    "reviewCount": 391,
    "placeId": "ChIJWV-5baX71y0RYnGFeXF5IdY",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=ONNO%20KITCHEN%20%26%20GELATO&query_place_id=ChIJWV-5baX71y0RYnGFeXF5IdY",
    "categories": [
      "Cafe"
    ],
    "phone": "+62 896-9518-0323",
    "website": null,
    "openingHours": [],
    "neighborhood": "Gayungan",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nr-BjuHnA14xOpmHaK6BPh1v92bMNLUWZx5i4GVrQG8GzDTbYcTBtLwm51iyliFP2fc-ASmy--t8Eu_damSSeDqby5Qp0nZpcMoIwE3e9FKdaUmjqmj4vCDmiQmryq-9i-L_e1J2w=w426-h240-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "No-contact delivery": true
        },
        {
          "Delivery": true
        },
        {
          "Takeout": true
        },
        {
          "Dine-in": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        }
      ],
      "Dining options": [
        {
          "Breakfast": true
        },
        {
          "Dinner": true
        },
        {
          "Seating": true
        }
      ],
      "Payments": [
        {
          "Debit cards": true
        },
        {
          "Credit cards": true
        }
      ],
      "Parking": [
        {
          "Free parking lot": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "SBY Selatan",
    "coordinates": [
      -7.335,
      112.787
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602747",
    "coordinates_source": "surabaya_area_mapping",
    "coordinates_estimated": true
  },
  {
    "id": "ChIJ74PXuaD1aS4R8ztJgu6BDjA",
    "name": "D'Rumah Kita",
    "address": "Surabaya St No.26, Menteng, Central Jakarta City, Jakarta 10310, Indonesia",
    "rating": "4.7",
    "reviewCount": 236,
    "placeId": "ChIJ74PXuaD1aS4R8ztJgu6BDjA",
    "google_maps_direction": "https://www.google.com/maps/search/?api=1&query=D%27Rumah%20Kita&query_place_id=ChIJ74PXuaD1aS4R8ztJgu6BDjA",
    "categories": [
      "Restaurant"
    ],
    "phone": "+62 877-0288-8857",
    "website": "https://www.instagram.com/drumahkita/",
    "openingHours": [
      {
        "day": "Monday",
        "hours": {
          "day": "Monday",
          "hours": "10:30 AM to 9 PM"
        }
      },
      {
        "day": "Tuesday",
        "hours": {
          "day": "Tuesday",
          "hours": "10:30 AM to 9 PM"
        }
      },
      {
        "day": "Wednesday",
        "hours": {
          "day": "Wednesday",
          "hours": "10:30 AM to 9 PM"
        }
      },
      {
        "day": "Thursday",
        "hours": {
          "day": "Thursday",
          "hours": "10:30 AM to 9 PM"
        }
      },
      {
        "day": "Friday",
        "hours": {
          "day": "Friday",
          "hours": "10:30 AM to 9 PM"
        }
      },
      {
        "day": "Saturday",
        "hours": {
          "day": "Saturday",
          "hours": "10:30 AM to 9 PM"
        }
      },
      {
        "day": "Sunday",
        "hours": {
          "day": "Sunday",
          "hours": "10:30 AM to 9 PM"
        }
      }
    ],
    "neighborhood": "Menteng",
    "city": "Surabaya",
    "description": null,
    "imageUrl": "https://lh3.googleusercontent.com/gps-cs-s/AC9h4nrq2ruA1NELV8VK_woJF6fCXhW8TDJVCRFbTtgqUUNpA2Nkbun0uySQqi8Z51RZQJiDYnywxLwu9IB4t3lbjDM0SaFpMFgFWIzMbByZZYplEQsVTzP-D6IyspMKJ5Scgsn6xoI0=w408-h544-k-no",
    "additionalInfo": {
      "Service options": [
        {
          "Outdoor seating": true
        },
        {
          "Takeaway": true
        },
        {
          "Dine-in": true
        }
      ],
      "Highlights": [
        {
          "Great coffee": true
        },
        {
          "Great dessert": true
        },
        {
          "Great tea selection": true
        }
      ],
      "Popular for": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Solo dining": true
        }
      ],
      "Offerings": [
        {
          "Coffee": true
        },
        {
          "Halal food": true
        },
        {
          "Quick bite": true
        }
      ],
      "Dining options": [
        {
          "Lunch": true
        },
        {
          "Dinner": true
        },
        {
          "Counter service": true
        },
        {
          "Dessert": true
        },
        {
          "Seating": true
        }
      ],
      "Amenities": [
        {
          "Toilet": true
        }
      ],
      "Atmosphere": [
        {
          "Casual": true
        },
        {
          "Cosy": true
        },
        {
          "Quiet": true
        },
        {
          "Trendy": true
        }
      ],
      "Crowd": [
        {
          "Groups": true
        },
        {
          "Tourists": true
        }
      ],
      "Planning": [
        {
          "Accepts reservations": true
        }
      ],
      "Payments": [
        {
          "Credit cards": true
        },
        {
          "Debit cards": true
        },
        {
          "NFC mobile payments": true
        },
        {
          "Credit cards": true
        }
      ],
      "Children": [
        {
          "Good for kids": true
        }
      ],
      "Parking": [
        {
          "Free of charge street parking": true
        },
        {
          "Free parking lot": true
        },
        {
          "Paid street parking": true
        },
        null
      ]
    },
    "permanentlyClosed": false,
    "lastUpdated": "2025-06-07T03:29:09.653Z",
    "dataSource": "apify_fresh",
    "region": "Unknown",
    "coordinates": [
      -7.2575,
      112.7521
    ],
    "coordinatesSource": "region_estimate",
    "coordinatesAccuracy": "low",
    "coordinates_corrected": true,
    "coordinates_updated": "2025-06-07T18:06:22.602809",
    "coordinates_source": "surabaya_center_fallback",
    "coordinates_estimated": true
  }
];

export const fetchCleanedCafesData = async (limit) => {
  const cleaned = activeCafes(cleanedCafesData);
  return limit ? cleaned.slice(0, limit) : cleaned;
};

export const fetchCafeById = async (id) => {
  return activeCafes(cleanedCafesData).find(cafe => cafe.id === id || cafe.placeId === id);
};

export const fetchAllCafesData = async () => activeCafes(cleanedCafesData);
